var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/pages/shipments-list/shipments-list-page.tsx
import React32, { useEffect as useEffect4, useState as useState6 } from "react";
import { PageContent, PageLayout } from "@ontruck/fe-ui";
import { Toaster } from "sonner";
import { createPortal } from "react-dom";

// src/business/smart-views/smart-views-data-hook.tsx
import useSWR from "swr";

// src/config/config-hook.ts
import { useContext } from "react";

// src/config/config-context.ts
import { createContext } from "react";
var config = {
  token: "",
  apiBase: "",
  userDelegations: []
};
var ConfigContext = createContext(config);

// src/config/config-hook.ts
function useConfigHook() {
  return useContext(ConfigContext);
}

// src/business/smart-views/smart-view-mapper.ts
function smartViewMapper(smartViewDto) {
  var _a;
  try {
    const smartViewBasicData = {
      id: (_a = smartViewDto.id) != null ? _a : "-1",
      name: smartViewDto.name
    };
    const smartViewContent = JSON.parse(smartViewDto.filters);
    return __spreadValues(__spreadValues({}, smartViewBasicData), smartViewContent);
  } catch (error) {
    return null;
  }
}

// src/business/smart-views/get-smart-views-mapper.ts
function getSmartViewsMapper(smartViewDtos) {
  return smartViewDtos.map((smartViewDto) => {
    try {
      return smartViewMapper(smartViewDto);
    } catch (e) {
      return null;
    }
  }).filter((view) => view !== null);
}

// src/business/smart-views/get-smart-views-api.ts
function getSmartViewsApi(_0) {
  return __async(this, arguments, function* ({ token, apiBase }) {
    const baseURL = `${apiBase}/v1/price-negotiation/filter-views/`;
    const url = baseURL;
    const response = yield fetch(url, {
      method: "GET",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!response.ok) {
      throw new Error("Failed to fetch smart views");
    }
    return yield response.json();
  });
}

// src/business/shipments/shipment-states-service.ts
var SHIPMENT_STATES = {
  incident: "incident",
  outForDelivery: "out-for-delivery",
  partialDelivery: "partial-delivery",
  delivered: "delivered",
  cancelled: "cancelled",
  destroyed: "destroyed",
  created: "created",
  pendingNewDelivery: "pending-new-delivery",
  atWarehouse: "at-warehouse",
  inTransfer: "in-transfer"
};
var shipmentStatesColors = {
  [SHIPMENT_STATES.incident]: "var(--01, #D31B4C)",
  [SHIPMENT_STATES.outForDelivery]: "var(--color_02, #0F4CDB)",
  [SHIPMENT_STATES.partialDelivery]: "var(--color_04, #8E5CE5)",
  [SHIPMENT_STATES.delivered]: "var(--color_03, #05B669)",
  [SHIPMENT_STATES.cancelled]: "var(--01, #D31B4C)",
  [SHIPMENT_STATES.destroyed]: "var(--grey-500, #94A6B8)",
  [SHIPMENT_STATES.created]: "var(--grey-500, #94A6B8)",
  [SHIPMENT_STATES.pendingNewDelivery]: "var(--color_02, #57B1E5)",
  [SHIPMENT_STATES.atWarehouse]: "var(--color_04, #1FE4D6)",
  [SHIPMENT_STATES.inTransfer]: "var(--color_02, #0F4CDB)",
  default: "var(--grey-500, #94A6B8)"
};
var getShipmentStateColor = (state) => {
  if (state in shipmentStatesColors) {
    return shipmentStatesColors[state];
  }
  return shipmentStatesColors.default;
};
var shipmentStatesTexts = {
  [SHIPMENT_STATES.incident]: "Incidente",
  [SHIPMENT_STATES.outForDelivery]: "En reparto",
  [SHIPMENT_STATES.partialDelivery]: "Reparto parcial",
  [SHIPMENT_STATES.delivered]: "Entregado",
  [SHIPMENT_STATES.cancelled]: "Cancelado",
  [SHIPMENT_STATES.destroyed]: "Destruido",
  [SHIPMENT_STATES.created]: "Documentado",
  [SHIPMENT_STATES.pendingNewDelivery]: "Pendiente de nuevo reparto",
  [SHIPMENT_STATES.atWarehouse]: "Llegada a destino",
  [SHIPMENT_STATES.inTransfer]: "En tr\xE1nsito"
};
var getShipmentStateText = (state) => {
  if (state in shipmentStatesTexts) {
    return shipmentStatesTexts[state];
  }
  return state;
};
var ShipmentsStateService = {
  getShipmentStateColor,
  getShipmentStateText,
  SHIPMENT_STATES
};

// src/business/shipments/shipment-services-service.ts
var SHIPMENT_SERVICES = {
  NEXT_DAY: "NEXT_DAY",
  FORTY_EIGHT_HOURS: "FORTY_EIGHT_HOURS"
};
var shipmentServicesTexts = {
  [SHIPMENT_SERVICES.NEXT_DAY]: "XS24",
  [SHIPMENT_SERVICES.FORTY_EIGHT_HOURS]: "XS48"
};
var getShipmentServiceText = (service) => {
  if (service in shipmentServicesTexts) {
    return shipmentServicesTexts[service];
  }
  return service;
};
var ShipmentsServicesService = {
  getShipmentServiceText,
  SHIPMENT_SERVICES
};

// src/business/smart-views/smart-views-service.ts
var COLUMNS_ALWAYS_VISIBLE = {
  state: "state",
  lastUpdate: "lastUpdate",
  externalId: "externalId"
};
var AVAILABLE_COLUMNS_TO_HIDE = {
  createdAt: "createdAt",
  receptionDatetime: "receptionDatetime",
  externalReference: "externalReference",
  senderAddress: "senderAddress",
  deliveryAddress: "deliveryAddress",
  deliveryDetails: "deliveryDetails",
  billingDelegation: "billingDelegation",
  originDelegation: "originDelegation",
  destinationDelegation: "destinationDelegation",
  service: "service",
  weight: "weight",
  centreObjectiveDatetime: "centreObjectiveDatetime",
  networkObjectiveDatetime: "networkObjectiveDatetime",
  shipper: "shipper",
  driver: "driver",
  lastReceivedEvent: "lastReceivedEvent"
};
var columnsTexts = {
  [COLUMNS_ALWAYS_VISIBLE.state]: "ESTADO",
  [COLUMNS_ALWAYS_VISIBLE.lastUpdate]: "\xDALTIMA ACTUALIZACI\xD3N",
  [COLUMNS_ALWAYS_VISIBLE.externalId]: "ENV\xCDO",
  [AVAILABLE_COLUMNS_TO_HIDE.createdAt]: "F DOCUMENTADO",
  [AVAILABLE_COLUMNS_TO_HIDE.receptionDatetime]: "F TR\xC1NSITO",
  [AVAILABLE_COLUMNS_TO_HIDE.externalReference]: "REF. EXTERNA",
  [AVAILABLE_COLUMNS_TO_HIDE.senderAddress]: "REMITENTE",
  [AVAILABLE_COLUMNS_TO_HIDE.deliveryAddress]: "DESTINATARIO",
  [AVAILABLE_COLUMNS_TO_HIDE.deliveryDetails]: "DETALLES DE ENTREGA",
  [AVAILABLE_COLUMNS_TO_HIDE.billingDelegation]: "CS. CARGO",
  [AVAILABLE_COLUMNS_TO_HIDE.originDelegation]: "CS. ORIGEN",
  [AVAILABLE_COLUMNS_TO_HIDE.destinationDelegation]: "CS. DESTINO",
  [AVAILABLE_COLUMNS_TO_HIDE.service]: "TIPO DE SERVICIO",
  [AVAILABLE_COLUMNS_TO_HIDE.weight]: "PESO",
  [AVAILABLE_COLUMNS_TO_HIDE.centreObjectiveDatetime]: "F. OBJETIVO CENTRO",
  [AVAILABLE_COLUMNS_TO_HIDE.networkObjectiveDatetime]: "F. OBJETIVO RED",
  [AVAILABLE_COLUMNS_TO_HIDE.shipper]: "CLIENTE",
  [AVAILABLE_COLUMNS_TO_HIDE.driver]: "CONDUCTOR",
  [AVAILABLE_COLUMNS_TO_HIDE.lastReceivedEvent]: "\xDALTIMA LECTURA"
};
var getColumnText = (column) => {
  if (column in columnsTexts) {
    return columnsTexts[column];
  }
  return column;
};
var ALWAYS_VISIBLE_FILTERS = {
  search: "search"
};
var AVAILABLE_FILTERS_TO_HIDE = {
  state: "state",
  date: "date",
  service: "service",
  destinationZipCode: "destinationZipCode",
  shipper: "shipper",
  driver: "driver",
  lastReceptionInDelegation: "lastReceptionInDelegation",
  csCargos: "csCargos",
  csOrigins: "csOrigins",
  csDestinations: "csDestinations"
};
var filtersTexts = {
  [ALWAYS_VISIBLE_FILTERS.search]: "B\xFAsqueda",
  [AVAILABLE_FILTERS_TO_HIDE.state]: "Estado",
  [AVAILABLE_FILTERS_TO_HIDE.date]: "Fecha",
  [AVAILABLE_FILTERS_TO_HIDE.service]: "Servicio",
  [AVAILABLE_FILTERS_TO_HIDE.destinationZipCode]: "CP de entrega",
  [AVAILABLE_FILTERS_TO_HIDE.shipper]: "Cliente",
  [AVAILABLE_FILTERS_TO_HIDE.driver]: "Conductor",
  [AVAILABLE_FILTERS_TO_HIDE.lastReceptionInDelegation]: "\xDAltima lectura en mi delegaci\xF3n",
  [AVAILABLE_FILTERS_TO_HIDE.csCargos]: "CS. Cargo",
  [AVAILABLE_FILTERS_TO_HIDE.csOrigins]: "CS. Origen",
  [AVAILABLE_FILTERS_TO_HIDE.csDestinations]: "CS. Destino"
};
var getFilterText = (filter) => {
  if (filter in filtersTexts) {
    return filtersTexts[filter];
  }
  return filter;
};
var AVAILABLE_FILTERS_TO_APPLY = {
  state: "state",
  service: "service",
  destinationZipCode: "destinationZipCode",
  shipper: "shipper",
  driver: "driver",
  search: "search",
  lastReceptionInDelegation: "lastReceptionInDelegation"
};
var filtersToApplyTexts = {
  [AVAILABLE_FILTERS_TO_APPLY.state]: "Estado",
  [AVAILABLE_FILTERS_TO_APPLY.service]: "Servicio",
  [AVAILABLE_FILTERS_TO_APPLY.destinationZipCode]: "CP de entrega",
  [AVAILABLE_FILTERS_TO_APPLY.shipper]: "Cliente",
  [AVAILABLE_FILTERS_TO_APPLY.driver]: "Conductor",
  [AVAILABLE_FILTERS_TO_APPLY.search]: "B\xFAsqueda",
  [AVAILABLE_FILTERS_TO_APPLY.lastReceptionInDelegation]: "\xDAltima lectura en mi delegaci\xF3n"
};
var getSmartViewFilterValueText = (filterValue) => {
  const { filter, value, displayValue } = filterValue;
  let filterText = filter;
  if (filter in filtersToApplyTexts) {
    filterText = filtersToApplyTexts[filter];
  }
  let valueToDisplay = value;
  if (filter === AVAILABLE_FILTERS_TO_APPLY.state) {
    valueToDisplay = ShipmentsStateService.getShipmentStateText(value);
  }
  if (filter === AVAILABLE_FILTERS_TO_APPLY.service) {
    valueToDisplay = ShipmentsServicesService.getShipmentServiceText(value);
  }
  if ((filter === AVAILABLE_FILTERS_TO_APPLY.driver || filter === AVAILABLE_FILTERS_TO_APPLY.shipper) && displayValue) {
    valueToDisplay = displayValue;
  }
  if (filter === AVAILABLE_FILTERS_TO_APPLY.lastReceptionInDelegation) {
    valueToDisplay = "Activado";
  }
  return {
    filterText,
    valueToDisplay
  };
};
var SmartViewsService = {
  getColumnText,
  getFilterText,
  getSmartViewFilterValueText
};

// src/business/smart-views/default-smart-views.ts
var DEFAULT_SMART_VIEWS = [
  // {
  //   id: '-3',
  //   name: 'Debug - Hide everything',
  //   type: 'shipments',
  //   hiddenColumns: Object.values(AVAILABLE_COLUMNS_TO_HIDE),
  //   hiddenFilters: Object.values(AVAILABLE_FILTERS_TO_HIDE),
  //   filterValues: [],
  // },
  {
    id: "-1",
    name: "Mi almacen",
    type: "shipments",
    hiddenColumns: [],
    hiddenFilters: [],
    filterValues: [
      { filter: AVAILABLE_FILTERS_TO_APPLY.state, value: SHIPMENT_STATES.outForDelivery },
      { filter: AVAILABLE_FILTERS_TO_APPLY.state, value: SHIPMENT_STATES.inTransfer },
      { filter: AVAILABLE_FILTERS_TO_APPLY.state, value: SHIPMENT_STATES.incident },
      { filter: AVAILABLE_FILTERS_TO_APPLY.state, value: SHIPMENT_STATES.pendingNewDelivery },
      { filter: AVAILABLE_FILTERS_TO_APPLY.lastReceptionInDelegation, value: "true" }
    ]
  }
];

// src/business/smart-views/smart-views-data-hook.tsx
var RELOAD_SMART_VIEWS_INTERVAL_IN_SECONDS = 1800;
var useSmartViewsDataHook = (type) => {
  const config2 = useConfigHook();
  const key = `last-mile/smart-views/${type}`;
  const fetcher = () => __async(void 0, null, function* () {
    return getSmartViewsApi(config2);
  });
  const { data } = useSWR(key, fetcher, {
    refreshInterval: RELOAD_SMART_VIEWS_INTERVAL_IN_SECONDS * 1e3,
    revalidateIfStale: true
  });
  if (data == null ? void 0 : data.results) {
    const smartViews = getSmartViewsMapper(data.results);
    const smartViewsFilteredByType = smartViews.filter((smartView) => smartView.type === type);
    const smartViewsFilteredByTypeAndDefault = [
      ...smartViewsFilteredByType,
      ...DEFAULT_SMART_VIEWS
    ];
    return smartViewsFilteredByTypeAndDefault;
  }
  return DEFAULT_SMART_VIEWS;
};

// src/components/my-delegation/my-delegation-hook.tsx
import { createStore } from "zustand";
import { useZustand } from "use-zustand";
var myDelegationStore = createStore((set) => ({
  selectedDelegationId: "",
  setSelectedDelegationId: (delegationId) => {
    set({ selectedDelegationId: delegationId });
  }
}));
var useMyDelegationHook = () => {
  const selectedDelegationId = useZustand(myDelegationStore, (state) => state.selectedDelegationId);
  const setSelectedDelegationId = useZustand(
    myDelegationStore,
    (state) => state.setSelectedDelegationId
  );
  return {
    selectedDelegationId,
    setSelectedDelegationId
  };
};

// src/components/my-delegation/constants.ts
var TOP_BAR_MODULE_MY_DELEGATION_ID = "top-bar-module-my-delegation";

// src/components/my-delegation/my-delegation-component.tsx
import React from "react";
import { FlexComponent, Input } from "@ontruck/fe-ui";
function MyDelegationComponent() {
  const { selectedDelegationId, setSelectedDelegationId } = useMyDelegationHook();
  const { userDelegations } = useConfigHook();
  const userAvailableDelegationOptions = userDelegations.map((userDelegation) => {
    return {
      value: userDelegation.id.toString(),
      label: userDelegation.name
    };
  });
  const allDelegationsOption = {
    value: "",
    label: "Todas"
  };
  const userDelegationOptions = [allDelegationsOption, ...userAvailableDelegationOptions];
  return /* @__PURE__ */ React.createElement(FlexComponent, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      handleChangeValue: (name, value) => {
        if (value !== void 0)
          setSelectedDelegationId(value);
      },
      label: "Mi delegaci\xF3n",
      name: "user-delegation-id",
      options: userDelegationOptions,
      type: "select",
      value: selectedDelegationId,
      width: "200px"
    }
  ));
}

// src/pages/shipments-list/shipments-list-selection-hook.tsx
import { createStore as createStore2 } from "zustand";
import { useZustand as useZustand2 } from "use-zustand";
var shipmentsListSelectionStore = createStore2((set) => ({
  selectedShipments: [],
  selectShipment: (shipment) => {
    set((state) => ({ selectedShipments: [...state.selectedShipments, shipment] }));
  },
  unSelectShipment: (shipment) => {
    set((state) => ({
      selectedShipments: state.selectedShipments.filter((s) => s.id !== shipment.id)
    }));
  },
  selectAllShipments: (shipments) => {
    set(() => ({ selectedShipments: shipments }));
  },
  unSelectAllShipments: () => {
    set({ selectedShipments: [] });
  }
}));
var useShipmentsListSelectionHook = () => {
  const selectedShipments = useZustand2(
    shipmentsListSelectionStore,
    (state) => state.selectedShipments
  );
  const selectShipment = useZustand2(shipmentsListSelectionStore, (state) => state.selectShipment);
  const unSelectShipment = useZustand2(
    shipmentsListSelectionStore,
    (state) => state.unSelectShipment
  );
  const selectAllShipments = useZustand2(
    shipmentsListSelectionStore,
    (state) => state.selectAllShipments
  );
  const unSelectAllShipments = useZustand2(
    shipmentsListSelectionStore,
    (state) => state.unSelectAllShipments
  );
  return {
    selectedShipments,
    selectShipment,
    unSelectShipment,
    selectAllShipments,
    unSelectAllShipments
  };
};

// src/pages/shipments-list/shipments-list-filters-hook.tsx
import { createStore as createStore3 } from "zustand";
import { useZustand as useZustand3 } from "use-zustand";

// src/pages/shipments-list/shipment-filters/shipment-filters-options.ts
var SHIPMENT_FILTERS_PAGINATION_SIZES = [20, 50, 100, 200];
var getShipmentFiltersOptions = () => {
  const statesToFilter = [
    ShipmentsStateService.SHIPMENT_STATES.destroyed,
    ShipmentsStateService.SHIPMENT_STATES.partialDelivery
  ];
  return {
    states: [...Object.values(ShipmentsStateService.SHIPMENT_STATES)].filter(
      (state) => !statesToFilter.includes(state)
    ),
    paginationSizes: SHIPMENT_FILTERS_PAGINATION_SIZES,
    services: ["", ...Object.values(ShipmentsServicesService.SHIPMENT_SERVICES)],
    smartViews: [],
    csCargos: [],
    csOrigins: [],
    csDestinations: []
  };
};

// src/pages/shipments-list/shipment-filters/shipment-filters-default-values.ts
var DEFAULT_SHIPMENT_SMART_VIEW = {
  id: "",
  name: "General",
  type: "shipment",
  hiddenColumns: [],
  hiddenFilters: [],
  filterValues: []
};
var SHIPMENT_FILTERS_DEFAULT_VALUES = {
  destinationZipCode: "",
  driverId: "",
  shipperId: "",
  page: 1,
  pageSize: SHIPMENT_FILTERS_PAGINATION_SIZES[0],
  search: "",
  service: "",
  state: [],
  focDateFrom: "",
  focDateTo: "",
  forDateFrom: "",
  forDateTo: "",
  createdAtDateFrom: "",
  createdAtDateTo: "",
  receptionDateFrom: "",
  receptionDateTo: "",
  lastReceptionInDelegation: false,
  csCargos: [],
  csOrigins: [],
  csDestinations: [],
  shipmentSmartView: DEFAULT_SHIPMENT_SMART_VIEW
};

// src/pages/shipments-list/shipments-list-filters-hook.tsx
var getInitialShipmentFilters = () => {
  const defaultShipmentFilters = SHIPMENT_FILTERS_DEFAULT_VALUES;
  const initialShipmentFilters = __spreadValues({}, defaultShipmentFilters);
  return initialShipmentFilters;
};
var getShipmentFiltersFromSmartView = (shipmentSmartView) => {
  var _a, _b, _c, _d, _e, _f;
  const newShipmentFilters = getInitialShipmentFilters();
  newShipmentFilters.shipmentSmartView = shipmentSmartView;
  const filtersToApply = shipmentSmartView.filterValues.map((filterValue) => {
    return {
      filter: filterValue.filter,
      value: filterValue.value
    };
  });
  const newStateFilterValues = filtersToApply.filter((filterValue) => {
    return filterValue.filter === "state";
  }).map((filterValue) => {
    return filterValue.value;
  });
  newShipmentFilters.state = newStateFilterValues;
  const newServiceFilterValue = (_a = filtersToApply.find((filterValue) => {
    return filterValue.filter === "service";
  })) == null ? void 0 : _a.value;
  if (newServiceFilterValue) {
    newShipmentFilters.service = newServiceFilterValue;
  }
  const newDestinationZipCodeFilterValue = (_b = filtersToApply.find((filterValue) => {
    return filterValue.filter === "destinationZipCode";
  })) == null ? void 0 : _b.value;
  if (newDestinationZipCodeFilterValue) {
    newShipmentFilters.destinationZipCode = newDestinationZipCodeFilterValue;
  }
  const newShipperFilterValue = (_c = filtersToApply.find((filterValue) => {
    return filterValue.filter === "shipper";
  })) == null ? void 0 : _c.value;
  if (newShipperFilterValue) {
    newShipmentFilters.shipperId = newShipperFilterValue;
  }
  const newDriverFilterValue = (_d = filtersToApply.find((filterValue) => {
    return filterValue.filter === "driver";
  })) == null ? void 0 : _d.value;
  if (newDriverFilterValue) {
    newShipmentFilters.driverId = newDriverFilterValue;
  }
  const newSearchFilterValue = (_e = filtersToApply.find((filterValue) => {
    return filterValue.filter === "search";
  })) == null ? void 0 : _e.value;
  if (newSearchFilterValue) {
    newShipmentFilters.search = newSearchFilterValue;
  }
  const newLastReceptionInDelegationFilterValue = (_f = filtersToApply.find((filterValue) => {
    return filterValue.filter === "lastReceptionInDelegation";
  })) == null ? void 0 : _f.value;
  if (newLastReceptionInDelegationFilterValue) {
    newShipmentFilters.lastReceptionInDelegation = newLastReceptionInDelegationFilterValue === "true";
  }
  return newShipmentFilters;
};
var shipmentsListFiltersStore = createStore3((set) => ({
  shipmentFilters: getInitialShipmentFilters(),
  shipmentFiltersOptions: getShipmentFiltersOptions(),
  shipmentsSmartViews: [],
  setShipmentsSmartViews: (shipmentsSmartViews) => {
    set((state) => __spreadProps(__spreadValues({}, state), { shipmentsSmartViews }));
  },
  handleChangeShipmentSmartView: (shipmentSmartView) => {
    set((state) => {
      return __spreadProps(__spreadValues({}, state), {
        shipmentFilters: getShipmentFiltersFromSmartView(shipmentSmartView)
      });
    });
  },
  handleChangePageSize: (pageSize) => {
    set((state) => __spreadProps(__spreadValues({}, state), { shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { pageSize }) }));
  },
  handleGoToPreviousPage: () => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { page: state.shipmentFilters.page - 1 })
    }));
  },
  handleGoToPage: (pageIndex) => {
    set((state) => __spreadProps(__spreadValues({}, state), { shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { page: pageIndex }) }));
  },
  handleGoToNextPage: () => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { page: state.shipmentFilters.page + 1 })
    }));
  },
  handleChangeState: (newStates) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { state: newStates, page: 1 })
    }));
  },
  handleChangeService: (newService) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { service: newService, page: 1 })
    }));
  },
  handleChangeSearch: (newSearch) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { search: newSearch, page: 1 })
    }));
  },
  handleChangeDestinationZipCode: (newDestinationZipCode) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), {
        destinationZipCode: newDestinationZipCode,
        page: 1
      })
    }));
  },
  handleChangeFocDateFrom: (newDateFrom) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { focDateFrom: newDateFrom, page: 1 })
    }));
  },
  handleChangeFocDateTo: (newDateTo) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { focDateTo: newDateTo, page: 1 })
    }));
  },
  handleChangeForDateFrom: (newDateFrom) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { forDateFrom: newDateFrom, page: 1 })
    }));
  },
  handleChangeForDateTo: (newDateTo) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { forDateTo: newDateTo, page: 1 })
    }));
  },
  handleChangeCreatedAtDateFrom: (newDateFrom) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { createdAtDateFrom: newDateFrom, page: 1 })
    }));
  },
  handleChangeCreatedAtDateTo: (newDateTo) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { createdAtDateTo: newDateTo, page: 1 })
    }));
  },
  handleChangeReceptionDateFrom: (newDateFrom) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { receptionDateFrom: newDateFrom, page: 1 })
    }));
  },
  handleChangeReceptionDateTo: (newDateTo) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { receptionDateTo: newDateTo, page: 1 })
    }));
  },
  handleChangeDriverId: (newDriverId) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { driverId: newDriverId, page: 1 })
    }));
  },
  handleChangeShipperId: (newShipperId) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { shipperId: newShipperId, page: 1 })
    }));
  },
  handleChangeLastReceptionInDelegation: (newLastReceptionInDelegation) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), {
        lastReceptionInDelegation: newLastReceptionInDelegation,
        page: 1
      })
    }));
  },
  handleChangeCsCargo: (newCsCargo) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { csCargos: newCsCargo, page: 1 })
    }));
  },
  handleChangeCsOrigin: (newCsOrigin) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { csOrigins: newCsOrigin, page: 1 })
    }));
  },
  handleChangeCsDestination: (newCsDestination) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      shipmentFilters: __spreadProps(__spreadValues({}, state.shipmentFilters), { csDestinations: newCsDestination, page: 1 })
    }));
  }
}));
var useShipmentsListFiltersHook = () => {
  const shipmentFilters = useZustand3(shipmentsListFiltersStore, (state) => state.shipmentFilters);
  const shipmentFiltersOptions = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.shipmentFiltersOptions
  );
  const shipmentsSmartViews = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.shipmentsSmartViews
  );
  const setShipmentsSmartViews = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.setShipmentsSmartViews
  );
  const handleChangeShipmentSmartView = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeShipmentSmartView
  );
  const handleChangePageSize = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangePageSize
  );
  const handleGoToPreviousPage = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleGoToPreviousPage
  );
  const handleGoToPage = useZustand3(shipmentsListFiltersStore, (state) => state.handleGoToPage);
  const handleGoToNextPage = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleGoToNextPage
  );
  const handleChangeState = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeState
  );
  const handleChangeService = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeService
  );
  const handleChangeSearch = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeSearch
  );
  const handleChangeDestinationZipCode = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeDestinationZipCode
  );
  const handleChangeFocDateFrom = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeFocDateFrom
  );
  const handleChangeFocDateTo = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeFocDateTo
  );
  const handleChangeForDateFrom = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeForDateFrom
  );
  const handleChangeForDateTo = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeForDateTo
  );
  const handleChangeCreatedAtDateFrom = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeCreatedAtDateFrom
  );
  const handleChangeCreatedAtDateTo = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeCreatedAtDateTo
  );
  const handleChangeReceptionDateFrom = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeReceptionDateFrom
  );
  const handleChangeReceptionDateTo = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeReceptionDateTo
  );
  const handleChangeDriverId = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeDriverId
  );
  const handleChangeShipperId = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeShipperId
  );
  const handleChangeLastReceptionInDelegation = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeLastReceptionInDelegation
  );
  const handleChangeCsCargo = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeCsCargo
  );
  const handleChangeCsDestination = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeCsDestination
  );
  const handleChangeCsOrigin = useZustand3(
    shipmentsListFiltersStore,
    (state) => state.handleChangeCsOrigin
  );
  return {
    handleChangeCreatedAtDateFrom,
    handleChangeCreatedAtDateTo,
    handleChangeCsCargo,
    handleChangeCsDestination,
    handleChangeCsOrigin,
    handleChangeDestinationZipCode,
    handleChangeDriverId,
    handleChangeFocDateFrom,
    handleChangeFocDateTo,
    handleChangeForDateFrom,
    handleChangeForDateTo,
    handleChangeLastReceptionInDelegation,
    handleChangePageSize,
    handleChangeReceptionDateFrom,
    handleChangeReceptionDateTo,
    handleChangeSearch,
    handleChangeService,
    handleChangeShipmentSmartView,
    handleChangeShipperId,
    handleChangeState,
    handleGoToNextPage,
    handleGoToPage,
    handleGoToPreviousPage,
    setShipmentsSmartViews,
    shipmentFilters,
    shipmentFiltersOptions,
    shipmentsSmartViews
  };
};

// src/pages/shipments-list/shipments-list-toolbar-component.tsx
import React7 from "react";

// src/components/toolbar/custom-toolbar-component.tsx
import { ToolbarComponent } from "@ontruck/fe-ui";
import styled from "styled-components";
var CustomToolbarComponent = styled(
  ToolbarComponent
)`
  padding: 0;
  height: auto;
`;

// src/components/toolbar/custom-toolbar-content-component.tsx
import { ToolbarContentComponent } from "@ontruck/fe-ui";
import styled2 from "styled-components";
var CustomToolbarContentComponent = styled2(ToolbarContentComponent)`
  align-items: stretch;
`;

// src/pages/shipments-list/shipment-filters/shipment-filters-component.tsx
import React6, { useState as useState2 } from "react";
import {
  FlexComponent as FlexComponent5,
  Input as Input4,
  ToolbarButtonComponent,
  MultiSelectInputComponent,
  TextComponent
} from "@ontruck/fe-ui";
import styled6 from "styled-components";
import { IconComponent, iconNames } from "@ontruck/fe-icons";

// src/components/driver-input/driver-input-component.tsx
import React2 from "react";
import { Input as Input2 } from "@ontruck/fe-ui";

// src/business/drivers/assign-driver-to-cargos-hook.ts
import { useCallback, useMemo, useState } from "react";
import { toast } from "sonner";
import { mutate } from "swr";

// src/pages/shipments-list/components/assign-driver-to-cargos/can-cargo-be-assigned-to-driver.ts
function canCargoBeAssignedToDriver(cargo) {
  const pendingAssignment = cargo.pendingAssignment;
  return pendingAssignment;
}

// src/business/drivers/assign-driver-to-cargos-api.ts
function assignDriverToCargosApi(_0) {
  return __async(this, arguments, function* ({
    cargos,
    driverId,
    config: config2
  }) {
    const endpoint = `${config2.apiBase}/v1/fleet/routes/assign_next/`;
    const body = {
      cargo_ids: cargos.map((cargo) => cargo.id),
      driver_id: driverId
    };
    return fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config2.token}`
      },
      body: JSON.stringify(body)
    });
  });
}

// src/business/drivers/assign-driver-to-cargos-hook.ts
function useAssignDriverToCargosHook({
  shipments,
  onSuccess,
  onCancel,
  config: config2
}) {
  const [loading, setLoading] = useState(false);
  const [selectedDriverId, setSelectedDriverId] = useState(void 0);
  const cargosThatCanBeAssigned = useMemo(() => {
    return shipments.flatMap((shipment) => shipment.cargos).filter((cargo) => canCargoBeAssignedToDriver(cargo));
  }, [shipments]);
  const cargosThatCannotBeAssigned = useMemo(() => {
    return shipments.flatMap((shipment) => shipment.cargos).filter((cargo) => !canCargoBeAssignedToDriver(cargo));
  }, [shipments]);
  const canSubmit = selectedDriverId !== void 0 && !loading;
  const headerText = `Asignar conductor a ${cargosThatCanBeAssigned.length} bultos`;
  const onGoback = useCallback(() => {
    if (loading) {
      return;
    }
    if (onCancel) {
      onCancel();
    }
  }, [onCancel, loading]);
  const onConfirm = useCallback(() => __async(this, null, function* () {
    const successMessage = "Asignaci\xF3n realizada con \xE9xito";
    const errorMessage = "Error al asignar";
    if (selectedDriverId === void 0) {
      return;
    }
    setLoading(true);
    try {
      const response = yield assignDriverToCargosApi({
        cargos: cargosThatCanBeAssigned,
        driverId: selectedDriverId,
        config: config2
      });
      if (!response.ok)
        throw new Error(`Bad response assigning driver ${selectedDriverId} to cargos`);
      setLoading(false);
      toast.success(successMessage);
      if (onSuccess) {
        onSuccess();
      }
      void mutate((key) => {
        return typeof key === "string" && key.startsWith("last-mile");
      });
    } catch (error) {
      toast.error(errorMessage);
      setLoading(false);
    }
  }), [cargosThatCanBeAssigned, config2, onSuccess, selectedDriverId]);
  const selectDriver = (id) => {
    if (id === selectedDriverId) {
      return;
    }
    setSelectedDriverId(id);
  };
  const hookResult = {
    loading,
    selectedDriverId,
    selectDriver,
    canSubmit,
    onGoback,
    onConfirm,
    headerText,
    cargosThatCanBeAssigned,
    cargosThatCannotBeAssigned
  };
  return hookResult;
}

// src/business/drivers/get-drivers-hook.ts
import useSWR2 from "swr";

// src/business/drivers/get-drivers-api.ts
var getDriversApi = (_0) => __async(void 0, [_0], function* ({ config: config2 }) {
  const endpoint = `${config2.apiBase}/api/drivers?page_size=0`;
  const response = yield fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${config2.token}`
    }
  });
  const data = yield response.json();
  return data;
});

// src/business/drivers/get-drivers-fetcher.ts
var getDriversFetcher = (config2) => {
  return getDriversApi({ config: config2 });
};

// src/business/drivers/get-drivers-mapper.ts
function getDriversMapper(driversDto) {
  if (!driversDto) {
    return;
  }
  return driversDto.map((d) => ({
    id: d.id.toString(),
    contactName: d.contact_name
  }));
}

// src/business/drivers/get-drivers-hook.ts
var useGetDriversHook = ({ config: config2 }) => {
  const fetcher = () => __async(void 0, null, function* () {
    return getDriversFetcher(config2);
  });
  const driversKey = "drivers";
  const { data, error, isLoading } = useSWR2(driversKey, fetcher);
  const driversMapped = data ? getDriversMapper(data) : [];
  return {
    drivers: driversMapped || [],
    count: (driversMapped == null ? void 0 : driversMapped.length) || 0,
    isLoading,
    error
  };
};

// src/components/driver-input/driver-input-component.tsx
function DriverInputComponent({
  config: config2,
  value,
  handleChangeValue
}) {
  const { drivers } = useGetDriversHook({ config: config2 });
  const driverOptions = drivers.map((driver) => ({
    label: driver.contactName,
    value: driver.id,
    searchValue: driver.contactName
  }));
  return /* @__PURE__ */ React2.createElement(
    Input2,
    {
      handleChangeValue,
      isClearable: true,
      label: "Conductor",
      name: "driver",
      options: driverOptions,
      type: "select-with-internal-search",
      value,
      width: "100%"
    }
  );
}

// src/components/filters/filters-container-component.tsx
import { FlexComponent as FlexComponent2 } from "@ontruck/fe-ui";
import styled3 from "styled-components";
var FiltersContainerComponent = styled3(FlexComponent2)`
  flex-grow: 1;
  justify-content: 'stretch';
  background-color: 'var(--otk-theme-color-grey-200, #e2e8ee)';
  align-items: center;
`;

// src/components/filters/responsive-inputs-container-component.tsx
import { FlexComponent as FlexComponent3 } from "@ontruck/fe-ui";
import styled4 from "styled-components";
var ResponsiveInputsContainerComponent = styled4(FlexComponent3)`
  flex-wrap: wrap;
  padding: 8px;
  min-height: 60px;
  align-items: center;
  background-color: var(--otk-theme-color-white);
  flex-grow: 1;
  gap: 8px;
`;

// src/components/filters/static-inputs-container-component.tsx
import React3 from "react";
import { FlexComponent as FlexComponent4 } from "@ontruck/fe-ui";
import styled5 from "styled-components";
var FlexContainerStyled = styled5(FlexComponent4)`
  padding: var(--delegations-cargos-filters-delegation-filter-padding, var(--otk-theme-space-s));
  background-color: var(--otk-theme-color-grey-200, #e2e8ee);
`;
var SmartViewInputContainerStyled = styled5(FlexComponent4)`
  flex-shrink: 0;
  height: 100%;
`;
function StaticInputsContainerComponent({
  children
}) {
  return /* @__PURE__ */ React3.createElement(SmartViewInputContainerStyled, null, /* @__PURE__ */ React3.createElement(FlexContainerStyled, null, children));
}

// src/business/shared/get-date-string-from-javascript-date.ts
var getDateStringFromJavascriptDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// src/components/filters/filters-config.ts
var FILTERS_CONFIG = {
  SMART_VIEWS: {
    width: "232px"
  },
  USER_DELEGATION_ID: {
    width: "180px"
  },
  FOC_DATE_FROM: {
    width: "150px"
  },
  FOR_DATE_FROM: {
    width: "150px"
  },
  CREATED_AT_DATE_FROM: {
    width: "150px"
  },
  RECEPTION_DATE_FROM: {
    width: "150px"
  },
  STATE: {
    width: "180px"
  },
  SERVICE: {
    width: "150px"
  },
  CS_CARGO: {
    width: "180px"
  },
  CS_ORIGIN: {
    width: "180px"
  },
  CS_DESTINATION: {
    width: "180px"
  },
  DESTINATION_ZIP_CODE: {
    width: "180px"
  },
  DRIVER_ID: {
    width: "220px"
  },
  SHIPPER_ID: {
    width: "220px"
  },
  SEARCH: {
    width: "180px"
  }
};

// src/components/shipper-input/shipper-input-component.tsx
import React4 from "react";
import { Input as Input3 } from "@ontruck/fe-ui";

// src/business/shippers/get-shippers-hook.ts
import useSWR3 from "swr";

// src/business/shippers/get-shippers-api.ts
var getShippersApi = (_0) => __async(void 0, [_0], function* ({ config: config2 }) {
  const endpoint = `${config2.apiBase}/v1/mercury/shippers/?search=&page_size=0&ordering=company_name`;
  const response = yield fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${config2.token}`
    }
  });
  const data = yield response.json();
  return data;
});

// src/business/shippers/get-shippers-fetcher.ts
var getShippersFetcher = (config2) => {
  return getShippersApi({ config: config2 });
};

// src/business/shippers/shipper-mapper.ts
function shipperMapper(shipperDto) {
  return {
    id: shipperDto.id,
    companyName: shipperDto.company_name
  };
}

// src/business/shippers/get-shippers-mapper.ts
function getShippersMapper(shippersDto) {
  return shippersDto.map(shipperMapper);
}

// src/business/shippers/get-shippers-hook.ts
var useGetShippersHook = ({ config: config2 }) => {
  const fetcher = () => __async(void 0, null, function* () {
    return getShippersFetcher(config2);
  });
  const shippersKey = "shippers";
  const { data, error, isLoading } = useSWR3(shippersKey, fetcher);
  const shippersMapped = data ? getShippersMapper(data) : [];
  return {
    shippers: shippersMapped,
    count: shippersMapped.length,
    isLoading,
    error
  };
};

// src/components/shipper-input/shipper-input-component.tsx
function ShipperInputComponent({
  config: config2,
  value,
  handleChangeValue
}) {
  const { shippers } = useGetShippersHook({ config: config2 });
  const shipperOptions = shippers.map((shipper) => ({
    label: shipper.companyName,
    value: shipper.id,
    searchValue: shipper.companyName
  }));
  return /* @__PURE__ */ React4.createElement(
    Input3,
    {
      handleChangeValue,
      isClearable: true,
      label: "Cliente",
      name: "shipper",
      options: shipperOptions,
      type: "select-with-internal-search",
      value,
      width: "100%"
    }
  );
}

// src/pages/shipments-list/shipment-filters/get-shipment-state-options.tsx
import React5 from "react";
import { LabelledBallComponent } from "@ontruck/fe-ui";
function getShipmentStateOptions(shipmentFiltersOptions) {
  return shipmentFiltersOptions.states.map((state) => {
    const shipmentStateFilterColor = ShipmentsStateService.getShipmentStateColor(state);
    const shipmentStateFilterText = state ? ShipmentsStateService.getShipmentStateText(state) : "Todos";
    const shipmentStateFilterValue = state ? state : "";
    const option = {
      value: shipmentStateFilterValue,
      label: shipmentStateFilterText,
      component: /* @__PURE__ */ React5.createElement(
        LabelledBallComponent,
        {
          ballColor: shipmentStateFilterColor,
          label: shipmentStateFilterText
        }
      )
    };
    return option;
  });
}

// src/pages/shipments-list/shipment-filters/get-shipment-service-options.ts
function getShipmentServiceOptions(shipmentFiltersOptions) {
  return shipmentFiltersOptions.services.map((service) => {
    const shipmentServiceFilterText = service ? ShipmentsServicesService.getShipmentServiceText(service) : "Todos";
    const shipmentServiceFilterValue = service ? service : "";
    const option = {
      value: shipmentServiceFilterValue,
      label: shipmentServiceFilterText
    };
    return option;
  });
}

// src/pages/shipments-list/shipment-filters/shipment-filters-component.tsx
var SmartViewsButton = styled6(ToolbarButtonComponent)`
  background-color: var(--grey300);
  height: auto;
  height: 100%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  margin-right: 8px;
`;
var CheckboxInputContainer = styled6(FlexComponent5)`
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: var(--otk-ui-input-height, 40px);
  padding: var(--otk-ui-input-padding, 4px 8px 2px 8px);
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  cursor: text;
  position: relative;
  border-radius: var(--otk-ui-input-border-radius, 4px);
  background: var(--otk-ui-input-background, #fff);
  border: var(--otk-ui-input-border, 1px solid #e2e8ee);
  width: auto;
  -webkit-flex: none;
  -ms-flex: none;
  flex: none;
  gap: 8px;
  input {
    transform: scale(1.2);
  }
`;
function ShipmentFiltersComponent({
  delegations,
  onGoToSmartViews
}) {
  const {
    handleChangeCreatedAtDateFrom,
    handleChangeCreatedAtDateTo,
    handleChangeCsCargo,
    handleChangeCsDestination,
    handleChangeCsOrigin,
    handleChangeDestinationZipCode,
    handleChangeDriverId,
    handleChangeFocDateFrom,
    handleChangeFocDateTo,
    handleChangeForDateFrom,
    handleChangeForDateTo,
    handleChangeLastReceptionInDelegation,
    handleChangeReceptionDateFrom,
    handleChangeReceptionDateTo,
    handleChangeSearch,
    handleChangeService,
    handleChangeShipmentSmartView,
    handleChangeShipperId,
    handleChangeState,
    shipmentFilters,
    shipmentFiltersOptions,
    shipmentsSmartViews
  } = useShipmentsListFiltersHook();
  const { selectedDelegationId } = useMyDelegationHook();
  const {
    shipmentFilters: {
      shipmentSmartView: { hiddenFilters }
    }
  } = useShipmentsListFiltersHook();
  const config2 = useConfigHook();
  const smartViewOptions = [
    {
      label: "General",
      value: DEFAULT_SHIPMENT_SMART_VIEW.id
    },
    ...shipmentsSmartViews.map((smartView) => ({
      label: smartView.name,
      value: smartView.id
    }))
  ];
  const stateOptions = getShipmentStateOptions(shipmentFiltersOptions);
  const serviceOptions = getShipmentServiceOptions(shipmentFiltersOptions);
  const csDelegationsOptions = delegations.map((delegation) => ({
    label: delegation.name,
    value: delegation.id
  }));
  const onSmartViewChange = (name, value) => {
    if (value === void 0) {
      return;
    }
    const selectedSmartView = shipmentsSmartViews.find((view) => view.id === value);
    if (!selectedSmartView) {
      handleChangeShipmentSmartView(DEFAULT_SHIPMENT_SMART_VIEW);
      return;
    }
    handleChangeShipmentSmartView(selectedSmartView);
  };
  const typeOfDateFilterOptions = [
    {
      label: "Documentado",
      value: "documentado"
    },
    {
      label: "Tr\xE1nsito",
      value: "transito"
    },
    {
      label: "Fecha obj. centro",
      value: "foc"
    },
    {
      label: "Fecha obj. red",
      value: "for"
    }
  ];
  const [typeOfDateFilter, setTypeOfDateFilter] = useState2(
    typeOfDateFilterOptions[0].value
  );
  const handleChangeTypeOfDateFilter = (value) => {
    setTypeOfDateFilter(value);
    handleChangeCreatedAtDateFrom("");
    handleChangeCreatedAtDateTo("");
    handleChangeReceptionDateFrom("");
    handleChangeReceptionDateTo("");
    handleChangeFocDateFrom("");
    handleChangeFocDateTo("");
    handleChangeForDateFrom("");
    handleChangeForDateTo("");
  };
  let genericDateFilterFromValue;
  if (typeOfDateFilter === "documentado") {
    genericDateFilterFromValue = shipmentFilters.createdAtDateFrom;
  } else if (typeOfDateFilter === "transito") {
    genericDateFilterFromValue = shipmentFilters.receptionDateFrom;
  } else if (typeOfDateFilter === "foc") {
    genericDateFilterFromValue = shipmentFilters.focDateFrom;
  } else if (typeOfDateFilter === "for") {
    genericDateFilterFromValue = shipmentFilters.forDateFrom;
  }
  const handleChangeGenericDateFilterFrom = (value) => {
    if (typeOfDateFilter === "documentado") {
      handleChangeCreatedAtDateFrom(value);
    } else if (typeOfDateFilter === "transito") {
      handleChangeReceptionDateFrom(value);
    } else if (typeOfDateFilter === "foc") {
      handleChangeFocDateFrom(value);
    } else if (typeOfDateFilter === "for") {
      handleChangeForDateFrom(value);
    }
  };
  let genericDateFilterToValue;
  if (typeOfDateFilter === "documentado") {
    genericDateFilterToValue = shipmentFilters.createdAtDateTo;
  } else if (typeOfDateFilter === "transito") {
    genericDateFilterToValue = shipmentFilters.receptionDateTo;
  } else if (typeOfDateFilter === "foc") {
    genericDateFilterToValue = shipmentFilters.focDateTo;
  } else if (typeOfDateFilter === "for") {
    genericDateFilterToValue = shipmentFilters.forDateTo;
  }
  const handleChangeGenericDateFilterTo = (value) => {
    if (typeOfDateFilter === "documentado") {
      handleChangeCreatedAtDateTo(value);
    } else if (typeOfDateFilter === "transito") {
      handleChangeReceptionDateTo(value);
    } else if (typeOfDateFilter === "foc") {
      handleChangeFocDateTo(value);
    } else if (typeOfDateFilter === "for") {
      handleChangeForDateTo(value);
    }
  };
  const multiSelectInputKey = shipmentFilters.state.join("");
  return /* @__PURE__ */ React6.createElement(FiltersContainerComponent, null, /* @__PURE__ */ React6.createElement(StaticInputsContainerComponent, null, /* @__PURE__ */ React6.createElement(SmartViewsButton, { onClick: onGoToSmartViews }, /* @__PURE__ */ React6.createElement(IconComponent, { name: iconNames.settings, sizeInPixels: 24 })), /* @__PURE__ */ React6.createElement(
    Input4,
    {
      handleChangeValue: onSmartViewChange,
      label: "Vista",
      name: "smart-view",
      options: smartViewOptions,
      type: "select",
      value: shipmentFilters.shipmentSmartView.id,
      width: FILTERS_CONFIG.SMART_VIEWS.width
    }
  )), /* @__PURE__ */ React6.createElement(ResponsiveInputsContainerComponent, null, !hiddenFilters.includes(AVAILABLE_FILTERS_TO_HIDE.state) && /* @__PURE__ */ React6.createElement(
    MultiSelectInputComponent,
    {
      key: multiSelectInputKey,
      label: "Estado",
      onChange: (values) => {
        handleChangeState(values);
      },
      options: stateOptions,
      values: shipmentFilters.state,
      width: FILTERS_CONFIG.STATE.width
    }
  ), !hiddenFilters.includes(AVAILABLE_FILTERS_TO_HIDE.date) && /* @__PURE__ */ React6.createElement(FlexComponent5, { gap: "0" }, /* @__PURE__ */ React6.createElement(
    Input4,
    {
      handleChangeValue: (name, value) => {
        if (value !== void 0)
          handleChangeTypeOfDateFilter(value);
      },
      label: "Fecha para filtrar",
      name: "type-of-date",
      options: typeOfDateFilterOptions,
      type: "select",
      value: typeOfDateFilter,
      width: FILTERS_CONFIG.FOR_DATE_FROM.width
    }
  ), /* @__PURE__ */ React6.createElement(
    Input4,
    {
      handleChangeValue: (name, value) => {
        if (!value) {
          handleChangeGenericDateFilterFrom("");
          return;
        }
        const newDate = new Date(value);
        const newDateNormalized = new Date(newDate.setHours(0, 0, 0, 0));
        const newDateFrom = getDateStringFromJavascriptDate(newDateNormalized);
        handleChangeGenericDateFilterFrom(newDateFrom);
      },
      label: "Fecha desde",
      name: "date",
      type: "date",
      value: genericDateFilterFromValue,
      width: FILTERS_CONFIG.FOR_DATE_FROM.width
    }
  ), /* @__PURE__ */ React6.createElement(
    Input4,
    {
      handleChangeValue: (name, value) => {
        if (!value) {
          handleChangeGenericDateFilterTo("");
          return;
        }
        const newDate = new Date(value);
        const newDateNormalized = new Date(newDate.setHours(23, 59, 59, 999));
        const newDateTo = getDateStringFromJavascriptDate(newDateNormalized);
        handleChangeGenericDateFilterTo(newDateTo);
      },
      label: "Fecha hasta",
      name: "date",
      type: "date",
      value: genericDateFilterToValue,
      width: FILTERS_CONFIG.FOR_DATE_FROM.width
    }
  )), !hiddenFilters.includes(AVAILABLE_FILTERS_TO_HIDE.service) && /* @__PURE__ */ React6.createElement(
    Input4,
    {
      handleChangeValue: (name, value) => {
        if (value !== void 0) {
          handleChangeService(value);
        }
      },
      label: "Servicio",
      name: "service",
      options: serviceOptions,
      type: "select",
      value: shipmentFilters.service,
      width: FILTERS_CONFIG.SERVICE.width
    }
  ), !hiddenFilters.includes(AVAILABLE_FILTERS_TO_HIDE.destinationZipCode) && /* @__PURE__ */ React6.createElement(
    Input4,
    {
      handleChangeEvent: (e) => {
        const event = e;
        const newValue = event.target.value;
        handleChangeDestinationZipCode(newValue);
      },
      label: "CP de entrega",
      name: "destination-zip-code",
      type: "text",
      value: shipmentFilters.destinationZipCode,
      width: FILTERS_CONFIG.DESTINATION_ZIP_CODE.width
    }
  ), /* @__PURE__ */ React6.createElement(
    MultiSelectInputComponent,
    {
      label: "CS. Cargo",
      onChange: (values) => {
        handleChangeCsCargo(values);
      },
      options: csDelegationsOptions,
      values: shipmentFilters.csCargos,
      width: FILTERS_CONFIG.CS_CARGO.width
    }
  ), /* @__PURE__ */ React6.createElement(
    MultiSelectInputComponent,
    {
      label: "CS. Origen",
      onChange: (values) => {
        handleChangeCsOrigin(values);
      },
      options: csDelegationsOptions,
      values: shipmentFilters.csOrigins,
      width: FILTERS_CONFIG.CS_ORIGIN.width
    }
  ), /* @__PURE__ */ React6.createElement(
    MultiSelectInputComponent,
    {
      label: "CS. Destino",
      onChange: (values) => {
        handleChangeCsDestination(values);
      },
      options: csDelegationsOptions,
      values: shipmentFilters.csDestinations,
      width: FILTERS_CONFIG.CS_DESTINATION.width
    }
  ), !hiddenFilters.includes(AVAILABLE_FILTERS_TO_HIDE.shipper) && /* @__PURE__ */ React6.createElement(FlexComponent5, { width: FILTERS_CONFIG.SHIPPER_ID.width }, /* @__PURE__ */ React6.createElement(
    ShipperInputComponent,
    {
      config: config2,
      handleChangeValue: (name, value) => {
        if (value === void 0) {
          handleChangeShipperId("");
        } else {
          handleChangeShipperId(value);
        }
      },
      value: shipmentFilters.shipperId === "" ? void 0 : shipmentFilters.shipperId
    }
  )), !hiddenFilters.includes(AVAILABLE_FILTERS_TO_HIDE.driver) && /* @__PURE__ */ React6.createElement(FlexComponent5, { width: FILTERS_CONFIG.DRIVER_ID.width }, /* @__PURE__ */ React6.createElement(
    DriverInputComponent,
    {
      config: config2,
      handleChangeValue: (name, value) => {
        if (value === void 0) {
          handleChangeDriverId("");
        } else {
          handleChangeDriverId(value);
        }
      },
      value: shipmentFilters.driverId === "" ? void 0 : shipmentFilters.driverId
    }
  )), selectedDelegationId.trim() !== "" && !hiddenFilters.includes(AVAILABLE_FILTERS_TO_HIDE.lastReceptionInDelegation) && /* @__PURE__ */ React6.createElement(CheckboxInputContainer, null, /* @__PURE__ */ React6.createElement("label", { htmlFor: "last-reception-in-delegation" }, /* @__PURE__ */ React6.createElement(TextComponent, null, "\xDAltima lectura en mi delegaci\xF3n")), /* @__PURE__ */ React6.createElement(
    "input",
    {
      checked: shipmentFilters.lastReceptionInDelegation,
      id: "last-reception-in-delegation",
      name: "last-reception-in-delegation",
      onChange: (e) => {
        handleChangeLastReceptionInDelegation(e.target.checked);
      },
      type: "checkbox"
    }
  )), /* @__PURE__ */ React6.createElement(
    Input4,
    {
      handleChangeEvent: (e) => {
        const event = e;
        const newValue = event.target.value;
        handleChangeSearch(newValue);
      },
      label: "B\xFAsqueda",
      name: "search",
      type: "search",
      value: shipmentFilters.search,
      width: FILTERS_CONFIG.SEARCH.width
    }
  )));
}

// src/pages/shipments-list/shipments-list-toolbar-component.tsx
function ShipmentsListToolbarComponent({
  delegations,
  onGoToSmartViews
}) {
  return /* @__PURE__ */ React7.createElement(CustomToolbarComponent, null, /* @__PURE__ */ React7.createElement(CustomToolbarContentComponent, null, /* @__PURE__ */ React7.createElement(ShipmentFiltersComponent, { delegations, onGoToSmartViews })));
}

// src/pages/shipments-list/shipments-list-data-hook.tsx
import useSWR4 from "swr";

// src/business/addresses/address-mapper.ts
function addressMapper(addressDto) {
  return {
    id: addressDto.id,
    city: addressDto.city,
    zipcode: addressDto.zipcode,
    addressLine: addressDto.address_line,
    contactPhone: addressDto.contact_phone,
    contactName: addressDto.contact_name,
    contactEmail: addressDto.contact_email,
    addressExtraInfo: addressDto.address_extra_info,
    country: addressDto.country,
    companyName: addressDto.company_name
  };
}

// src/business/cargo-events/cargo-event-mapper.ts
function cargoEventMapper(cargoEventDto) {
  var _a, _b, _c;
  return {
    id: cargoEventDto.id.toString(),
    eventType: cargoEventDto.event_type,
    createdAt: cargoEventDto.created_at,
    createdBy: {
      id: cargoEventDto.created_by.id,
      username: cargoEventDto.created_by.username,
      firstName: (_a = cargoEventDto.created_by.first_name) != null ? _a : "",
      lastName: (_b = cargoEventDto.created_by.last_name) != null ? _b : "",
      type: cargoEventDto.created_by.type
    },
    longitude: cargoEventDto.longitude,
    latitude: cargoEventDto.latitude,
    observations: cargoEventDto.observations,
    idNumber: cargoEventDto.id_number,
    image: cargoEventDto.image,
    driver: cargoEventDto.driver ? {
      id: cargoEventDto.driver.id,
      contactName: cargoEventDto.driver.contact_name
    } : null,
    diff: cargoEventDto.diff,
    address: {
      id: cargoEventDto.address.id,
      companyName: cargoEventDto.address.company_name,
      contactName: cargoEventDto.address.contact_name,
      addressName: cargoEventDto.address.address_name,
      addressLine: cargoEventDto.address.address_line,
      zipcode: cargoEventDto.address.zipcode,
      city: cargoEventDto.address.city,
      country: cargoEventDto.address.country
    },
    syntheticEventType: (_c = cargoEventDto.synthetic_event_type) != null ? _c : "",
    incidentType: cargoEventDto.incident_type
  };
}

// src/business/drivers/driver-mapper.ts
function driverMapper(driverDto) {
  return {
    id: driverDto.id,
    contactName: driverDto.contact_name
  };
}

// src/business/cargos/cargo-mapper.ts.ts
function cargoMapper(cargoDto) {
  var _a, _b;
  return {
    id: cargoDto.id.toString(),
    state: cargoDto.state,
    externalId: cargoDto.external_id,
    pendingAssignment: cargoDto.pending_assignment,
    events: cargoDto.events.map(cargoEventMapper),
    driver: cargoDto.driver ? driverMapper(cargoDto.driver) : null,
    maxHeight: cargoDto.max_height,
    maxWidth: (_a = cargoDto.max_width) != null ? _a : 0,
    maxLength: (_b = cargoDto.max_length) != null ? _b : 0,
    totalFloorSpace: cargoDto.total_floor_space,
    totalVolume: cargoDto.total_volume,
    weight: cargoDto.weight,
    lastReceivedEvent: cargoDto.last_received_event ? cargoEventMapper(cargoDto.last_received_event) : null,
    latestCargoEvent: cargoEventMapper(cargoDto.latest_cargo_event)
  };
}

// src/business/delegations/delegation-mapper.ts
function delegationMapper(delegationDto) {
  return {
    id: delegationDto.id,
    address: addressMapper(delegationDto.warehouse_address),
    name: delegationDto.name,
    city: delegationDto.city,
    zipCode: delegationDto.zip_code
  };
}

// src/business/shipments/shipment-mapper.ts
function shipmentMapper(shipmentDto) {
  var _a, _b, _c, _d, _e;
  const cargos = shipmentDto.cargos.map(cargoMapper);
  const drivers = [];
  for (const cargo of cargos) {
    const cargoDriver = cargo.driver;
    if (cargoDriver) {
      if (!drivers.find((driver) => driver.id === cargoDriver.id)) {
        drivers.push(cargoDriver);
      }
    }
  }
  return {
    id: shipmentDto.id,
    state: shipmentDto.state,
    externalId: shipmentDto.external_id,
    billingDelegation: delegationMapper(shipmentDto.billing_delegation),
    originDelegation: delegationMapper(shipmentDto.origin_delegation),
    destinationDelegation: delegationMapper(shipmentDto.destination_delegation),
    senderAddress: shipmentDto.sender_address ? addressMapper(shipmentDto.sender_address) : null,
    deliveryAddress: shipmentDto.delivery_address ? addressMapper(shipmentDto.delivery_address) : null,
    service: shipmentDto.service,
    lastReceivedEvent: shipmentDto.last_received_event ? cargoEventMapper(shipmentDto.last_received_event) : null,
    latestCargoEvent: cargoEventMapper(shipmentDto.latest_cargo_event),
    cargos,
    drivers,
    networkObjectiveDatetime: (_a = shipmentDto.network_objective_datetime) != null ? _a : null,
    centreObjectiveDatetime: (_b = shipmentDto.centre_objective_datetime) != null ? _b : null,
    receptionDatetime: (_c = shipmentDto.reception_datetime) != null ? _c : null,
    createdAt: shipmentDto.created_at,
    externalReference: shipmentDto.external_reference,
    shipper: shipmentDto.shipper ? shipperMapper(shipmentDto.shipper) : null,
    cargosInShipmentStateCount: shipmentDto.cargos_in_shipment_state_count,
    maxHeight: shipmentDto.max_height,
    maxWidth: (_d = shipmentDto.max_width) != null ? _d : 0,
    maxLength: (_e = shipmentDto.max_length) != null ? _e : 0,
    totalFloorSpace: shipmentDto.total_floor_space,
    totalVolume: shipmentDto.total_volume,
    weight: shipmentDto.weight
  };
}

// src/business/shipments/get-shipments-mapper.ts
function getShipmentsMapper(shipmentDtos) {
  const shipments = shipmentDtos.map((s) => {
    try {
      return shipmentMapper(s);
    } catch (e) {
      console.error("Error mapping shippment with id ", s.id);
      console.error(e);
      throw e;
    }
  });
  return shipments;
}

// src/business/shipments/get-shipments-api.ts
var getShipmentsQueryFromShipmentFilters = (shipmentFilters, myDelegationId) => {
  const defaultQuery = `?page_size=${shipmentFilters.pageSize}&page=${shipmentFilters.page}&ordering=-id`;
  try {
    const dateToSuffix = "T23:59:59Z";
    let query = defaultQuery;
    if (shipmentFilters.service) {
      query += `&service=${shipmentFilters.service}`;
    }
    if (shipmentFilters.state.length > 0) {
      shipmentFilters.state.forEach((state) => {
        query += `&state=${state}`;
      });
    }
    if (shipmentFilters.search.trim() !== "") {
      query += `&search=${shipmentFilters.search}`;
    }
    if (shipmentFilters.destinationZipCode.trim() !== "") {
      query += `&destination_zipcode=${shipmentFilters.destinationZipCode}`;
    }
    if (myDelegationId !== "") {
      query += `&delegation=${myDelegationId}`;
    }
    if (shipmentFilters.csCargos.length > 0) {
      shipmentFilters.csCargos.forEach((csCargo) => {
        query += `&billing_delegation=${csCargo}`;
      });
    }
    if (shipmentFilters.csOrigins.length > 0) {
      shipmentFilters.csOrigins.forEach((csOrigin) => {
        query += `&origin_delegation=${csOrigin}`;
      });
    }
    if (shipmentFilters.csDestinations.length > 0) {
      shipmentFilters.csDestinations.forEach((csDestination) => {
        query += `&destination_delegation=${csDestination}`;
      });
    }
    if (shipmentFilters.lastReceptionInDelegation && myDelegationId !== "") {
      query += `&last_reception_in_delegation=${myDelegationId}`;
    }
    if (shipmentFilters.createdAtDateFrom.trim() !== "") {
      query += `&created_at_from=${shipmentFilters.createdAtDateFrom}`;
    }
    if (shipmentFilters.createdAtDateTo.trim() !== "") {
      query += `&created_at_to=${shipmentFilters.createdAtDateTo}${dateToSuffix}`;
    }
    if (shipmentFilters.receptionDateFrom.trim() !== "") {
      query += `&reception_datetime_from=${shipmentFilters.receptionDateFrom}`;
    }
    if (shipmentFilters.receptionDateTo.trim() !== "") {
      query += `&reception_datetime_to=${shipmentFilters.receptionDateTo}${dateToSuffix}`;
    }
    if (shipmentFilters.focDateFrom.trim() !== "") {
      query += `&centre_objective_datetime_from=${shipmentFilters.focDateFrom}`;
    }
    if (shipmentFilters.focDateTo.trim() !== "") {
      query += `&centre_objective_datetime_to=${shipmentFilters.focDateTo}${dateToSuffix}`;
    }
    if (shipmentFilters.forDateFrom.trim() !== "") {
      query += `&network_objective_datetime_from=${shipmentFilters.forDateFrom}`;
    }
    if (shipmentFilters.forDateTo.trim() !== "") {
      query += `&network_objective_datetime_to=${shipmentFilters.forDateTo}${dateToSuffix}`;
    }
    if (shipmentFilters.shipperId !== "") {
      query += `&shipper=${shipmentFilters.shipperId}`;
    }
    if (shipmentFilters.driverId !== "") {
      query += `&driver=${shipmentFilters.driverId}`;
    }
    return query;
  } catch (error) {
    return defaultQuery;
  }
};
function getShipmentsApi(_0, _1, _2) {
  return __async(this, arguments, function* ({ token, apiBase }, shipmentFilters, myDelegationId) {
    const baseURL = `${apiBase}/v1/fleet/shipments/`;
    const queryParams = getShipmentsQueryFromShipmentFilters(shipmentFilters, myDelegationId);
    const url = `${baseURL}${queryParams}`;
    const response = yield fetch(url, {
      method: "GET",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!response.ok) {
      throw new Error("Failed to fetch shipments");
    }
    return yield response.json();
  });
}

// src/business/shipments/get-shipments-fetcher.ts
var getShipmentsFetcher = (config2, shipmentFilters, myDelegationId) => {
  return getShipmentsApi(config2, shipmentFilters, myDelegationId);
};

// src/pages/shipments-list/shipments-list-data-hook.tsx
var RELOAD_SHIPMENTS_LIST_INTERVAL_IN_SECONDS = 30;
var useShipmentsListDataHook = ({
  shipmentFilters,
  myDelegationId
}) => {
  var _a;
  const key = `last-mile/shipments/${JSON.stringify(shipmentFilters)}/${myDelegationId}`;
  const config2 = useConfigHook();
  const fetcher = () => __async(void 0, null, function* () {
    return getShipmentsFetcher(config2, shipmentFilters, myDelegationId);
  });
  const { data, error, isLoading } = useSWR4(key, fetcher, {
    refreshInterval: RELOAD_SHIPMENTS_LIST_INTERVAL_IN_SECONDS * 1e3,
    revalidateIfStale: true
  });
  const shipmentsMapped = data ? getShipmentsMapper(data.results) : [];
  const totalShipmentsCount = (_a = data == null ? void 0 : data.count) != null ? _a : 0;
  return {
    shipments: shipmentsMapped,
    isLoading,
    error,
    totalShipmentsCount
  };
};

// src/pages/shipments-list/shipments-table/shipments-table-component.tsx
import React31, { useCallback as useCallback5, useMemo as useMemo14 } from "react";
import { TableComponent as TableComponent2, TableErrorComponent } from "@ontruck/fe-ui";

// src/pages/shipments-list/shipments-table/shipments-table-summary-component.tsx
import React14 from "react";
import {
  FlexComponent as FlexComponent8,
  TableCellComponent,
  TextComponent as TextComponent4,
  ToolbarButtonComponent as ToolbarButtonComponent3
} from "@ontruck/fe-ui";
import styled9 from "styled-components";
import { IconComponent as IconComponent3 } from "@ontruck/fe-icons";

// src/pages/shipments-list/components/assign-driver-to-cargos/assign-driver-to-cargos-button-component.tsx
import React8 from "react";
import {
  ToolbarButtonComponent as ToolbarButtonComponent2,
  TooltipBodyComponent,
  TooltipComponent,
  TooltipHeaderComponent,
  TooltipUnorderedListComponent
} from "@ontruck/fe-ui";
import { IconComponent as IconComponent2 } from "@ontruck/fe-icons";
function AssignDriverToCargosButtonComponent({
  onClick,
  canAssign
}) {
  const handleAssignDriverToCargos = () => {
    if (onClick) {
      onClick();
    }
  };
  const buttonText = "Asignar reparto a env\xEDos seleccionados";
  return /* @__PURE__ */ React8.createElement(
    TooltipComponent,
    {
      content: /* @__PURE__ */ React8.createElement("div", null, /* @__PURE__ */ React8.createElement(TooltipHeaderComponent, null, "Para asignar el reparto:"), /* @__PURE__ */ React8.createElement(TooltipBodyComponent, null, /* @__PURE__ */ React8.createElement(TooltipUnorderedListComponent, null, /* @__PURE__ */ React8.createElement("li", null, "Hay que seleccionar al menos un env\xEDo"), /* @__PURE__ */ React8.createElement("li", null, "Los bultos del env\xEDo tienen que estar listos para entregar")))),
      isDisabled: canAssign,
      renderOpener: (props) => /* @__PURE__ */ React8.createElement(
        ToolbarButtonComponent2,
        __spreadProps(__spreadValues({}, props), {
          height: "auto",
          isDisabled: !canAssign,
          onClick: canAssign ? handleAssignDriverToCargos : void 0,
          withBorder: true
        }),
        /* @__PURE__ */ React8.createElement(IconComponent2, { colorVariant: "primary", name: "van", sizeInPixels: 24 }),
        " ",
        buttonText
      )
    }
  );
}

// src/pages/shipments-list/components/assign-driver-to-cargos/assign-driver-to-cargos-hook.tsx
import React11 from "react";
import { Modal } from "react-async-popup";

// src/pages/shipments-list/components/assign-driver-to-cargos/assign-driver-to-cargos-modal-component.tsx
import React10 from "react";
import { ModalComponent, FlexComponent as FlexComponent6, TextComponent as TextComponent2 } from "@ontruck/fe-ui";
import { CircleExclamationIcon } from "@ontruck/fe-icons";

// src/components/modals/modal-body-regular-text.tsx
import styled7 from "styled-components";
var ModalBodyRegularText = styled7.div`
  align-self: stretch;
  color: var(--grey700);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

// src/pages/shipments-list/components/assign-driver-to-cargos/assign-driver-to-cargos-input-component.tsx
import React9, { useMemo as useMemo2 } from "react";
import { Input as Input5 } from "@ontruck/fe-ui";
function AssignDriverToCargosInputComponent({
  config: config2,
  value,
  handleChangeValue
}) {
  const { drivers } = useGetDriversHook({ config: config2 });
  const driversOptions = useMemo2(
    () => drivers.map((d) => ({
      label: d.contactName,
      value: d.id,
      searchValue: d.contactName
    })),
    [drivers]
  );
  return /* @__PURE__ */ React9.createElement(
    Input5,
    {
      handleChangeValue,
      isClearable: true,
      label: "Conductor",
      name: "driver",
      options: driversOptions,
      type: "select-with-internal-search",
      value,
      width: "100%"
    }
  );
}

// src/pages/shipments-list/components/assign-driver-to-cargos/assign-driver-to-cargos-modal-component.tsx
function AssignDriverToCargosModalComponent({
  shipments,
  onSuccess,
  onCancel,
  config: config2
}) {
  const {
    canSubmit,
    loading,
    onConfirm,
    selectedDriverId,
    onGoback,
    selectDriver,
    headerText,
    cargosThatCanBeAssigned,
    cargosThatCannotBeAssigned
  } = useAssignDriverToCargosHook({
    shipments,
    onSuccess,
    onCancel,
    config: config2
  });
  const handleChangeValue = (name, value) => {
    selectDriver(value);
  };
  return /* @__PURE__ */ React10.createElement(
    ModalComponent,
    {
      bodyComponent: /* @__PURE__ */ React10.createElement(FlexComponent6, { alignSelf: "stretch", flexDirection: "column", gap: "32px" }, /* @__PURE__ */ React10.createElement(ModalBodyRegularText, { style: { display: "flex", flexDirection: "column", gap: "8px" } }, /* @__PURE__ */ React10.createElement(TextComponent2, { fontWeight: "bold" }, "Bultos que ser\xE1n asignados:"), /* @__PURE__ */ React10.createElement(
        FlexComponent6,
        {
          flexDirection: "column",
          gap: "8px",
          style: { maxHeight: "100px", overflowY: "auto" }
        },
        cargosThatCanBeAssigned.map((cargo) => /* @__PURE__ */ React10.createElement(TextComponent2, { key: cargo.id }, cargo.externalId))
      )), /* @__PURE__ */ React10.createElement(FlexComponent6, { flexDirection: "column", gap: "8px", width: "100%" }, /* @__PURE__ */ React10.createElement(ModalBodyRegularText, null, "Asignar a:"), /* @__PURE__ */ React10.createElement(
        AssignDriverToCargosInputComponent,
        {
          config: config2,
          handleChangeValue,
          value: selectedDriverId
        }
      )), cargosThatCannotBeAssigned.length > 0 && /* @__PURE__ */ React10.createElement(ModalBodyRegularText, { style: { display: "flex", flexDirection: "column", gap: "8px" } }, /* @__PURE__ */ React10.createElement(TextComponent2, { color: "var(--accent700)", fontWeight: "bold", gap: "8px" }, /* @__PURE__ */ React10.createElement(CircleExclamationIcon, { color: "var(--accent700)", sizeInPixels: 16 }), " Bultos que no pueden ser asignados:"), /* @__PURE__ */ React10.createElement(
        FlexComponent6,
        {
          flexDirection: "column",
          gap: "8px",
          style: { maxHeight: "100px", overflowY: "auto" }
        },
        cargosThatCannotBeAssigned.map((cargo) => /* @__PURE__ */ React10.createElement(TextComponent2, { color: "var(--accent700)", key: cargo.id }, cargo.externalId))
      ))),
      cancelButtonLabel: "Cancelar",
      confirmButtonIsLoadingLabel: "Asignando...",
      confirmButtonLabel: "Asignar",
      description: headerText,
      isCancelDisabled: loading,
      isConfirmDisabled: !canSubmit,
      isConfirmLoading: loading,
      onCancel: onGoback,
      onClose: onGoback,
      onConfirm,
      title: "Asignar conductor"
    }
  );
}

// src/pages/shipments-list/components/assign-driver-to-cargos/assign-driver-to-cargos-hook.tsx
var useAssingDriverToCargoHook = ({
  config: config2,
  shipments,
  onSuccess
}) => {
  const openAssignDriverToCargosModal = () => __async(void 0, null, function* () {
    const { show, destroy } = yield Modal.new({
      content: /* @__PURE__ */ React11.createElement(
        AssignDriverToCargosModalComponent,
        {
          config: config2,
          onCancel: () => void destroy(),
          onSuccess: () => {
            void destroy();
            if (onSuccess) {
              onSuccess();
            }
          },
          shipments
        }
      ),
      footer: null
    });
    void show();
  });
  return {
    openAssignDriverToCargosModal
  };
};

// src/pages/shipments-list/receive/receive-cargos-hook.tsx
import React13 from "react";
import { Modal as Modal2 } from "react-async-popup";

// src/pages/shipments-list/receive/receive-cargos-modal-component.tsx
import React12, { useCallback as useCallback3, useEffect as useEffect2 } from "react";
import {
  BoxesSpinnerComponent,
  FlexComponent as FlexComponent7,
  Input as Input6,
  ModalComponent as ModalComponent2,
  TableComponent,
  TextComponent as TextComponent3
} from "@ontruck/fe-ui";
import { CircleLineCheckIcon, CircleXIcon, QrCodeIcon } from "@ontruck/fe-icons/";
import styled8 from "styled-components";

// src/pages/shipments-list/receive/receive-cargos-modal-hook.tsx
import { useCallback as useCallback2, useEffect, useState as useState3 } from "react";
import { toast as toast2 } from "sonner";
import { mutate as mutate2 } from "swr";

// src/pages/shipments-list/receive/reveice-cargo-api.ts
function receiveCargoApi(_0) {
  return __async(this, arguments, function* ({
    cargoId,
    config: config2,
    warehouseId
  }) {
    const endpoint = `${config2.apiBase}/v1/fleet/cargos/ext-${cargoId}/receive/`;
    const body = JSON.stringify({
      deconsolidate: true,
      address_id: warehouseId
    });
    return fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config2.token}`
      },
      body
    });
  });
}

// src/pages/shipments-list/receive/receive-cargos-modal-hook.tsx
function useReceiveCargosModalHook({
  onSuccess,
  onCancel,
  config: config2,
  userDelegations,
  selectedDelegationId
}) {
  const [loading, setLoading] = useState3(false);
  const [isConfirming, setIsConfirming] = useState3(false);
  const canSubmit = !loading;
  const headerText = isConfirming ? "Confirmar finalizaci\xF3n de recepci\xF3n" : "Marcar paquetes como recibidos";
  const confirmButtonLabel = isConfirming ? "Si, recepcion finalizada" : "Finalizar recepcion";
  const cancelButtonLabel = isConfirming ? "No, continuar escaneando" : "Cancelar";
  const [selectedWarehouseId, setSelectedWarehouseId] = useState3("");
  const userAvailableWarehouseOptions = userDelegations.map((userDelegation) => {
    return {
      value: userDelegation.warehouse_address.id.toString(),
      label: userDelegation.name
    };
  });
  const emptyWarehouseOption = {
    value: "",
    label: "Selecciona una delegaci\xF3n"
  };
  const userWarehouseOptions = [emptyWarehouseOption, ...userAvailableWarehouseOptions];
  useEffect(() => {
    var _a;
    if (selectedDelegationId) {
      const warehouseId = (_a = userDelegations.find(
        (userDelegation) => userDelegation.id === Number(selectedDelegationId)
      )) == null ? void 0 : _a.warehouse_address.id;
      if (warehouseId) {
        setSelectedWarehouseId(warehouseId.toString());
      }
    }
  }, [selectedDelegationId, userDelegations]);
  const [cargoId, setCargoId] = useState3("");
  const [receivedCargos, setReceivedCargos] = useState3([]);
  const onGoback = useCallback2(() => {
    if (loading) {
      return;
    }
    if (isConfirming) {
      setIsConfirming(false);
      return;
    }
    onCancel();
  }, [onCancel, loading, isConfirming]);
  const onConfirm = useCallback2(() => {
    if (isConfirming) {
      onSuccess();
      return;
    }
    setIsConfirming(true);
  }, [onSuccess, isConfirming]);
  const attempToMarkCargoAsReceived = useCallback2(
    (cargoIdToAttemp) => __async(this, null, function* () {
      if (!selectedWarehouseId) {
        return;
      }
      const successMessage = `Paquete ${cargoIdToAttemp} marcado como recibido con \xE9xito`;
      const errorMessage = `Error al marcar el paquete ${cargoIdToAttemp} como recibido`;
      setLoading(true);
      try {
        const response = yield receiveCargoApi({
          cargoId,
          config: config2,
          warehouseId: selectedWarehouseId
        });
        if (!response.ok)
          throw new Error(`Bad response receiving cargo`);
        setReceivedCargos(
          (prev) => prev.map((cargo) => cargo.cargoId === cargoId ? __spreadProps(__spreadValues({}, cargo), { status: "ok" }) : cargo)
        );
        setLoading(false);
        toast2.success(successMessage);
        void mutate2((key) => {
          return typeof key === "string" && key.startsWith("last-mile");
        });
      } catch (error) {
        setReceivedCargos(
          (prev) => prev.map((cargo) => cargo.cargoId === cargoId ? __spreadProps(__spreadValues({}, cargo), { status: "error" }) : cargo)
        );
        toast2.error(errorMessage);
        setLoading(false);
      }
    }),
    [cargoId, config2, selectedWarehouseId]
  );
  const manageCargoMarkedAsReceived = useCallback2(
    (cargoIdToAttemp) => __async(this, null, function* () {
      const cargoRecived = receivedCargos.find((cargo) => cargo.cargoId === cargoIdToAttemp);
      if (cargoRecived) {
        return;
      }
      setCargoId("");
      setReceivedCargos((prev) => [...prev, { cargoId: cargoIdToAttemp, status: "loading" }]);
      yield attempToMarkCargoAsReceived(cargoIdToAttemp);
    }),
    [attempToMarkCargoAsReceived, receivedCargos]
  );
  const handleEnter = useCallback2(
    (event) => __async(this, null, function* () {
      if (event.key === "Enter" && cargoId.trim() !== "") {
        yield manageCargoMarkedAsReceived(cargoId);
      }
    }),
    [manageCargoMarkedAsReceived, cargoId]
  );
  const hookResult = {
    loading,
    canSubmit,
    onGoback,
    onConfirm,
    headerText,
    handleEnter,
    receivedCargos,
    setReceivedCargos,
    cargoId,
    setCargoId,
    userWarehouseOptions,
    selectedWarehouseId,
    setSelectedWarehouseId,
    isConfirming,
    confirmButtonLabel,
    cancelButtonLabel
  };
  return hookResult;
}

// src/pages/shipments-list/receive/receive-cargos-modal-component.tsx
var ScrollableTableContainer = styled8(FlexComponent7)`
  max-height: 250px;
  min-height: 250px;
  overflow-y: auto;
  width: 100%;
`;
function ReceiveCargosModalComponent({
  onSuccess,
  onCancel,
  config: config2,
  userDelegations,
  selectedDelegationId
}) {
  const {
    canSubmit,
    loading,
    onConfirm,
    onGoback,
    headerText,
    cargoId,
    setCargoId,
    receivedCargos,
    handleEnter,
    userWarehouseOptions,
    selectedWarehouseId,
    setSelectedWarehouseId,
    isConfirming,
    confirmButtonLabel,
    cancelButtonLabel
  } = useReceiveCargosModalHook({
    onSuccess,
    onCancel,
    config: config2,
    userDelegations,
    selectedDelegationId
  });
  useEffect2(() => {
    if (selectedWarehouseId === "") {
      return;
    }
    const timer = setTimeout(() => {
      if (selectedWarehouseId === "") {
        return;
      }
      const input = document.querySelector('input[name="scan-input"]');
      if (input) {
        input.focus();
      }
    }, 1);
    return () => {
      clearTimeout(timer);
    };
  }, [selectedWarehouseId]);
  const getTableRowsCells = useCallback3(() => {
    return receivedCargos.map((cargo) => {
      return {
        id: cargo.cargoId,
        cells: [
          {
            id: `cargo-${cargo.cargoId}-column-1`,
            backgroundColor: "var(--otk-ui-modal-container-background, #f2f5f8)",
            content: /* @__PURE__ */ React12.createElement(FlexComponent7, { alignItems: "center", justifyContent: "space-between", width: "100%" }, /* @__PURE__ */ React12.createElement(TextComponent3, { flexGrow: 1 }, cargo.cargoId), cargo.status === "loading" ? /* @__PURE__ */ React12.createElement(
              BoxesSpinnerComponent,
              {
                color: "var(--otk-theme-color-primary, rgb(0, 122, 255))",
                sizeInPixels: 16
              }
            ) : null, cargo.status === "ok" ? /* @__PURE__ */ React12.createElement(CircleLineCheckIcon, { color: "green", sizeInPixels: 16 }) : null, cargo.status === "error" ? /* @__PURE__ */ React12.createElement(CircleXIcon, { color: "red", sizeInPixels: 16 }) : null),
            width: "100%"
          }
        ]
      };
    });
  }, [receivedCargos]);
  return /* @__PURE__ */ React12.createElement(
    ModalComponent2,
    {
      bodyComponent: isConfirming ? /* @__PURE__ */ React12.createElement(FlexComponent7, { alignSelf: "stretch", flexDirection: "column", gap: "8px" }, /* @__PURE__ */ React12.createElement(TextComponent3, null, "\xBFEst\xE1s seguro de que quieres finalizar la recepci\xF3n?")) : /* @__PURE__ */ React12.createElement(FlexComponent7, { alignSelf: "stretch", flexDirection: "column", gap: "8px" }, /* @__PURE__ */ React12.createElement(FlexComponent7, { width: "100%" }, /* @__PURE__ */ React12.createElement(
        Input6,
        {
          handleChangeValue: (name, value) => {
            if (value !== void 0)
              setSelectedWarehouseId(value);
          },
          label: "Delegaci\xF3n",
          name: "warehouse-id",
          options: userWarehouseOptions,
          type: "select",
          value: selectedWarehouseId,
          width: "100%"
        }
      )), /* @__PURE__ */ React12.createElement(
        Input6,
        {
          autoFocus: true,
          handleChangeEvent: (e) => {
            const event = e;
            const newValue = event.target.value;
            setCargoId(newValue);
          },
          icon: /* @__PURE__ */ React12.createElement(QrCodeIcon, null),
          isDisabled: selectedWarehouseId === "",
          label: "Escanea o teclea el c\xF3digo del paquete y pulsa enter",
          name: "scan-input",
          onKeyDown: handleEnter,
          type: "text-with-icon",
          value: cargoId,
          width: "100%"
        }
      ), /* @__PURE__ */ React12.createElement(ScrollableTableContainer, null, /* @__PURE__ */ React12.createElement(
        TableComponent,
        {
          emptyStateMessage: "Aqu\xED aparecer\xE1n los paquetes escaneados",
          numberOfItems: receivedCargos.length,
          rowsCells: getTableRowsCells()
        }
      ))),
      cancelButtonLabel,
      confirmButtonIsLoadingLabel: "Finalizar recepcion",
      confirmButtonLabel,
      description: headerText,
      isCancelDisabled: loading,
      isConfirmDisabled: !canSubmit,
      isConfirmLoading: loading,
      onCancel: onGoback,
      onClose: onGoback,
      onConfirm
    }
  );
}

// src/pages/shipments-list/receive/receive-cargos-hook.tsx
var useReceiveCargosHook = ({
  onSuccess
}) => {
  const config2 = useConfigHook();
  const { selectedDelegationId } = useMyDelegationHook();
  const { userDelegations } = useConfigHook();
  const openReceiveCargosModal = () => __async(void 0, null, function* () {
    const { show, destroy } = yield Modal2.new({
      content: /* @__PURE__ */ React13.createElement(
        ReceiveCargosModalComponent,
        {
          config: config2,
          onCancel: () => void destroy(),
          onSuccess: () => {
            onSuccess();
            void destroy();
          },
          selectedDelegationId,
          userDelegations
        }
      ),
      footer: null
    });
    void show();
  });
  return {
    openReceiveCargosModal
  };
};

// src/pages/shipments-list/components/assign-driver-to-cargos/can-selected-shipments-be-assigned-to-driver.ts
function canSelectedShipmentsBeAssignedToDriver(shipments) {
  return shipments.length > 0 && shipments.flatMap((shipment) => shipment.cargos).some((cargo) => canCargoBeAssignedToDriver(cargo));
}

// src/pages/shipments-list/shipments-table/shipments-table-summary-component.tsx
var FixedSummaryWrapperComponent = styled9(FlexComponent8)`
  position: relative;
  width: 100%;
`;
var FixedSummaryContainerComponent = styled9(FlexComponent8)`
  position: fixed;
  left: 0;
  right: 0;
  width: 100%;
  background-color: white;
`;
function ShipmentsTableSummaryComponent({
  isLoading,
  isError,
  totalShipmentsCount
}) {
  const config2 = useConfigHook();
  const { selectedShipments } = useShipmentsListSelectionHook();
  const canCargosBeAssigned = canSelectedShipmentsBeAssignedToDriver(selectedShipments);
  const { openAssignDriverToCargosModal } = useAssingDriverToCargoHook({
    config: config2,
    shipments: selectedShipments
  });
  const selectedCount = selectedShipments.length;
  const handleClickAssignDriverToCargosButton = () => __async(this, null, function* () {
    yield openAssignDriverToCargosModal();
  });
  const { openReceiveCargosModal } = useReceiveCargosHook({
    onSuccess: () => {
      console.log("Paquetes marcados como recibidos con \xE9xito");
    }
  });
  const handleClickReceiveCargosButton = () => __async(this, null, function* () {
    yield openReceiveCargosModal();
  });
  return /* @__PURE__ */ React14.createElement(
    FixedSummaryWrapperComponent,
    {
      alignItems: "center",
      backgroundColor: "white",
      height: "40px",
      width: "100%"
    },
    !isLoading && !isError && /* @__PURE__ */ React14.createElement(
      FixedSummaryContainerComponent,
      {
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%"
      },
      /* @__PURE__ */ React14.createElement(FlexComponent8, null, /* @__PURE__ */ React14.createElement(TableCellComponent, { borderRight: "1px solid var(--grey-200, #E2E8EE);", padding: "0 16px" }, /* @__PURE__ */ React14.createElement(TextComponent4, { color: "var(--grey-500, #94A6B8)", fontSize: "12px", fontWeight: 500 }, "Total: ", totalShipmentsCount)), /* @__PURE__ */ React14.createElement(TableCellComponent, { padding: "0 16px" }, /* @__PURE__ */ React14.createElement(TextComponent4, { color: "var(--grey-500, #94A6B8)", fontSize: "12px", fontWeight: 500 }, "Seleccionados: ", selectedCount)), /* @__PURE__ */ React14.createElement(
        AssignDriverToCargosButtonComponent,
        {
          canAssign: canCargosBeAssigned,
          onClick: () => void handleClickAssignDriverToCargosButton()
        }
      )),
      /* @__PURE__ */ React14.createElement(FlexComponent8, { margin: "0 16px" }, /* @__PURE__ */ React14.createElement(
        ToolbarButtonComponent3,
        {
          height: "auto",
          onClick: () => void handleClickReceiveCargosButton(),
          withBorder: true
        },
        /* @__PURE__ */ React14.createElement(IconComponent3, { colorVariant: "primary", name: "qr-code", sizeInPixels: 24 }),
        " Recibir paquetes"
      ))
    )
  );
}

// src/pages/shipments-list/shipments-table/shipments-table-header-columns.tsx
import React16 from "react";

// src/pages/shipments-list/shipments-table/shipments-table-columns.ts
var { getColumnText: getColumnText2 } = SmartViewsService;
var SHIPMENTS_TABLE_COLUMNS = {
  accordionIndicator: {
    id: "1",
    width: "16px"
  },
  checkbox: {
    id: "2",
    width: "45px",
    alignment: "center"
  },
  state: {
    id: "3",
    width: "192px",
    label: getColumnText2(COLUMNS_ALWAYS_VISIBLE.state)
  },
  createdAt: {
    id: "4",
    width: "144px",
    label: getColumnText2(AVAILABLE_COLUMNS_TO_HIDE.createdAt)
  },
  receptionDatetime: {
    id: "5",
    width: "144px",
    label: getColumnText2(AVAILABLE_COLUMNS_TO_HIDE.receptionDatetime)
  },
  externalId: {
    id: "6",
    width: "208px",
    label: getColumnText2(COLUMNS_ALWAYS_VISIBLE.externalId)
  },
  externalReference: {
    id: "7",
    width: "232px",
    label: getColumnText2(AVAILABLE_COLUMNS_TO_HIDE.externalReference)
  },
  senderAddress: {
    id: "8",
    width: "180px",
    label: getColumnText2(AVAILABLE_COLUMNS_TO_HIDE.senderAddress)
  },
  deliveryAddress: {
    id: "9",
    width: "180px",
    label: getColumnText2(AVAILABLE_COLUMNS_TO_HIDE.deliveryAddress)
  },
  deliveryDetails: {
    id: "10",
    width: "288px",
    label: getColumnText2(AVAILABLE_COLUMNS_TO_HIDE.deliveryDetails)
  },
  billingDelegation: {
    id: "11",
    width: "180px",
    label: getColumnText2(AVAILABLE_COLUMNS_TO_HIDE.billingDelegation)
  },
  originDelegation: {
    id: "12",
    width: "180px",
    label: getColumnText2(AVAILABLE_COLUMNS_TO_HIDE.originDelegation)
  },
  destinationDelegation: {
    id: "13",
    width: "180px",
    label: getColumnText2(AVAILABLE_COLUMNS_TO_HIDE.destinationDelegation)
  },
  service: {
    id: "14",
    width: "136px",
    label: getColumnText2(AVAILABLE_COLUMNS_TO_HIDE.service)
  },
  weight: {
    id: "15",
    width: "136px",
    label: getColumnText2(AVAILABLE_COLUMNS_TO_HIDE.weight)
  },
  centreObjectiveDatetime: {
    id: "16",
    width: "144px",
    label: getColumnText2(AVAILABLE_COLUMNS_TO_HIDE.centreObjectiveDatetime)
  },
  networkObjectiveDatetime: {
    id: "17",
    width: "144px",
    label: getColumnText2(AVAILABLE_COLUMNS_TO_HIDE.networkObjectiveDatetime)
  },
  shipper: {
    id: "18",
    width: "192px",
    label: getColumnText2(AVAILABLE_COLUMNS_TO_HIDE.shipper)
  },
  driver: {
    id: "19",
    width: "192px",
    label: getColumnText2(AVAILABLE_COLUMNS_TO_HIDE.driver)
  },
  lastReceivedEvent: {
    id: "20",
    width: "352px",
    label: getColumnText2(AVAILABLE_COLUMNS_TO_HIDE.lastReceivedEvent)
  },
  lastUpdate: {
    id: "21",
    width: "352px",
    label: getColumnText2(COLUMNS_ALWAYS_VISIBLE.lastUpdate),
    group: "right"
  }
};

// src/pages/shipments-list/shipments-table/shipments-table-header-checkbox-component.tsx
import React15 from "react";
function ShipmentsTableHeaderCheckboxComponent({
  shipments
}) {
  const { selectedShipments, selectAllShipments, unSelectAllShipments } = useShipmentsListSelectionHook();
  const isAllSelected = shipments.length > 0 && selectedShipments.length === shipments.length;
  return /* @__PURE__ */ React15.createElement(
    "input",
    {
      checked: isAllSelected,
      onChange: () => {
        if (isAllSelected) {
          unSelectAllShipments();
        } else {
          selectAllShipments(shipments);
        }
      },
      type: "checkbox"
    }
  );
}

// src/pages/shipments-list/shipments-table/shipments-table-header-columns.tsx
var getShipmentsTableHeaderColumns = ({
  shipments
}) => {
  const columns = SHIPMENTS_TABLE_COLUMNS;
  columns.checkbox.cellComponent = /* @__PURE__ */ React16.createElement(ShipmentsTableHeaderCheckboxComponent, { shipments });
  return columns;
};

// src/pages/shipments-list/shipments-table/shipments-table-row-component.tsx
import React30, { useState as useState5 } from "react";
import styled11 from "styled-components";
import { AccordionComponent, AccordionTriggerComponent, TableCellComponent as TableCellComponent10 } from "@ontruck/fe-ui";

// src/pages/shipments-list/shipments-table/shipments-table-row-parent-component.tsx
import React28, { useMemo as useMemo12 } from "react";
import { FlexComponent as FlexComponent12, TooltipComponent as TooltipComponent2, TooltipHeaderComponent as TooltipHeaderComponent2 } from "@ontruck/fe-ui";

// src/components/table-cells/table-cell-state-component.tsx
import React17, { useMemo as useMemo3 } from "react";
import { LabelledBallComponent as LabelledBallComponent2, TableCellComponent as TableCellComponent2 } from "@ontruck/fe-ui";
function TableCellStateComponent(_a) {
  var _b = _a, {
    stateColor,
    stateText,
    isSelected = false,
    isOpen = false,
    isChildren = false
  } = _b, tableCellComponentProps = __objRest(_b, [
    "stateColor",
    "stateText",
    "isSelected",
    "isOpen",
    "isChildren"
  ]);
  const background = useMemo3(() => {
    if (isChildren) {
      return "#f2f8ff";
    }
    if (isOpen) {
      return "#cfdff4";
    }
    if (isSelected) {
      return "var(--otk-theme-color-grey-200, #e2e8ee)";
    }
    return "var(--otk-theme-color-grey-100, #F2F5F8)";
  }, [isChildren, isSelected, isOpen]);
  return /* @__PURE__ */ React17.createElement(
    TableCellComponent2,
    __spreadValues({
      background,
      borderLeft: `4px solid ${stateColor}`
    }, tableCellComponentProps),
    /* @__PURE__ */ React17.createElement(LabelledBallComponent2, { ballColor: stateColor, label: stateText })
  );
}

// src/components/table-cells/table-cell-address-component.tsx
import React18, { useMemo as useMemo4 } from "react";
import { TableCellComponent as TableCellComponent3, TextComponent as TextComponent5 } from "@ontruck/fe-ui";
function TableCellAddressComponent(_a) {
  var _b = _a, {
    isChildren = false,
    address,
    isSelected = false,
    isOpen = false
  } = _b, tableCellComponentProps = __objRest(_b, [
    "isChildren",
    "address",
    "isSelected",
    "isOpen"
  ]);
  const background = useMemo4(() => {
    if (isChildren) {
      return "#f2f8ff";
    }
    if (isOpen) {
      return "#cfdff4";
    }
    if (isSelected) {
      return "var(--otk-theme-color-grey-100, #f2f5f8)";
    }
    return "transparent";
  }, [isSelected, isOpen, isChildren]);
  const border = useMemo4(() => {
    if (isOpen) {
      return "1px solid #7e9abe";
    }
    return "1px solid var(--otk-theme-color-grey-200, #e2e8ee)";
  }, [isOpen]);
  const city = useMemo4(() => {
    const words = address == null ? void 0 : address.city.split(" ");
    if (words) {
      return words.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
    }
    return "";
  }, [address == null ? void 0 : address.city]);
  return /* @__PURE__ */ React18.createElement(
    TableCellComponent3,
    __spreadProps(__spreadValues({
      background,
      borderLeft: border
    }, tableCellComponentProps), {
      style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "center"
      }
    }),
    /* @__PURE__ */ React18.createElement(TextComponent5, { gap: "4px" }, /* @__PURE__ */ React18.createElement("strong", null, city)),
    /* @__PURE__ */ React18.createElement(TextComponent5, { gap: "4px" }, address == null ? void 0 : address.zipcode)
  );
}

// src/components/table-cells/table-cell-acordion-component.tsx
import React19, { useMemo as useMemo5 } from "react";
import { AccordionIconComponent, TableCellComponent as TableCellComponent4 } from "@ontruck/fe-ui";
function TableCellAcordionComponent(_a) {
  var _b = _a, {
    isOpen,
    isChildren = false,
    isSelected = false
  } = _b, tableCellComponentProps = __objRest(_b, [
    "isOpen",
    "isChildren",
    "isSelected"
  ]);
  const background = useMemo5(() => {
    if (isChildren) {
      return "#f2f8ff";
    }
    if (isSelected || isOpen) {
      return "var(--otk-theme-color-grey-200, #e2e8ee)";
    }
    return "var(--otk-theme-color-grey-300, #CCD7E0)";
  }, [isSelected, isOpen, isChildren]);
  return /* @__PURE__ */ React19.createElement(
    TableCellComponent4,
    __spreadValues({
      background,
      borderRight: isChildren ? "1px solid #f2f8ff" : "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
      justifyContent: "center",
      padding: "unset"
    }, tableCellComponentProps),
    !isChildren && /* @__PURE__ */ React19.createElement(AccordionIconComponent, { open: isOpen })
  );
}

// src/components/table-cells/table-cell-checkbox-component.tsx
import React20, { useMemo as useMemo6 } from "react";
import { TableCellComponent as TableCellComponent5 } from "@ontruck/fe-ui";
function TableCellCheckboxComponent(_a) {
  var _b = _a, {
    isChildren = false,
    isOpen = false,
    isChecked,
    handleCheckboxChange,
    isSelected = false
  } = _b, tableCellComponentProps = __objRest(_b, [
    "isChildren",
    "isOpen",
    "isChecked",
    "handleCheckboxChange",
    "isSelected"
  ]);
  const background = useMemo6(() => {
    if (isChildren) {
      return "#f2f8ff";
    }
    if (isOpen) {
      return "#cfdff4";
    }
    if (isSelected) {
      return "var(--otk-theme-color-grey-200, #e2e8ee)";
    }
    return "var(--otk-theme-color-grey-100, #F2F5F8)";
  }, [isChildren, isSelected, isOpen]);
  return /* @__PURE__ */ React20.createElement(
    TableCellComponent5,
    __spreadValues({
      background,
      borderLeft: isChildren ? "1px solid #f2f8ff" : "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
      borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)"
    }, tableCellComponentProps),
    isChecked !== void 0 && handleCheckboxChange !== void 0 && !isChildren && /* @__PURE__ */ React20.createElement("input", { checked: isChecked, onChange: handleCheckboxChange, type: "checkbox" })
  );
}

// src/components/table-cells/table-cell-text-component.tsx
import React21, { useMemo as useMemo7 } from "react";
import { BadgeComponent, FlexComponent as FlexComponent9, TableCellComponent as TableCellComponent6, TextComponent as TextComponent6 } from "@ontruck/fe-ui";
function TableCellTextComponent(_a) {
  var _b = _a, {
    text,
    badgeText,
    badgeBorderColor,
    isSelected = false,
    fontWeight = "normal",
    isOpen = false,
    isChildren = false
  } = _b, tableCellComponentProps = __objRest(_b, [
    "text",
    "badgeText",
    "badgeBorderColor",
    "isSelected",
    "fontWeight",
    "isOpen",
    "isChildren"
  ]);
  const background = useMemo7(() => {
    if (isChildren) {
      return "#f2f8ff";
    }
    if (isOpen) {
      return "#cfdff4";
    }
    if (isSelected) {
      return "var(--otk-theme-color-grey-100, #f2f5f8)";
    }
    return "transparent";
  }, [isSelected, isOpen, isChildren]);
  const border = useMemo7(() => {
    if (isChildren) {
      return "1px solid #b2c9e7";
    }
    if (isOpen) {
      return "1px solid #b2c9e7";
    }
    return "1px solid var(--otk-theme-color-grey-200, #e2e8ee)";
  }, [isOpen, isChildren]);
  return /* @__PURE__ */ React21.createElement(
    TableCellComponent6,
    __spreadValues({
      background,
      borderLeft: border,
      borderRight: border
    }, tableCellComponentProps),
    /* @__PURE__ */ React21.createElement(FlexComponent9, { alignItems: "center", justifyContent: "space-between", width: "100%" }, /* @__PURE__ */ React21.createElement(TextComponent6, { fontWeight }, text), badgeText !== void 0 && /* @__PURE__ */ React21.createElement(
      BadgeComponent,
      {
        backgroundColor: isOpen ? "#7e9abe" : void 0,
        color: isOpen ? "#f2f8ff" : void 0,
        style: {
          borderBottom: `3px solid ${badgeBorderColor ? badgeBorderColor : "transparent"}`
        }
      },
      badgeText
    ))
  );
}

// src/components/table-cells/table-cell-cargo-event-component.tsx
import React22, { useMemo as useMemo8 } from "react";
import { TableCellComponent as TableCellComponent7, TextComponent as TextComponent7 } from "@ontruck/fe-ui";
import { getReadableDate } from "@ontruck/fe-core";

// src/business/cargo-events/cargo-event-types-service.ts
var CARGO_EVENT_TYPES = {
  created: "created",
  customsCleared: "customs-cleared",
  collectedForDelivery: "collected-for-delivery",
  collectedForTransfer: "collected-for-transfer",
  delivered: "delivered",
  received: "received",
  consolidated: "consolidated",
  deconsolidated: "deconsolidated",
  deliveryFailed: "delivery-failed",
  deliveryAddressUpdated: "delivery-address-updated",
  deliveryInternalUpdated: "delivery-internal-updated",
  assigned: "assigned",
  incidentReported: "incident-reported",
  incidentResolved: "incident-resolved",
  returningToDelegation: "returning-to-delegation",
  shipmentStateChanged: "shipment-state-changed"
};
var cargoEventTypesTexts = {
  [CARGO_EVENT_TYPES.created]: "Documentado",
  [CARGO_EVENT_TYPES.customsCleared]: "Documentad",
  [CARGO_EVENT_TYPES.collectedForDelivery]: "Recogido para reparto",
  [CARGO_EVENT_TYPES.collectedForTransfer]: "Recogido para transferencia",
  [CARGO_EVENT_TYPES.delivered]: "Entregado",
  [CARGO_EVENT_TYPES.received]: "Recibido",
  [CARGO_EVENT_TYPES.consolidated]: "Consolidado",
  [CARGO_EVENT_TYPES.deconsolidated]: "Desconsolidado",
  [CARGO_EVENT_TYPES.deliveryFailed]: "Reparto fallido",
  [CARGO_EVENT_TYPES.deliveryAddressUpdated]: "Direcci\xF3n de reparto actualizada",
  [CARGO_EVENT_TYPES.deliveryInternalUpdated]: "Reparto interno actualizado",
  [CARGO_EVENT_TYPES.assigned]: "Asignado",
  [CARGO_EVENT_TYPES.incidentReported]: "Incidente reportado",
  [CARGO_EVENT_TYPES.incidentResolved]: "Incidente resuelto",
  [CARGO_EVENT_TYPES.returningToDelegation]: "Volviendo a la delegaci\xF3n",
  [CARGO_EVENT_TYPES.shipmentStateChanged]: "Estado del env\xEDo actualizado"
};
var getCargoEventTypeText = (cargoEvent) => {
  const eventType = cargoEvent.eventType || "Desconocido";
  if (eventType === CARGO_EVENT_TYPES.received) {
    const syntheticEventType = cargoEvent.syntheticEventType;
    if (syntheticEventType === "received") {
      return `Llegada al CS origen`;
    }
    if (syntheticEventType === "received-at-origin") {
      return `Llegada al CS origen`;
    } else if (syntheticEventType === "received-at-platform") {
      return `Lectura en plataforma`;
    } else if (syntheticEventType === "received-at-destination") {
      return `Llegada a CS destino`;
    }
  }
  if (eventType in cargoEventTypesTexts) {
    return cargoEventTypesTexts[eventType];
  }
  return eventType;
};
var CargoEventTypesService = {
  getCargoEventTypeText,
  CARGO_EVENT_TYPES
};

// src/components/table-cells/table-cell-cargo-event-component.tsx
function TableCellCargoEventComponent(_a) {
  var _b = _a, {
    isSelected = false,
    isChildren = false,
    isOpen = false,
    cargoEvent
  } = _b, tableCellComponentProps = __objRest(_b, [
    "isSelected",
    "isChildren",
    "isOpen",
    "cargoEvent"
  ]);
  const cargoEventReadableDate = cargoEvent ? getReadableDate(cargoEvent.createdAt) : "";
  let cargoEventUserDisplayName = cargoEvent ? cargoEvent.createdBy.username : "";
  if ((cargoEvent == null ? void 0 : cargoEvent.createdBy.firstName) && cargoEvent.createdBy.lastName) {
    cargoEventUserDisplayName = `${cargoEvent.createdBy.firstName} ${cargoEvent.createdBy.lastName}`;
  }
  const cargoEventTypeText = cargoEvent ? CargoEventTypesService.getCargoEventTypeText(cargoEvent) : "";
  const cargoEventAddressText = (cargoEvent == null ? void 0 : cargoEvent.eventType) === CARGO_EVENT_TYPES.received ? ` / ${cargoEvent.address.companyName}` : "";
  const background = useMemo8(() => {
    if (isChildren) {
      return "#f2f8ff";
    }
    if (isOpen) {
      return "#cfdff4";
    }
    if (isSelected) {
      return "var(--otk-theme-color-grey-200, #e2e8ee)";
    }
    return "var(--otk-theme-color-grey-100, #F2F5F8)";
  }, [isSelected, isChildren, isOpen]);
  const border = useMemo8(() => {
    if (isChildren) {
      return "1px solid #b2c9e7";
    }
    if (isOpen) {
      return "1px solid #b2c9e7";
    }
    return "1px solid var(--otk-theme-color-grey-200, #e2e8ee)";
  }, [isOpen, isChildren]);
  return /* @__PURE__ */ React22.createElement(
    TableCellComponent7,
    __spreadValues({
      background,
      borderLeft: border,
      borderRight: isChildren ? "1px solid #f2f8ff" : void 0,
      marginLeft: "auto",
      padding: "0"
    }, tableCellComponentProps),
    /* @__PURE__ */ React22.createElement(TextComponent7, { alignItems: "start", flexDirection: "column", flexGrow: 1, padding: "5px 16px" }, /* @__PURE__ */ React22.createElement(TextComponent7, { fontWeight: 700, style: { flexWrap: "wrap" } }, cargoEventTypeText, " ", /* @__PURE__ */ React22.createElement("span", { style: { fontWeight: 400, marginLeft: "4px" } }, cargoEventAddressText)), /* @__PURE__ */ React22.createElement(TextComponent7, { color: "var(--grey-500, #94A6B8)", fontSize: "12px", fontWeight: 500 }, cargoEventUserDisplayName), /* @__PURE__ */ React22.createElement(TextComponent7, { color: "var(--grey-500, #94A6B8)", fontSize: "12px", fontWeight: 500 }, cargoEventReadableDate))
  );
}

// src/business/shared/get-formatted-date-from-string-datetime.ts
function getFormattedDateFromStringDatetime(datetime) {
  var _a, _b, _c, _d, _e;
  if (!datetime) {
    return "";
  }
  try {
    const date = new Date(datetime);
    if (isNaN(date.getTime())) {
      return "";
    }
    const formatter = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: "Europe/Madrid"
    });
    const parts = formatter.formatToParts(date);
    const day = ((_a = parts.find((p) => p.type === "day")) == null ? void 0 : _a.value) || "";
    const month = ((_b = parts.find((p) => p.type === "month")) == null ? void 0 : _b.value) || "";
    const year = ((_c = parts.find((p) => p.type === "year")) == null ? void 0 : _c.value) || "";
    const hour = ((_d = parts.find((p) => p.type === "hour")) == null ? void 0 : _d.value) || "";
    const minute = ((_e = parts.find((p) => p.type === "minute")) == null ? void 0 : _e.value) || "";
    return `${year}-${month}-${day} ${hour}:${minute}`;
  } catch (e) {
    return "";
  }
}

// src/components/table-cells/table-cell-address-details-component.tsx
import React23, { useMemo as useMemo9 } from "react";
import { FlexComponent as FlexComponent10, TableCellComponent as TableCellComponent8, TextComponent as TextComponent8 } from "@ontruck/fe-ui";
function TableCellAddressDetailsComponent(_a) {
  var _b = _a, {
    isChildren = false,
    address,
    isSelected = false,
    isOpen = false
  } = _b, tableCellComponentProps = __objRest(_b, [
    "isChildren",
    "address",
    "isSelected",
    "isOpen"
  ]);
  const background = useMemo9(() => {
    if (isChildren) {
      return "#f2f8ff";
    }
    if (isOpen) {
      return "#cfdff4";
    }
    if (isSelected) {
      return "var(--otk-theme-color-grey-100, #f2f5f8)";
    }
    return "transparent";
  }, [isSelected, isOpen, isChildren]);
  const border = useMemo9(() => {
    if (isOpen) {
      return "1px solid #7e9abe";
    }
    return "1px solid var(--otk-theme-color-grey-200, #e2e8ee)";
  }, [isOpen]);
  return /* @__PURE__ */ React23.createElement(TableCellComponent8, __spreadValues({ background, borderLeft: border }, tableCellComponentProps), /* @__PURE__ */ React23.createElement(FlexComponent10, { flexDirection: "column", gap: "4px" }, /* @__PURE__ */ React23.createElement(TextComponent8, { color: "var(--otk-theme-color-grey-500, #667085)" }, address == null ? void 0 : address.companyName), /* @__PURE__ */ React23.createElement(TextComponent8, null, address == null ? void 0 : address.addressLine)));
}

// src/components/table-cells/table-cell-delegation-component.tsx
import React24, { useMemo as useMemo10 } from "react";
import { TableCellComponent as TableCellComponent9, TextComponent as TextComponent9 } from "@ontruck/fe-ui";
function TableCellDelegationComponent(_a) {
  var _b = _a, {
    isChildren = false,
    delegation,
    isSelected = false,
    isOpen = false
  } = _b, tableCellComponentProps = __objRest(_b, [
    "isChildren",
    "delegation",
    "isSelected",
    "isOpen"
  ]);
  const background = useMemo10(() => {
    if (isChildren) {
      return "#f2f8ff";
    }
    if (isOpen) {
      return "#cfdff4";
    }
    if (isSelected) {
      return "var(--otk-theme-color-grey-100, #f2f5f8)";
    }
    return "transparent";
  }, [isSelected, isOpen, isChildren]);
  const border = useMemo10(() => {
    if (isOpen) {
      return "1px solid #7e9abe";
    }
    return "1px solid var(--otk-theme-color-grey-200, #e2e8ee)";
  }, [isOpen]);
  return /* @__PURE__ */ React24.createElement(
    TableCellComponent9,
    __spreadProps(__spreadValues({
      background,
      borderLeft: border
    }, tableCellComponentProps), {
      style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "center"
      }
    }),
    /* @__PURE__ */ React24.createElement(TextComponent9, { gap: "4px" }, /* @__PURE__ */ React24.createElement("strong", null, delegation == null ? void 0 : delegation.name)),
    /* @__PURE__ */ React24.createElement(TextComponent9, { gap: "4px" }, delegation == null ? void 0 : delegation.address.zipcode)
  );
}

// src/pages/shipments-list/shipments-table/individual-actions/shipments-table-individual-actions-component.tsx
import React27 from "react";
import {
  Popover,
  IndividualActionsBodyComponent,
  IndividualActionItemComponent,
  IndividualActionsMenuButtonComponent
} from "@ontruck/fe-ui";
import { mutate as mutate3 } from "swr";
import styled10 from "styled-components";

// src/business/cargos/cargo-states-service.ts
var CARGO_STATES = {
  incident: "incident",
  outForDelivery: "out-for-delivery",
  partialDelivery: "partial-delivery",
  delivered: "delivered",
  cancelled: "cancelled",
  destroyed: "destroyed",
  created: "created",
  pendingNewDelivery: "pending-new-delivery",
  atWarehouse: "at-warehouse",
  inTransfer: "in-transfer"
};
var cargoStatesColors = {
  [CARGO_STATES.incident]: ShipmentsStateService.getShipmentStateColor(CARGO_STATES.incident),
  [CARGO_STATES.outForDelivery]: ShipmentsStateService.getShipmentStateColor(
    CARGO_STATES.outForDelivery
  ),
  [CARGO_STATES.partialDelivery]: ShipmentsStateService.getShipmentStateColor(
    CARGO_STATES.partialDelivery
  ),
  [CARGO_STATES.delivered]: ShipmentsStateService.getShipmentStateColor(CARGO_STATES.delivered),
  [CARGO_STATES.cancelled]: ShipmentsStateService.getShipmentStateColor(CARGO_STATES.cancelled),
  [CARGO_STATES.destroyed]: ShipmentsStateService.getShipmentStateColor(CARGO_STATES.destroyed),
  [CARGO_STATES.created]: ShipmentsStateService.getShipmentStateColor(CARGO_STATES.created),
  [CARGO_STATES.pendingNewDelivery]: ShipmentsStateService.getShipmentStateColor(
    CARGO_STATES.pendingNewDelivery
  ),
  [CARGO_STATES.atWarehouse]: ShipmentsStateService.getShipmentStateColor(CARGO_STATES.atWarehouse),
  [CARGO_STATES.inTransfer]: ShipmentsStateService.getShipmentStateColor(CARGO_STATES.inTransfer),
  default: ShipmentsStateService.getShipmentStateColor("default")
};
var getCargoStateColor = (state) => {
  if (state in cargoStatesColors) {
    return cargoStatesColors[state];
  }
  return cargoStatesColors.default;
};
var cargoStatesTexts = {
  [CARGO_STATES.incident]: ShipmentsStateService.getShipmentStateText(CARGO_STATES.incident),
  [CARGO_STATES.outForDelivery]: ShipmentsStateService.getShipmentStateText(
    CARGO_STATES.outForDelivery
  ),
  [CARGO_STATES.partialDelivery]: ShipmentsStateService.getShipmentStateText(
    CARGO_STATES.partialDelivery
  ),
  [CARGO_STATES.delivered]: ShipmentsStateService.getShipmentStateText(CARGO_STATES.delivered),
  [CARGO_STATES.cancelled]: ShipmentsStateService.getShipmentStateText(CARGO_STATES.cancelled),
  [CARGO_STATES.destroyed]: ShipmentsStateService.getShipmentStateText(CARGO_STATES.destroyed),
  [CARGO_STATES.created]: ShipmentsStateService.getShipmentStateText(CARGO_STATES.created),
  [CARGO_STATES.pendingNewDelivery]: ShipmentsStateService.getShipmentStateText(
    CARGO_STATES.pendingNewDelivery
  ),
  [CARGO_STATES.atWarehouse]: ShipmentsStateService.getShipmentStateText(CARGO_STATES.atWarehouse),
  [CARGO_STATES.inTransfer]: ShipmentsStateService.getShipmentStateText(CARGO_STATES.inTransfer)
};
var getCargoStateText = (state) => {
  if (state in cargoStatesTexts) {
    return cargoStatesTexts[state];
  }
  return state;
};
var CargoStatesService = {
  getCargoStateColor,
  getCargoStateText,
  CARGO_STATES
};

// src/pages/shipments-list/incident-reporting/delivery-failed/can-report-delivery-failed-incident-for-cargo.ts
var canReportDeliveryFailedIncidentForCargo = (cargo) => {
  const cargoStates = CargoStatesService.CARGO_STATES;
  const statesThatDontAllowToReportIncident = [cargoStates.incident];
  const cargoIsHasTheRightState = !statesThatDontAllowToReportIncident.includes(
    cargo.state
  );
  const cargoHasDriver = cargo.driver !== null && cargo.driver !== void 0;
  return cargoHasDriver && cargoIsHasTheRightState;
};

// src/pages/shipments-list/incident-reporting/staged-in-platform/can-report-staged-in-platform-incident-for-cargo.ts
var canReportStagedInPlatformIncidentForCargo = (cargo) => {
  const cargoStates = CargoStatesService.CARGO_STATES;
  const cargoIsHasTheRightState = cargo.state === cargoStates.outForDelivery || cargo.state === cargoStates.inTransfer;
  return cargoIsHasTheRightState;
};

// src/pages/shipments-list/incident-reporting/postponed-delivery/can-report-postponed-delivery-incident-for-cargo.ts
var canReportPostponedDeliveryIncidentForCargo = (cargo) => {
  const cargoStates = CargoStatesService.CARGO_STATES;
  const cargoIsHasTheRightState = cargo.state === cargoStates.outForDelivery;
  return cargoIsHasTheRightState;
};

// src/pages/shipments-list/incident-reporting/wrong-address/can-report-wrong-address-incident-for-cargo.ts
var canReportWrongAddressIncidentForCargo = (cargo) => {
  const cargoStates = CargoStatesService.CARGO_STATES;
  const cargoIsHasTheRightState = cargo.state === cargoStates.outForDelivery;
  return cargoIsHasTheRightState;
};

// src/pages/shipments-list/incident-reporting/can-report-incident-for-cargo.ts
var canReportIncidentForCargo = (cargo) => {
  return canReportDeliveryFailedIncidentForCargo(cargo) || canReportStagedInPlatformIncidentForCargo(cargo) || canReportPostponedDeliveryIncidentForCargo(cargo) || canReportWrongAddressIncidentForCargo(cargo);
};

// src/pages/shipments-list/incident-reporting/can-report-incident-for-shipment.ts
var canReportIncidentForShipment = (shipment) => {
  return shipment.cargos.some((cargo) => canReportIncidentForCargo(cargo));
};

// src/pages/shipments-list/incident-reporting/report-incident-hook.tsx
import React26 from "react";
import { Modal as Modal3 } from "react-async-popup";

// src/pages/shipments-list/incident-reporting/report-incident-modal-component.tsx
import React25 from "react";
import { FlexComponent as FlexComponent11, Input as Input7, ModalComponent as ModalComponent3 } from "@ontruck/fe-ui";

// src/pages/shipments-list/incident-reporting/report-incident-modal-hook.tsx
import { useCallback as useCallback4, useEffect as useEffect3, useMemo as useMemo11, useState as useState4 } from "react";
import { toast as toast3 } from "sonner";

// src/business/incidents/incident-types-service.ts
var INCIDENT_TYPES = {
  deliveryFailed: "delivery-failed",
  incorrectAddress: "incorrect-address",
  stagedInPlatform: "staged-in-platform",
  postponedDelivery: "postponed-delivery",
  other: "other"
};
var incidentTypesTexts = {
  [INCIDENT_TYPES.deliveryFailed]: "Reparto fallido",
  [INCIDENT_TYPES.incorrectAddress]: "Direcci\xF3n incorrecta",
  [INCIDENT_TYPES.stagedInPlatform]: "Estacionado en plataforma",
  [INCIDENT_TYPES.postponedDelivery]: "Repartir al d\xEDa siguiente",
  [INCIDENT_TYPES.other]: "Otro"
};
var getIncidentTypeText = (type) => {
  if (type in incidentTypesTexts) {
    return incidentTypesTexts[type];
  }
  return type;
};
var incidentTypesCodes = {
  [INCIDENT_TYPES.deliveryFailed]: "D18",
  [INCIDENT_TYPES.incorrectAddress]: "D20",
  [INCIDENT_TYPES.stagedInPlatform]: "C01",
  [INCIDENT_TYPES.postponedDelivery]: "D13",
  [INCIDENT_TYPES.other]: "DYY"
};
var getIncidentTypeCode = (type) => {
  if (type in incidentTypesCodes) {
    return incidentTypesCodes[type];
  }
  return type;
};
var IncidentTypesService = {
  getIncidentTypeText,
  getIncidentTypeCode,
  INCIDENT_TYPES
};

// src/pages/shipments-list/incident-reporting/delivery-failed/report-delivery-failed-incident-for-cargo-api.ts
function reportDeliveryFailedIncidentForCargoApi(_0) {
  return __async(this, arguments, function* ({
    cargo,
    config: config2
  }) {
    var _a;
    const cargoId = cargo.id;
    const driverId = (_a = cargo.driver) == null ? void 0 : _a.id;
    const endpoint = `${config2.apiBase}/v1/fleet/cargos/${cargoId}/incidents/`;
    const body = {
      driver_id: driverId,
      incident_type: IncidentTypesService.INCIDENT_TYPES.deliveryFailed
    };
    return fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config2.token}`
      },
      body: JSON.stringify(body)
    });
  });
}

// src/pages/shipments-list/incident-reporting/staged-in-platform/report-staged-in-platform-incident-for-cargo.ts
function reportStagedInPlatformIncidentForCargoApi(_0) {
  return __async(this, arguments, function* ({
    cargo,
    config: config2
  }) {
    const cargoId = cargo.id;
    const endpoint = `${config2.apiBase}/v1/fleet/cargos/${cargoId}/incidents/`;
    const body = {
      incident_type: IncidentTypesService.INCIDENT_TYPES.stagedInPlatform
    };
    return fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config2.token}`
      },
      body: JSON.stringify(body)
    });
  });
}

// src/pages/shipments-list/incident-reporting/postponed-delivery/report-postponed-delivery-incident-for-cargo.ts
function reportPostponedDeliveryIncidentForCargoApi(_0) {
  return __async(this, arguments, function* ({
    cargo,
    config: config2
  }) {
    const cargoId = cargo.id;
    const endpoint = `${config2.apiBase}/v1/fleet/cargos/${cargoId}/incidents/`;
    const body = {
      incident_type: IncidentTypesService.INCIDENT_TYPES.postponedDelivery
    };
    return fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config2.token}`
      },
      body: JSON.stringify(body)
    });
  });
}

// src/pages/shipments-list/incident-reporting/wrong-address/report-wrong-address-incident-for-cargo.ts
function reportWrongAddressIncidentForCargoApi(_0) {
  return __async(this, arguments, function* ({
    cargo,
    config: config2
  }) {
    const cargoId = cargo.id;
    const endpoint = `${config2.apiBase}/v1/fleet/cargos/${cargoId}/incidents/`;
    const body = {
      incident_type: IncidentTypesService.INCIDENT_TYPES.incorrectAddress
    };
    return fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config2.token}`
      },
      body: JSON.stringify(body)
    });
  });
}

// src/pages/shipments-list/incident-reporting/report-incident-modal-hook.tsx
function useReportIncidentModalHook({
  shipment,
  onSuccess,
  onCancel,
  config: config2
}) {
  const cargoOptions = useMemo11(() => {
    return shipment.cargos.filter((cargo) => canReportIncidentForCargo(cargo)).map((cargo) => ({
      label: cargo.externalId,
      value: cargo.id
    }));
  }, [shipment.cargos]);
  const initialCargoId = useMemo11(() => {
    if (cargoOptions.length === 1) {
      return cargoOptions[0].value;
    }
    return void 0;
  }, [cargoOptions]);
  const [selectedCargoId, setSelectedCargoId] = useState4(initialCargoId);
  const selectedCargo = useMemo11(() => {
    return shipment.cargos.find((cargo) => cargo.id === selectedCargoId);
  }, [shipment.cargos, selectedCargoId]);
  const incidentTypeOptionsForSelectedCargo = useMemo11(() => {
    const incidentTypesForSelectedCargo = [];
    if (!selectedCargo) {
      return [];
    }
    if (canReportWrongAddressIncidentForCargo(selectedCargo)) {
      incidentTypesForSelectedCargo.push(IncidentTypesService.INCIDENT_TYPES.incorrectAddress);
    }
    if (canReportDeliveryFailedIncidentForCargo(selectedCargo)) {
      incidentTypesForSelectedCargo.push(IncidentTypesService.INCIDENT_TYPES.deliveryFailed);
    }
    if (canReportStagedInPlatformIncidentForCargo(selectedCargo)) {
      incidentTypesForSelectedCargo.push(IncidentTypesService.INCIDENT_TYPES.stagedInPlatform);
    }
    if (canReportPostponedDeliveryIncidentForCargo(selectedCargo)) {
      incidentTypesForSelectedCargo.push(IncidentTypesService.INCIDENT_TYPES.postponedDelivery);
    }
    return incidentTypesForSelectedCargo.map((type) => ({
      label: `${IncidentTypesService.getIncidentTypeCode(type)} - ${IncidentTypesService.getIncidentTypeText(type)} `,
      value: type
    }));
  }, [selectedCargo]);
  const [selectedIncidentType, setSelectedIncidentType] = useState4(void 0);
  const isIncidentTypeDisabled = useMemo11(() => {
    return selectedCargo === void 0;
  }, [selectedCargo]);
  useEffect3(() => {
    setSelectedIncidentType(void 0);
  }, [selectedCargo]);
  const [loading, setLoading] = useState4(false);
  const canSubmit = !loading && selectedCargo !== void 0 && selectedIncidentType !== void 0;
  const headerText = `Reportar incidente para Env\xEDo ${shipment.externalId}`;
  const onGoback = useCallback4(() => {
    if (loading) {
      return;
    }
    onCancel();
  }, [onCancel, loading]);
  const reportIncident = useCallback4(() => __async(this, null, function* () {
    if (!selectedCargo) {
      throw new Error("No cargo selected");
    }
    if (selectedIncidentType === IncidentTypesService.INCIDENT_TYPES.incorrectAddress) {
      return reportWrongAddressIncidentForCargoApi({
        cargo: selectedCargo,
        config: config2
      });
    }
    if (selectedIncidentType === IncidentTypesService.INCIDENT_TYPES.deliveryFailed) {
      return reportDeliveryFailedIncidentForCargoApi({
        cargo: selectedCargo,
        config: config2
      });
    }
    if (selectedIncidentType === IncidentTypesService.INCIDENT_TYPES.stagedInPlatform) {
      return reportStagedInPlatformIncidentForCargoApi({
        cargo: selectedCargo,
        config: config2
      });
    }
    if (selectedIncidentType === IncidentTypesService.INCIDENT_TYPES.postponedDelivery) {
      return reportPostponedDeliveryIncidentForCargoApi({
        cargo: selectedCargo,
        config: config2
      });
    }
  }), [selectedCargo, selectedIncidentType, config2]);
  const onConfirm = useCallback4(() => __async(this, null, function* () {
    if (!selectedCargo) {
      return;
    }
    const successMessage = "Incidente reportado con \xE9xito";
    const errorMessage = "Error al reportar el incidente";
    setLoading(true);
    try {
      const response = yield reportIncident();
      if (!(response == null ? void 0 : response.ok))
        throw new Error(`Bad response reporting incident`);
      setLoading(false);
      toast3.success(successMessage);
      onSuccess();
      onCancel();
    } catch (error) {
      toast3.error(errorMessage);
      setLoading(false);
    }
  }), [selectedCargo, onSuccess, onCancel, reportIncident]);
  const hookResult = {
    loading,
    canSubmit,
    onGoback,
    onConfirm,
    headerText,
    cargoOptions,
    selectedCargoId,
    setSelectedCargoId,
    incidentTypeOptionsForSelectedCargo,
    selectedIncidentType,
    setSelectedIncidentType,
    isIncidentTypeDisabled
  };
  return hookResult;
}

// src/pages/shipments-list/incident-reporting/report-incident-modal-component.tsx
function ReportIncidentModalComponent({
  shipment,
  onSuccess,
  onCancel,
  config: config2
}) {
  const {
    canSubmit,
    loading,
    onConfirm,
    onGoback,
    headerText,
    cargoOptions,
    selectedCargoId,
    setSelectedCargoId,
    incidentTypeOptionsForSelectedCargo,
    selectedIncidentType,
    setSelectedIncidentType,
    isIncidentTypeDisabled
  } = useReportIncidentModalHook({
    shipment,
    onSuccess,
    onCancel,
    config: config2
  });
  return /* @__PURE__ */ React25.createElement(
    ModalComponent3,
    {
      bodyComponent: /* @__PURE__ */ React25.createElement(FlexComponent11, { alignSelf: "stretch", flexDirection: "column", gap: "8px" }, /* @__PURE__ */ React25.createElement(
        Input7,
        {
          handleChangeValue: (name, value) => {
            if (value !== void 0)
              setSelectedCargoId(value);
          },
          label: "Paquete a reportar",
          name: "cargo",
          options: cargoOptions,
          type: "select",
          value: selectedCargoId,
          width: "100%"
        }
      ), /* @__PURE__ */ React25.createElement(
        Input7,
        {
          handleChangeValue: (name, value) => {
            if (value !== void 0)
              setSelectedIncidentType(value);
          },
          isDisabled: isIncidentTypeDisabled,
          label: "Tipo de incidente",
          name: "incident-type",
          options: incidentTypeOptionsForSelectedCargo,
          type: "select",
          value: selectedIncidentType,
          width: "100%"
        }
      )),
      cancelButtonLabel: "Cancelar",
      confirmButtonIsLoadingLabel: "Reportando...",
      confirmButtonLabel: "Reportar",
      description: headerText,
      isCancelDisabled: loading,
      isConfirmDisabled: !canSubmit,
      isConfirmLoading: loading,
      onCancel: onGoback,
      onClose: onGoback,
      onConfirm,
      title: "Reportar incidente"
    }
  );
}

// src/pages/shipments-list/incident-reporting/report-incident-hook.tsx
var useReportIncidentHook = ({
  shipment,
  onSuccess
}) => {
  const config2 = useConfigHook();
  const openReportIncidentModal = () => __async(void 0, null, function* () {
    const { show, destroy } = yield Modal3.new({
      content: /* @__PURE__ */ React26.createElement(
        ReportIncidentModalComponent,
        {
          config: config2,
          onCancel: () => void destroy(),
          onSuccess,
          shipment
        }
      ),
      footer: null
    });
    void show();
  });
  return {
    openReportIncidentModal
  };
};

// src/pages/shipments-list/shipments-table/individual-actions/shipments-table-individual-actions-component.tsx
var StyledIndividualActionsMenuButtonComponent = styled10.div`
  min-height: 60px;
  display: flex;
  align-items: center;
  button {
    min-height: 60px;
  }
`;
function ShipmentsTableIndividualActionsComponent({
  shipment
}) {
  const isReportIncidentEnabled = canReportIncidentForShipment(shipment);
  const { openReportIncidentModal } = useReportIncidentHook({
    shipment,
    onSuccess: () => {
      void mutate3((key) => {
        return typeof key === "string" && key.startsWith("last-mile");
      });
    }
  });
  return /* @__PURE__ */ React27.createElement(
    Popover,
    {
      className: "forced-right-popover",
      content: /* @__PURE__ */ React27.createElement(IndividualActionsBodyComponent, null, /* @__PURE__ */ React27.createElement(
        IndividualActionItemComponent,
        {
          enabled: isReportIncidentEnabled,
          onClick: () => {
            if (isReportIncidentEnabled) {
              void openReportIncidentModal();
            }
          }
        },
        "Reportar incidente"
      )),
      placement: "left",
      renderOpener: ({ ref, onClick }) => /* @__PURE__ */ React27.createElement(StyledIndividualActionsMenuButtonComponent, null, /* @__PURE__ */ React27.createElement(IndividualActionsMenuButtonComponent, { onClick, ref }))
    }
  );
}

// src/pages/shipments-list/shipments-table/shipments-table-row-parent-component.tsx
function ShipmentsTableRowParentComponent({
  handleToggleAccordion,
  shipmentItem,
  isOpen,
  onGoToShipmentDetail,
  onClickShowShipmentEvents,
  isSelected = false
}) {
  var _a, _b, _c, _d, _e, _f;
  const { selectedShipments, selectShipment, unSelectShipment } = useShipmentsListSelectionHook();
  const {
    shipmentFilters: {
      shipmentSmartView: { hiddenColumns }
    }
  } = useShipmentsListFiltersHook();
  const shipmentStateColor = ShipmentsStateService.getShipmentStateColor(shipmentItem.state);
  const shipmentStateText = ShipmentsStateService.getShipmentStateText(shipmentItem.state);
  const shipmentServiceText = ShipmentsServicesService.getShipmentServiceText(shipmentItem.service);
  const isChecked = selectedShipments.some((shipment) => shipment.id === shipmentItem.id);
  const handleCheckboxChange = () => {
    if (isChecked) {
      unSelectShipment(shipmentItem);
    } else {
      selectShipment(shipmentItem);
    }
  };
  const hasMultipleDrivers = shipmentItem.drivers.length > 1;
  const driverText = shipmentItem.drivers.length > 0 ? shipmentItem.drivers[0].contactName || `Conductor ${shipmentItem.drivers[0].id}` : "";
  const networkObjectiveDatetimeText = getFormattedDateFromStringDatetime(
    shipmentItem.networkObjectiveDatetime
  );
  const centreObjectiveDatetimeText = getFormattedDateFromStringDatetime(
    shipmentItem.centreObjectiveDatetime
  );
  const createdAtText = getFormattedDateFromStringDatetime(shipmentItem.createdAt);
  const receptionDatetimeText = getFormattedDateFromStringDatetime(shipmentItem.receptionDatetime);
  const weightText = shipmentItem.weight.toFixed(2).toString();
  const background = useMemo12(() => {
    if (isOpen) {
      return "#cfdff4";
    }
    if (isSelected) {
      return "var(--otk-theme-color-grey-200, #e2e8ee)";
    }
    return "#fff";
  }, [isSelected, isOpen]);
  return /* @__PURE__ */ React28.createElement(
    FlexComponent12,
    {
      alignItems: "center",
      backgroundColor: background,
      borderTop: "1px solid var(--grey-300, #CCD7E0)"
    },
    /* @__PURE__ */ React28.createElement(
      TableCellAcordionComponent,
      {
        isOpen,
        isSelected,
        width: SHIPMENTS_TABLE_COLUMNS.accordionIndicator.width
      }
    ),
    /* @__PURE__ */ React28.createElement(
      TableCellCheckboxComponent,
      {
        handleCheckboxChange,
        isChecked,
        isOpen,
        isSelected,
        width: SHIPMENTS_TABLE_COLUMNS.checkbox.width
      }
    ),
    /* @__PURE__ */ React28.createElement(
      TableCellStateComponent,
      {
        isOpen,
        isSelected,
        onClick: () => {
          onGoToShipmentDetail && onGoToShipmentDetail(shipmentItem.id);
        },
        stateColor: shipmentStateColor,
        stateText: shipmentStateText,
        style: {
          cursor: "pointer"
        },
        width: SHIPMENTS_TABLE_COLUMNS.state.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.createdAt) && /* @__PURE__ */ React28.createElement(
      TableCellTextComponent,
      {
        isOpen,
        isSelected,
        text: createdAtText,
        width: SHIPMENTS_TABLE_COLUMNS.createdAt.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.receptionDatetime) && /* @__PURE__ */ React28.createElement(
      TableCellTextComponent,
      {
        isOpen,
        isSelected,
        text: receptionDatetimeText,
        width: SHIPMENTS_TABLE_COLUMNS.receptionDatetime.width
      }
    ),
    /* @__PURE__ */ React28.createElement(
      TableCellTextComponent,
      {
        badgeBorderColor: shipmentStateColor,
        badgeText: shipmentItem.cargosInShipmentStateCount,
        isOpen,
        isSelected,
        onClick: handleToggleAccordion,
        style: {
          cursor: "pointer"
        },
        text: shipmentItem.externalId,
        width: SHIPMENTS_TABLE_COLUMNS.externalId.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.externalReference) && /* @__PURE__ */ React28.createElement(
      TableCellTextComponent,
      {
        isOpen,
        isSelected,
        text: (_a = shipmentItem.externalReference) != null ? _a : "",
        width: SHIPMENTS_TABLE_COLUMNS.externalReference.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.senderAddress) && /* @__PURE__ */ React28.createElement(
      TableCellAddressComponent,
      {
        address: (_b = shipmentItem.senderAddress) != null ? _b : void 0,
        isOpen,
        isSelected,
        width: SHIPMENTS_TABLE_COLUMNS.senderAddress.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.deliveryAddress) && /* @__PURE__ */ React28.createElement(
      TableCellAddressComponent,
      {
        address: (_c = shipmentItem.deliveryAddress) != null ? _c : void 0,
        isOpen,
        isSelected,
        width: SHIPMENTS_TABLE_COLUMNS.deliveryAddress.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.deliveryDetails) && /* @__PURE__ */ React28.createElement(
      TableCellAddressDetailsComponent,
      {
        address: (_d = shipmentItem.deliveryAddress) != null ? _d : void 0,
        isOpen,
        isSelected,
        width: SHIPMENTS_TABLE_COLUMNS.deliveryDetails.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.billingDelegation) && /* @__PURE__ */ React28.createElement(
      TableCellDelegationComponent,
      {
        delegation: shipmentItem.billingDelegation,
        isOpen,
        isSelected,
        width: SHIPMENTS_TABLE_COLUMNS.billingDelegation.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.originDelegation) && /* @__PURE__ */ React28.createElement(
      TableCellDelegationComponent,
      {
        delegation: shipmentItem.originDelegation,
        isOpen,
        isSelected,
        width: SHIPMENTS_TABLE_COLUMNS.originDelegation.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.destinationDelegation) && /* @__PURE__ */ React28.createElement(
      TableCellDelegationComponent,
      {
        delegation: shipmentItem.destinationDelegation,
        isOpen,
        isSelected,
        width: SHIPMENTS_TABLE_COLUMNS.destinationDelegation.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.service) && /* @__PURE__ */ React28.createElement(
      TableCellTextComponent,
      {
        isOpen,
        isSelected,
        text: shipmentServiceText,
        width: SHIPMENTS_TABLE_COLUMNS.service.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.weight) && /* @__PURE__ */ React28.createElement(
      TableCellTextComponent,
      {
        isOpen,
        isSelected,
        text: weightText,
        width: SHIPMENTS_TABLE_COLUMNS.weight.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.centreObjectiveDatetime) && /* @__PURE__ */ React28.createElement(
      TableCellTextComponent,
      {
        isOpen,
        isSelected,
        text: centreObjectiveDatetimeText,
        width: SHIPMENTS_TABLE_COLUMNS.centreObjectiveDatetime.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.networkObjectiveDatetime) && /* @__PURE__ */ React28.createElement(
      TableCellTextComponent,
      {
        isOpen,
        isSelected,
        text: networkObjectiveDatetimeText,
        width: SHIPMENTS_TABLE_COLUMNS.networkObjectiveDatetime.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.shipper) && /* @__PURE__ */ React28.createElement(
      TableCellTextComponent,
      {
        isOpen,
        isSelected,
        text: (_f = (_e = shipmentItem.shipper) == null ? void 0 : _e.companyName) != null ? _f : "",
        width: SHIPMENTS_TABLE_COLUMNS.shipper.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.driver) && /* @__PURE__ */ React28.createElement(
      TooltipComponent2,
      {
        content: /* @__PURE__ */ React28.createElement("div", null, /* @__PURE__ */ React28.createElement(TooltipHeaderComponent2, null, shipmentItem.drivers.map((driver) => /* @__PURE__ */ React28.createElement("p", { key: driver.id }, driver.contactName || `Conductor ${driver.id}`)))),
        isDisabled: shipmentItem.drivers.length <= 1,
        renderOpener: (props) => /* @__PURE__ */ React28.createElement(FlexComponent12, __spreadProps(__spreadValues({}, props), { height: "100%" }), /* @__PURE__ */ React28.createElement(
          TableCellTextComponent,
          {
            badgeText: hasMultipleDrivers ? shipmentItem.cargos.length.toString() : void 0,
            isOpen,
            isSelected,
            text: driverText,
            width: SHIPMENTS_TABLE_COLUMNS.driver.width
          }
        ))
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.lastReceivedEvent) && /* @__PURE__ */ React28.createElement(
      TableCellCargoEventComponent,
      {
        cargoEvent: shipmentItem.lastReceivedEvent,
        isOpen,
        isSelected,
        width: SHIPMENTS_TABLE_COLUMNS.lastReceivedEvent.width
      }
    ),
    /* @__PURE__ */ React28.createElement(
      TableCellCargoEventComponent,
      {
        cargoEvent: shipmentItem.latestCargoEvent,
        isOpen,
        isSelected,
        onClick: () => {
          onClickShowShipmentEvents && onClickShowShipmentEvents(shipmentItem);
        },
        style: {
          cursor: "pointer"
        },
        width: `calc(${SHIPMENTS_TABLE_COLUMNS.lastUpdate.width} - 24px)`
      }
    ),
    /* @__PURE__ */ React28.createElement(ShipmentsTableIndividualActionsComponent, { shipment: shipmentItem })
  );
}

// src/pages/shipments-list/shipments-table/shipments-table-row-children-component.tsx
import React29, { useMemo as useMemo13 } from "react";
import { FlexComponent as FlexComponent13 } from "@ontruck/fe-ui";
function ShipmentsTableRowChildrenComponent({
  shipmentItem,
  cargoItem,
  isOpen = false
}) {
  var _a, _b, _c, _d, _e, _f;
  const cargoStateColor = CargoStatesService.getCargoStateColor(cargoItem.state);
  const cargoStateText = CargoStatesService.getCargoStateText(cargoItem.state);
  const shipmentServiceText = ShipmentsServicesService.getShipmentServiceText(shipmentItem.service);
  const cargoDriverText = cargoItem.driver ? cargoItem.driver.contactName || `Conductor ${cargoItem.driver.id}` : "";
  const networkObjectiveDatetimeText = getFormattedDateFromStringDatetime(
    shipmentItem.networkObjectiveDatetime
  );
  const centreObjectiveDatetimeText = getFormattedDateFromStringDatetime(
    shipmentItem.centreObjectiveDatetime
  );
  const {
    shipmentFilters: {
      shipmentSmartView: { hiddenColumns }
    }
  } = useShipmentsListFiltersHook();
  const createdAtText = getFormattedDateFromStringDatetime(shipmentItem.createdAt);
  const receptionDatetimeText = getFormattedDateFromStringDatetime(shipmentItem.receptionDatetime);
  const weightText = cargoItem.weight.toFixed(2).toString();
  const background = useMemo13(() => {
    if (isOpen) {
      return "#f2f8ff";
    }
    return "#fff";
  }, [isOpen]);
  return /* @__PURE__ */ React29.createElement(
    FlexComponent13,
    {
      alignItems: "center",
      backgroundColor: background,
      borderTop: "1px solid var(--grey-300, #CCD7E0)"
    },
    /* @__PURE__ */ React29.createElement(
      TableCellAcordionComponent,
      {
        isChildren: true,
        isOpen,
        width: SHIPMENTS_TABLE_COLUMNS.accordionIndicator.width
      }
    ),
    /* @__PURE__ */ React29.createElement(
      TableCellCheckboxComponent,
      {
        isChildren: true,
        isOpen,
        width: SHIPMENTS_TABLE_COLUMNS.checkbox.width
      }
    ),
    /* @__PURE__ */ React29.createElement(
      TableCellStateComponent,
      {
        isChildren: true,
        stateColor: cargoStateColor,
        stateText: cargoStateText,
        width: SHIPMENTS_TABLE_COLUMNS.state.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.createdAt) && /* @__PURE__ */ React29.createElement(
      TableCellTextComponent,
      {
        isChildren: true,
        text: createdAtText,
        width: SHIPMENTS_TABLE_COLUMNS.createdAt.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.receptionDatetime) && /* @__PURE__ */ React29.createElement(
      TableCellTextComponent,
      {
        isChildren: true,
        text: receptionDatetimeText,
        width: SHIPMENTS_TABLE_COLUMNS.receptionDatetime.width
      }
    ),
    /* @__PURE__ */ React29.createElement(
      TableCellTextComponent,
      {
        isChildren: true,
        text: cargoItem.externalId,
        width: SHIPMENTS_TABLE_COLUMNS.externalId.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.externalReference) && /* @__PURE__ */ React29.createElement(
      TableCellTextComponent,
      {
        isChildren: true,
        text: (_a = shipmentItem.externalReference) != null ? _a : "",
        width: SHIPMENTS_TABLE_COLUMNS.externalReference.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.senderAddress) && /* @__PURE__ */ React29.createElement(
      TableCellAddressComponent,
      {
        address: (_b = shipmentItem.senderAddress) != null ? _b : void 0,
        isChildren: true,
        width: SHIPMENTS_TABLE_COLUMNS.senderAddress.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.deliveryAddress) && /* @__PURE__ */ React29.createElement(
      TableCellAddressComponent,
      {
        address: (_c = shipmentItem.deliveryAddress) != null ? _c : void 0,
        isChildren: true,
        width: SHIPMENTS_TABLE_COLUMNS.deliveryAddress.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.deliveryDetails) && /* @__PURE__ */ React29.createElement(
      TableCellAddressDetailsComponent,
      {
        address: (_d = shipmentItem.deliveryAddress) != null ? _d : void 0,
        isChildren: true,
        width: SHIPMENTS_TABLE_COLUMNS.deliveryDetails.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.billingDelegation) && /* @__PURE__ */ React29.createElement(
      TableCellDelegationComponent,
      {
        delegation: shipmentItem.billingDelegation,
        isChildren: true,
        width: SHIPMENTS_TABLE_COLUMNS.billingDelegation.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.originDelegation) && /* @__PURE__ */ React29.createElement(
      TableCellDelegationComponent,
      {
        delegation: shipmentItem.originDelegation,
        isChildren: true,
        width: SHIPMENTS_TABLE_COLUMNS.originDelegation.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.destinationDelegation) && /* @__PURE__ */ React29.createElement(
      TableCellDelegationComponent,
      {
        delegation: shipmentItem.destinationDelegation,
        isChildren: true,
        width: SHIPMENTS_TABLE_COLUMNS.destinationDelegation.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.service) && /* @__PURE__ */ React29.createElement(
      TableCellTextComponent,
      {
        isChildren: true,
        text: shipmentServiceText,
        width: SHIPMENTS_TABLE_COLUMNS.service.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.weight) && /* @__PURE__ */ React29.createElement(
      TableCellTextComponent,
      {
        isChildren: true,
        text: weightText,
        width: SHIPMENTS_TABLE_COLUMNS.weight.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.centreObjectiveDatetime) && /* @__PURE__ */ React29.createElement(
      TableCellTextComponent,
      {
        isChildren: true,
        text: centreObjectiveDatetimeText,
        width: SHIPMENTS_TABLE_COLUMNS.centreObjectiveDatetime.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.networkObjectiveDatetime) && /* @__PURE__ */ React29.createElement(
      TableCellTextComponent,
      {
        isChildren: true,
        text: networkObjectiveDatetimeText,
        width: SHIPMENTS_TABLE_COLUMNS.networkObjectiveDatetime.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.shipper) && /* @__PURE__ */ React29.createElement(
      TableCellTextComponent,
      {
        isChildren: true,
        text: (_f = (_e = shipmentItem.shipper) == null ? void 0 : _e.companyName) != null ? _f : "",
        width: SHIPMENTS_TABLE_COLUMNS.shipper.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.driver) && /* @__PURE__ */ React29.createElement(
      TableCellTextComponent,
      {
        isChildren: true,
        text: cargoDriverText,
        width: SHIPMENTS_TABLE_COLUMNS.driver.width
      }
    ),
    !hiddenColumns.includes(AVAILABLE_COLUMNS_TO_HIDE.lastReceivedEvent) && /* @__PURE__ */ React29.createElement(
      TableCellCargoEventComponent,
      {
        cargoEvent: cargoItem.lastReceivedEvent,
        isChildren: true,
        width: SHIPMENTS_TABLE_COLUMNS.lastReceivedEvent.width
      }
    ),
    /* @__PURE__ */ React29.createElement(
      TableCellCargoEventComponent,
      {
        cargoEvent: cargoItem.latestCargoEvent,
        isChildren: true,
        width: SHIPMENTS_TABLE_COLUMNS.lastUpdate.width
      }
    )
  );
}

// src/pages/shipments-list/shipments-table/shipments-table-row-component.tsx
var RowWrapperComponent = styled11.div`
  header {
    display: flex;
    padding: unset;
    border-top: none;
    border-bottom: none;

    > div {
      flex: 1;
    }

    :hover {
      cursor: default;
    }
  }
  ${TableCellComponent10} {
    min-height: 60px;
  }
`;
var StyledAccordionComponent = styled11(AccordionComponent)`
  height: auto;
  border-left: none;
  border-right: none;
`;
var StyledAccordionTriggerComponent = styled11(AccordionTriggerComponent)`
  padding: unset;
  border-top: 3px solid
    ${({ isSelected }) => isSelected ? "var(--otk-theme-color-grey-300, #ccd6e0)" : "var(--otk-theme-color-grey-200, #e2e8ee)"};
  border-bottom: none;
`;
var StyledAccordionContentComponent = styled11(AccordionTriggerComponent)`
  padding: unset;
  border-top: none;
  border-bottom: none;
`;
function ShipmentsTableRowComponent({
  onGoToShipmentDetail,
  id,
  shipmentItem,
  onClickShowShipmentEvents,
  isSelected = false
}) {
  const [isOpen, setIsOpen] = useState5(false);
  const handleToggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  return /* @__PURE__ */ React30.createElement(RowWrapperComponent, { id }, /* @__PURE__ */ React30.createElement(StyledAccordionComponent, null, /* @__PURE__ */ React30.createElement(StyledAccordionTriggerComponent, { isSelected, open: isSelected }, /* @__PURE__ */ React30.createElement(
    ShipmentsTableRowParentComponent,
    {
      handleToggleAccordion,
      isOpen,
      isSelected,
      onClickShowShipmentEvents,
      onGoToShipmentDetail,
      shipmentItem
    }
  )), isOpen ? shipmentItem.cargos.map((cargo) => {
    return /* @__PURE__ */ React30.createElement(StyledAccordionComponent, { key: cargo.id }, /* @__PURE__ */ React30.createElement(StyledAccordionContentComponent, { open: isOpen }, /* @__PURE__ */ React30.createElement(
      ShipmentsTableRowChildrenComponent,
      {
        cargoItem: cargo,
        isOpen,
        key: cargo.id,
        shipmentItem
      }
    )));
  }) : null));
}

// src/pages/shipments-list/shipments-table/shipments-table-component.tsx
function ShipmentsTableComponent({
  shipments,
  error,
  totalShipmentsCount,
  isLoading,
  onGoToShipmentDetail,
  onClickShowShipmentEvents,
  shipmentIdShowingEvents
}) {
  const {
    shipmentFilters,
    shipmentFiltersOptions,
    handleChangePageSize,
    handleGoToPreviousPage,
    handleGoToPage,
    handleGoToNextPage
  } = useShipmentsListFiltersHook();
  const headerColumns = useMemo14(
    () => getShipmentsTableHeaderColumns({ shipments }),
    [shipments]
  );
  const headerColumnsFiltered = useMemo14(() => {
    const columnsArray = Object.entries(headerColumns).map(([key, value]) => __spreadValues({
      key
    }, value));
    const filteredColumns = columnsArray.filter(
      (column) => !shipmentFilters.shipmentSmartView.hiddenColumns.includes(column.key)
    );
    return filteredColumns.reduce(
      (acc, _a) => {
        var _b = _a, { key } = _b, value = __objRest(_b, ["key"]);
        return __spreadProps(__spreadValues({}, acc), {
          [key]: value
        });
      },
      {}
    );
  }, [headerColumns, shipmentFilters.shipmentSmartView.hiddenColumns]);
  const getShipmentsRowsComponent = useCallback5(() => {
    return shipments.map((shipmentItem) => {
      return /* @__PURE__ */ React31.createElement(
        ShipmentsTableRowComponent,
        {
          id: `shipments-list-${shipmentItem.id}`,
          isSelected: shipmentIdShowingEvents === shipmentItem.id,
          key: shipmentItem.id,
          onClickShowShipmentEvents,
          onGoToShipmentDetail,
          shipmentItem
        }
      );
    });
  }, [shipments, onGoToShipmentDetail, onClickShowShipmentEvents, shipmentIdShowingEvents]);
  return /* @__PURE__ */ React31.createElement(
    TableComponent2,
    {
      columns: headerColumnsFiltered,
      emptyStateMessage: "No se han encontrado env\xEDos",
      errorComponent: /* @__PURE__ */ React31.createElement(TableErrorComponent, { errorLabel: "Error al cargar los env\xEDos" }),
      isError: error !== void 0,
      isLoading,
      isResponsive: true,
      numberOfItems: totalShipmentsCount,
      onChangePageSize: handleChangePageSize,
      onGoToNextPage: handleGoToNextPage,
      onGoToPage: handleGoToPage,
      onGoToPreviousPage: handleGoToPreviousPage,
      pageIndex: shipmentFilters.page,
      pageSize: shipmentFilters.pageSize,
      pageSizes: shipmentFiltersOptions.paginationSizes,
      resultsPerPageLabel: "Env\xEDos por p\xE1gina",
      rowsComponents: getShipmentsRowsComponent(),
      scrollCacheKey: "shipments",
      summaryComponent: /* @__PURE__ */ React31.createElement(
        ShipmentsTableSummaryComponent,
        {
          isError: error !== void 0,
          isLoading,
          totalShipmentsCount
        }
      )
    }
  );
}

// src/pages/shipments-list/shipments-list-delegations-hook.tsx
import useSWR5 from "swr";
function getShipmentsListDelegationsApi(_0, _1) {
  return __async(this, arguments, function* ({ token, apiBase }, myDelegationId) {
    const baseURL = `${apiBase}/v1/fleet/delegations/`;
    let url;
    if (myDelegationId) {
      url = `${baseURL}?delegation=${myDelegationId}`;
    } else {
      url = baseURL;
    }
    const response = yield fetch(url, {
      method: "GET",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!response.ok) {
      throw new Error("Failed to fetch shipments");
    }
    return yield response.json();
  });
}
function getShipmentsListDelegationsMapper(delegations) {
  return delegations.map((d) => ({
    id: d.id,
    name: d.name,
    city: d.city,
    zipCode: d.zip_code,
    address: d.warehouse_address
  }));
}
function getShipmentsListDelegationsFetcher(config2, myDelegationId) {
  return getShipmentsListDelegationsApi(config2, myDelegationId);
}
var RELOAD_SHIPMENTS_LIST_DELEGATIONS_INTERVAL_IN_SECONDS = 30;
var useShipmentsListDelegationsHook = ({
  myDelegationId
}) => {
  var _a;
  const key = `last-mile/shipments/delegations/${myDelegationId}`;
  const config2 = useConfigHook();
  const fetcher = () => __async(void 0, null, function* () {
    return getShipmentsListDelegationsFetcher(config2, myDelegationId);
  });
  const { data, error, isLoading } = useSWR5(key, fetcher, {
    refreshInterval: RELOAD_SHIPMENTS_LIST_DELEGATIONS_INTERVAL_IN_SECONDS * 1e3,
    revalidateIfStale: true
  });
  const delegationsMapped = data ? getShipmentsListDelegationsMapper(data.results) : [];
  const totalDelegationsCount = (_a = data == null ? void 0 : data.count) != null ? _a : 0;
  return {
    delegations: delegationsMapped,
    isLoading,
    error,
    totalDelegationsCount
  };
};

// src/pages/shipments-list/shipments-list-page.tsx
function ShipmentsListPage({
  onGoToShipmentDetail,
  onGoToSmartViews
}) {
  const {
    shipmentFilters,
    setShipmentsSmartViews,
    shipmentsSmartViews,
    handleChangeShipmentSmartView
  } = useShipmentsListFiltersHook();
  const availableShipmentsSmartViews = useSmartViewsDataHook("shipments");
  useEffect4(() => {
    const availableShipmentsSmartViewsIds = availableShipmentsSmartViews.map(
      (smartView) => smartView.id
    );
    const currentShipmentsSmartViewsIds = shipmentsSmartViews.map((smartView) => smartView.id);
    const hasDifferentLength = availableShipmentsSmartViewsIds.length !== currentShipmentsSmartViewsIds.length;
    const hasDifferentIds = availableShipmentsSmartViewsIds.some((id) => !currentShipmentsSmartViewsIds.includes(id)) || currentShipmentsSmartViewsIds.some((id) => !availableShipmentsSmartViewsIds.includes(id));
    if (hasDifferentLength || hasDifferentIds) {
      setShipmentsSmartViews(availableShipmentsSmartViews);
      const currentSmartView = shipmentFilters.shipmentSmartView;
      if (!availableShipmentsSmartViewsIds.includes(currentSmartView.id)) {
        handleChangeShipmentSmartView(DEFAULT_SHIPMENT_SMART_VIEW);
      }
    }
  }, [
    availableShipmentsSmartViews,
    handleChangeShipmentSmartView,
    setShipmentsSmartViews,
    shipmentFilters.shipmentSmartView,
    shipmentsSmartViews
  ]);
  const { selectedDelegationId } = useMyDelegationHook();
  const { delegations } = useShipmentsListDelegationsHook({
    myDelegationId: selectedDelegationId
  });
  const { unSelectAllShipments } = useShipmentsListSelectionHook();
  const { shipments, isLoading, error, totalShipmentsCount } = useShipmentsListDataHook({
    shipmentFilters,
    myDelegationId: selectedDelegationId
  });
  useEffect4(() => {
    unSelectAllShipments();
  }, [shipmentFilters, unSelectAllShipments]);
  const [topBarModuleMyDelegationNode, setTopBarModuleMyDelegationNode] = useState6(
    null
  );
  useEffect4(() => {
    if (topBarModuleMyDelegationNode) {
      return;
    }
    const node = document.getElementById(TOP_BAR_MODULE_MY_DELEGATION_ID);
    if (!node) {
      console.error(`Node with id ${TOP_BAR_MODULE_MY_DELEGATION_ID} not found`);
      return;
    }
    setTopBarModuleMyDelegationNode(node);
  }, [topBarModuleMyDelegationNode, setTopBarModuleMyDelegationNode]);
  return /* @__PURE__ */ React32.createElement(PageLayout, null, topBarModuleMyDelegationNode ? createPortal(/* @__PURE__ */ React32.createElement(MyDelegationComponent, null), topBarModuleMyDelegationNode) : null, /* @__PURE__ */ React32.createElement(
    ShipmentsListToolbarComponent,
    {
      delegations,
      onGoToSmartViews
    }
  ), /* @__PURE__ */ React32.createElement(PageContent, null, /* @__PURE__ */ React32.createElement(
    ShipmentsTableComponent,
    {
      error,
      isLoading,
      onGoToShipmentDetail,
      shipments,
      totalShipmentsCount
    }
  )), /* @__PURE__ */ React32.createElement(Toaster, { richColors: true }));
}

// src/pages/incidents-list/incidents-list-page.tsx
import React46, { useEffect as useEffect5, useState as useState9 } from "react";
import { PageContent as PageContent2, PageLayout as PageLayout2 } from "@ontruck/fe-ui";
import { Toaster as Toaster2 } from "sonner";
import { createPortal as createPortal2 } from "react-dom";

// src/pages/incidents-list/incidents-list-data-hook.tsx
import useSWR6 from "swr";

// src/business/incidents/get-incidents-api.ts
var getIncidentsQueryFromIncidentFilters = (incidentFilters, myDelegationId) => {
  let query = `?page_size=${incidentFilters.pageSize}&page=${incidentFilters.page}&ordering=-id`;
  if (incidentFilters.search.trim() !== "") {
    query += `&shipment_search=${incidentFilters.search}`;
  }
  if (incidentFilters.resolved.trim() !== "") {
    query += `&resolved=${incidentFilters.resolved}`;
  }
  if (incidentFilters.destinationZipCode.trim() !== "") {
    query += `&shipment_destination_zipcode=${incidentFilters.destinationZipCode}`;
  }
  if (myDelegationId !== "") {
    query += `&delegation=${myDelegationId}`;
  }
  return query;
};
function getIncidentsApi(_0, _1, _2) {
  return __async(this, arguments, function* ({ token, apiBase }, incidentFilters, myDelegationId) {
    const baseURL = `${apiBase}/v1/fleet/incidents/`;
    const queryParams = getIncidentsQueryFromIncidentFilters(incidentFilters, myDelegationId);
    const url = `${baseURL}${queryParams}`;
    const response = yield fetch(url, {
      method: "GET",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!response.ok) {
      throw new Error("Failed to fetch incidents");
    }
    return yield response.json();
  });
}

// src/business/incidents/get-incidents-fetcher.ts
var getIncidentsFetcher = (config2, incidentFilters, myDelegationId) => {
  return getIncidentsApi(config2, incidentFilters, myDelegationId);
};

// src/business/incidents/incident-mapper.ts
function incidentCarrierMapper(incidentCarrierDto) {
  if (!incidentCarrierDto) {
    return;
  }
  return {
    id: incidentCarrierDto.id.toString(),
    name: incidentCarrierDto.name
  };
}
function incidentCreatedByMapper(incidentCreatedByDto) {
  return {
    id: incidentCreatedByDto.id.toString(),
    username: incidentCreatedByDto.username,
    type: incidentCreatedByDto.type,
    firstName: incidentCreatedByDto.first_name,
    lastName: incidentCreatedByDto.last_name,
    phone: incidentCreatedByDto.phone,
    carrier: incidentCarrierMapper(incidentCreatedByDto.carrier)
  };
}
function incidentResolutionMapper(incidentResolutionDto) {
  if (!incidentResolutionDto) {
    return null;
  }
  return {
    id: incidentResolutionDto.id.toString()
  };
}
function incidentShipmentMapper(incidentShipmentDto) {
  if (!incidentShipmentDto) {
    return null;
  }
  return {
    id: incidentShipmentDto.id.toString(),
    externalId: incidentShipmentDto.external_id,
    billingDelegation: incidentShipmentDto.billing_delegation ? delegationMapper(incidentShipmentDto.billing_delegation) : void 0,
    originDelegation: incidentShipmentDto.origin_delegation ? delegationMapper(incidentShipmentDto.origin_delegation) : void 0,
    destinationDelegation: incidentShipmentDto.destination_delegation ? delegationMapper(incidentShipmentDto.destination_delegation) : void 0,
    deliveryAddress: incidentShipmentDto.delivery_address ? addressMapper(incidentShipmentDto.delivery_address) : null
  };
}
function incidentCargoMapper(incidentCargoDto) {
  return {
    id: incidentCargoDto.id.toString(),
    state: incidentCargoDto.state,
    externalId: incidentCargoDto.external_id || "",
    events: incidentCargoDto.events.map(cargoEventMapper),
    shipment: incidentShipmentMapper(incidentCargoDto.shipment)
  };
}
function incidentTypeMapper(incidentTypeDto) {
  if (!incidentTypeDto) {
    return;
  }
  return incidentTypeDto;
}
function incidentDriverMapper(incidentDriverDto) {
  if (!incidentDriverDto) {
    return;
  }
  return {
    id: incidentDriverDto.id.toString(),
    contactName: incidentDriverDto.contact_name
  };
}
function incidentMapper(incidentDto) {
  return {
    id: incidentDto.id.toString(),
    createdBy: incidentCreatedByMapper(incidentDto.created_by),
    createdAt: incidentDto.created_at,
    resolved: incidentDto.resolved,
    resolution: incidentResolutionMapper(incidentDto.resolution),
    cargo: incidentCargoMapper(incidentDto.cargo),
    code: incidentDto.code,
    incidentType: incidentTypeMapper(incidentDto.incident_type),
    driver: incidentDriverMapper(incidentDto.driver),
    acceptsSimpleResolution: incidentDto.accepts_simple_resolution || false
  };
}

// src/business/incidents/get-incidents-mapper.ts
function getIncidentsMapper(incidentsDtos) {
  const incidents = incidentsDtos.map((i) => {
    try {
      return incidentMapper(i);
    } catch (e) {
      console.error("Error incident shippment with id ", i.id);
      console.error(e);
      throw e;
    }
  });
  return incidents;
}

// src/pages/incidents-list/incidents-list-data-hook.tsx
var RELOAD_INCIDENTS_LIST_INTERVAL_IN_SECONDS = 30;
var useIncidentsListDataHook = ({
  incidentFilters,
  myDelegationId
}) => {
  var _a;
  const key = `last-mile/incidents/${JSON.stringify(incidentFilters)}/${myDelegationId}`;
  const config2 = useConfigHook();
  const fetcher = () => __async(void 0, null, function* () {
    return getIncidentsFetcher(config2, incidentFilters, myDelegationId);
  });
  const { data, error, isLoading } = useSWR6(key, fetcher, {
    refreshInterval: RELOAD_INCIDENTS_LIST_INTERVAL_IN_SECONDS * 1e3,
    revalidateIfStale: true
  });
  const incidentsMapped = data ? getIncidentsMapper(data.results) : [];
  const totalIncidentsCount = (_a = data == null ? void 0 : data.count) != null ? _a : 0;
  return {
    incidents: incidentsMapped,
    isLoading,
    error,
    totalIncidentsCount
  };
};

// src/pages/incidents-list/incidents-list-toolbar-component.tsx
import React34 from "react";

// src/pages/incidents-list/incidents-filters/incident-filters-component.tsx
import React33 from "react";
import { Input as Input8 } from "@ontruck/fe-ui";

// src/pages/incidents-list/incidents-list-filters-hook.tsx
import { createStore as createStore4 } from "zustand";
import { useZustand as useZustand4 } from "use-zustand";

// src/pages/incidents-list/incidents-filters/incident-filters-options.ts
var INCIDENT_FILTERS_PAGINATION_SIZES = [20, 50, 100, 200];
var getIncidentFiltersOptions = () => {
  return {
    paginationSizes: INCIDENT_FILTERS_PAGINATION_SIZES
  };
};

// src/pages/incidents-list/incidents-filters/incident-filters-default-values.ts
var INCIDENT_FILTERS_DEFAULT_VALUES = {
  destinationZipCode: "",
  page: 1,
  pageSize: INCIDENT_FILTERS_PAGINATION_SIZES[0],
  search: "",
  resolved: ""
};

// src/pages/incidents-list/incidents-list-filters-hook.tsx
var getInitialIncidentFilters = () => {
  const defaultIncidentFilters = INCIDENT_FILTERS_DEFAULT_VALUES;
  const initialIncidentFilters = __spreadValues({}, defaultIncidentFilters);
  return initialIncidentFilters;
};
var incidentsListFiltersStore = createStore4((set) => ({
  incidentFilters: getInitialIncidentFilters(),
  incidentFiltersOptions: getIncidentFiltersOptions(),
  handleChangePageSize: (pageSize) => {
    set((state) => __spreadProps(__spreadValues({}, state), { incidentFilters: __spreadProps(__spreadValues({}, state.incidentFilters), { pageSize }) }));
  },
  handleGoToPreviousPage: () => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      incidentFilters: __spreadProps(__spreadValues({}, state.incidentFilters), { page: state.incidentFilters.page - 1 })
    }));
  },
  handleGoToPage: (pageIndex) => {
    set((state) => __spreadProps(__spreadValues({}, state), { incidentFilters: __spreadProps(__spreadValues({}, state.incidentFilters), { page: pageIndex }) }));
  },
  handleGoToNextPage: () => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      incidentFilters: __spreadProps(__spreadValues({}, state.incidentFilters), { page: state.incidentFilters.page + 1 })
    }));
  },
  handleChangeService: (newService) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      incidentFilters: __spreadProps(__spreadValues({}, state.incidentFilters), { service: newService, page: 1 })
    }));
  },
  handleChangeSearch: (newSearch) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      incidentFilters: __spreadProps(__spreadValues({}, state.incidentFilters), { search: newSearch, page: 1 })
    }));
  },
  handleChangeDestinationZipCode: (newDestinationZipCode) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      incidentFilters: __spreadProps(__spreadValues({}, state.incidentFilters), {
        destinationZipCode: newDestinationZipCode,
        page: 1
      })
    }));
  },
  handleChangeResolved: (newResolved) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      incidentFilters: __spreadProps(__spreadValues({}, state.incidentFilters), { resolved: newResolved, page: 1 })
    }));
  }
}));
var useIncidentsListFiltersHook = () => {
  const incidentFilters = useZustand4(incidentsListFiltersStore, (state) => state.incidentFilters);
  const incidentFiltersOptions = useZustand4(
    incidentsListFiltersStore,
    (state) => state.incidentFiltersOptions
  );
  const handleChangePageSize = useZustand4(
    incidentsListFiltersStore,
    (state) => state.handleChangePageSize
  );
  const handleGoToPreviousPage = useZustand4(
    incidentsListFiltersStore,
    (state) => state.handleGoToPreviousPage
  );
  const handleGoToPage = useZustand4(incidentsListFiltersStore, (state) => state.handleGoToPage);
  const handleGoToNextPage = useZustand4(
    incidentsListFiltersStore,
    (state) => state.handleGoToNextPage
  );
  const handleChangeService = useZustand4(
    incidentsListFiltersStore,
    (state) => state.handleChangeService
  );
  const handleChangeSearch = useZustand4(
    incidentsListFiltersStore,
    (state) => state.handleChangeSearch
  );
  const handleChangeDestinationZipCode = useZustand4(
    incidentsListFiltersStore,
    (state) => state.handleChangeDestinationZipCode
  );
  const handleChangeResolved = useZustand4(
    incidentsListFiltersStore,
    (state) => state.handleChangeResolved
  );
  return {
    incidentFilters,
    incidentFiltersOptions,
    handleChangePageSize,
    handleGoToPreviousPage,
    handleGoToPage,
    handleGoToNextPage,
    handleChangeService,
    handleChangeSearch,
    handleChangeDestinationZipCode,
    handleChangeResolved
  };
};

// src/pages/incidents-list/incidents-filters/incident-filters-component.tsx
function IncidentFiltersComponent() {
  const {
    incidentFilters,
    handleChangeResolved,
    handleChangeSearch,
    handleChangeDestinationZipCode
  } = useIncidentsListFiltersHook();
  const resolvedOptions = [
    {
      label: "Todos",
      value: ""
    },
    {
      label: "Resueltos",
      value: "true"
    },
    {
      label: "No resueltos",
      value: "false"
    }
  ];
  return /* @__PURE__ */ React33.createElement(FiltersContainerComponent, null, /* @__PURE__ */ React33.createElement(ResponsiveInputsContainerComponent, null, /* @__PURE__ */ React33.createElement(
    Input8,
    {
      handleChangeValue: (name, value) => {
        if (value !== void 0)
          handleChangeResolved(value);
      },
      label: "Estado",
      name: "state",
      options: resolvedOptions,
      type: "select",
      value: incidentFilters.resolved,
      width: FILTERS_CONFIG.STATE.width
    }
  ), /* @__PURE__ */ React33.createElement(
    Input8,
    {
      handleChangeEvent: (e) => {
        const event = e;
        const newValue = event.target.value;
        handleChangeDestinationZipCode(newValue);
      },
      label: "CP de entrega",
      name: "destination-zip-code",
      type: "text",
      value: incidentFilters.destinationZipCode,
      width: FILTERS_CONFIG.DESTINATION_ZIP_CODE.width
    }
  ), /* @__PURE__ */ React33.createElement(
    Input8,
    {
      handleChangeEvent: (e) => {
        const event = e;
        const newValue = event.target.value;
        handleChangeSearch(newValue);
      },
      label: "B\xFAsqueda",
      name: "search",
      type: "search",
      value: incidentFilters.search,
      width: FILTERS_CONFIG.SEARCH.width
    }
  )));
}

// src/pages/incidents-list/incidents-list-toolbar-component.tsx
function IncidentsListToolbarComponent() {
  return /* @__PURE__ */ React34.createElement(CustomToolbarComponent, null, /* @__PURE__ */ React34.createElement(CustomToolbarContentComponent, null, /* @__PURE__ */ React34.createElement(IncidentFiltersComponent, null)));
}

// src/pages/incidents-list/incidents-list-selection-hook.tsx
import { createStore as createStore5 } from "zustand";
import { useZustand as useZustand5 } from "use-zustand";
var incidentsListSelectionStore = createStore5((set) => ({
  selectedIncidents: [],
  selectIncident: (incident) => {
    set((state) => ({ selectedIncidents: [...state.selectedIncidents, incident] }));
  },
  unSelectIncident: (incident) => {
    set((state) => ({
      selectedIncidents: state.selectedIncidents.filter((s) => s.id !== incident.id)
    }));
  },
  selectAllIncidents: (incidents) => {
    set(() => ({ selectedIncidents: incidents }));
  },
  unSelectAllIncidents: () => {
    set({ selectedIncidents: [] });
  }
}));
var useIncidentsListSelectionHook = () => {
  const selectedIncidents = useZustand5(
    incidentsListSelectionStore,
    (state) => state.selectedIncidents
  );
  const selectIncident = useZustand5(incidentsListSelectionStore, (state) => state.selectIncident);
  const unSelectIncident = useZustand5(
    incidentsListSelectionStore,
    (state) => state.unSelectIncident
  );
  const selectAllIncidents = useZustand5(
    incidentsListSelectionStore,
    (state) => state.selectAllIncidents
  );
  const unSelectAllIncidents = useZustand5(
    incidentsListSelectionStore,
    (state) => state.unSelectAllIncidents
  );
  return {
    selectedIncidents,
    selectIncident,
    unSelectIncident,
    selectAllIncidents,
    unSelectAllIncidents
  };
};

// src/pages/incidents-list/incidents-table/incidents-table-component.tsx
import React45, { useCallback as useCallback9, useMemo as useMemo16 } from "react";
import { TableComponent as TableComponent3, TableErrorComponent as TableErrorComponent2 } from "@ontruck/fe-ui";

// src/pages/incidents-list/incidents-table/incidents-table-summary-component.tsx
import React35 from "react";
import { FlexComponent as FlexComponent14, TableCellComponent as TableCellComponent11, TextComponent as TextComponent10 } from "@ontruck/fe-ui";
import styled12 from "styled-components";
var FixedSummaryWrapperComponent2 = styled12(FlexComponent14)`
  position: relative;
  width: 100%;
`;
var FixedSummaryContainerComponent2 = styled12(FlexComponent14)`
  position: fixed;
  left: 0;
  right: 0;
  width: 100%;
  background-color: white;
`;
function IncidentsTableSummaryComponent({
  isLoading,
  isError,
  totalIncidentsCount
}) {
  const { selectedIncidents } = useIncidentsListSelectionHook();
  const selectedCount = selectedIncidents.length;
  return /* @__PURE__ */ React35.createElement(
    FixedSummaryWrapperComponent2,
    {
      alignItems: "center",
      backgroundColor: "white",
      height: "40px",
      width: "100%"
    },
    !isLoading && !isError && /* @__PURE__ */ React35.createElement(
      FixedSummaryContainerComponent2,
      {
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%"
      },
      /* @__PURE__ */ React35.createElement(FlexComponent14, null, /* @__PURE__ */ React35.createElement(TableCellComponent11, { borderRight: "1px solid var(--grey-200, #E2E8EE);", padding: "0 16px" }, /* @__PURE__ */ React35.createElement(TextComponent10, { color: "var(--grey-500, #94A6B8)", fontSize: "12px", fontWeight: 500 }, "Total: ", totalIncidentsCount)), /* @__PURE__ */ React35.createElement(TableCellComponent11, { padding: "0 16px" }, /* @__PURE__ */ React35.createElement(TextComponent10, { color: "var(--grey-500, #94A6B8)", fontSize: "12px", fontWeight: 500 }, "Seleccionados: ", selectedCount)))
    )
  );
}

// src/pages/incidents-list/incidents-table/incidents-table-header-columns.tsx
import React37 from "react";

// src/pages/incidents-list/incidents-table/incidents-table-columns.ts
var INCIDENTS_TABLE_COLUMNS = {
  accordionIndicator: {
    id: "1",
    width: "16px"
  },
  checkbox: {
    id: "2",
    width: "45px",
    alignment: "center"
  },
  state: {
    id: "3",
    width: "192px",
    label: "ESTADO"
  },
  code: {
    id: "4",
    width: "208px",
    label: "COD."
  },
  incidentType: {
    id: "5",
    width: "248px",
    label: "TIPO DE INCIDENTE"
  },
  externalId: {
    id: "6",
    width: "208px",
    label: "ENV\xCDO"
  },
  cargo: {
    id: "7",
    width: "208px",
    label: "BULTO"
  },
  deliveryAddress: {
    id: "8",
    width: "180px",
    label: "DESTINATARIO"
  },
  billingDelegation: {
    id: "9",
    width: "180px",
    label: "CS. CARGO"
  },
  originDelegation: {
    id: "10",
    width: "180px",
    label: "CS. ORIGEN"
  },
  destinationDelegation: {
    id: "11",
    width: "180px",
    label: "CS. DESTINO"
  },
  driver: {
    id: "12",
    width: "192px",
    label: "CONDUCTOR ASIGNADO"
  },
  lastUpdate: {
    id: "13",
    width: "288px",
    label: "\xDALTIMA ACTUALIZACI\xD3N",
    group: "right"
  }
};

// src/pages/incidents-list/incidents-table/incidents-table-header-checkbox-component.tsx
import React36 from "react";
function IncidentsTableHeaderCheckboxComponent({
  incidents
}) {
  const { selectedIncidents, selectAllIncidents, unSelectAllIncidents } = useIncidentsListSelectionHook();
  const isAllSelected = incidents.length > 0 && selectedIncidents.length === incidents.length;
  return /* @__PURE__ */ React36.createElement(
    "input",
    {
      checked: isAllSelected,
      onChange: () => {
        if (isAllSelected) {
          unSelectAllIncidents();
        } else {
          selectAllIncidents(incidents);
        }
      },
      type: "checkbox"
    }
  );
}

// src/pages/incidents-list/incidents-table/incidents-table-header-columns.tsx
var getIncidentsTableHeaderColumns = ({
  incidents
}) => {
  const columns = INCIDENTS_TABLE_COLUMNS;
  columns.checkbox.cellComponent = /* @__PURE__ */ React37.createElement(IncidentsTableHeaderCheckboxComponent, { incidents });
  return columns;
};

// src/pages/incidents-list/incidents-table/incidents-table-row-component.tsx
import React44 from "react";
import { AccordionComponent as AccordionComponent2, AccordionTriggerComponent as AccordionTriggerComponent2, TableCellComponent as TableCellComponent12 } from "@ontruck/fe-ui";
import styled15 from "styled-components";

// src/pages/incidents-list/incidents-table/incidents-table-row-parent-component.tsx
import React43 from "react";
import { FlexComponent as FlexComponent17 } from "@ontruck/fe-ui";

// src/pages/incidents-list/incidents-table/individual-actions/incidents-table-individual-actions-component.tsx
import React42, { useCallback as useCallback8 } from "react";
import {
  Popover as Popover2,
  IndividualActionsBodyComponent as IndividualActionsBodyComponent2,
  IndividualActionItemComponent as IndividualActionItemComponent2,
  IndividualActionsMenuButtonComponent as IndividualActionsMenuButtonComponent2
} from "@ontruck/fe-ui";
import { mutate as mutate4 } from "swr";
import styled14 from "styled-components";

// src/pages/incidents-list/incident-solving/solve-delivery-failed/solve-delivery-failed-hook.tsx
import React39 from "react";
import { Modal as Modal4 } from "react-async-popup";

// src/pages/incidents-list/incident-solving/solve-delivery-failed/solve-delivery-failed-modal-component.tsx
import React38 from "react";
import { FlexComponent as FlexComponent15, Input as Input9, ModalComponent as ModalComponent4 } from "@ontruck/fe-ui";

// src/components/modals/modal-body-error-text.tsx
import styled13 from "styled-components";
var ModalBodyErrorText = styled13.div`
  align-self: stretch;
  color: var(--01, #d31b4c);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

// src/pages/incidents-list/incident-solving/solve-delivery-failed/solve-delivery-failed-modal-hook.tsx
import { useCallback as useCallback6, useMemo as useMemo15, useState as useState7 } from "react";
import { toast as toast4 } from "sonner";

// src/business/shared/get-datetime-string-from-date-string.ts
var getDatetimeStringFromDateString = (dateString) => {
  const date = new Date(dateString);
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date.getUTCSeconds()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
};

// src/pages/incidents-list/incident-solving/solve-delivery-failed/solve-delivery-failed-api.ts
function solveDeliveryFailedApi(_0) {
  return __async(this, arguments, function* ({
    incident,
    newDeliveryDeadline,
    newAddress,
    config: config2
  }) {
    const endpoint = `${config2.apiBase}/v1/fleet/incidents/${incident.id}/arrange_new_delivery/`;
    const body = {
      new_delivery_deadline: newDeliveryDeadline,
      new_address_attributes: newAddress
    };
    return fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config2.token}`
      },
      body: JSON.stringify(body)
    });
  });
}

// src/pages/incidents-list/incident-solving/solve-delivery-failed/solve-delivery-failed-modal-hook.tsx
var getInitialDate = () => {
  const date = /* @__PURE__ */ new Date();
  date.setDate(date.getDate() + 1);
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
function useSolveDeliveryFailedModalHook({
  incident,
  onSuccess,
  onCancel,
  config: config2,
  withAddress = false
}) {
  var _a;
  const [loading, setLoading] = useState7(false);
  const initialDate = useMemo15(() => getInitialDate(), []);
  const [newDeliveryDeadline, setNewDeliveryDeadline] = useState7(initialDate);
  const hasDateError = useMemo15(() => {
    return new Date(newDeliveryDeadline) < new Date(initialDate);
  }, [newDeliveryDeadline, initialDate]);
  const [addressLine, setAddressLine] = useState7("");
  const hasAddressLineError = useMemo15(() => {
    return addressLine.trim().length === 0;
  }, [addressLine]);
  const [city, setCity] = useState7("");
  const hasCityError = useMemo15(() => {
    return city.trim().length === 0;
  }, [city]);
  const [zipcode, setZipcode] = useState7("");
  const hasZipcodeError = useMemo15(() => {
    return zipcode.trim().length === 0;
  }, [zipcode]);
  const [hasBackendError, setHasBackendError] = useState7(false);
  const hasAddressError = withAddress ? hasAddressLineError || hasCityError || hasZipcodeError : false;
  const canSubmit = !loading && !hasDateError && !hasAddressError;
  const headerText = `Env\xEDo ${((_a = incident.cargo.shipment) == null ? void 0 : _a.externalId) || ""} Paquete ${incident.cargo.externalId}`;
  const onGoback = useCallback6(() => {
    if (loading) {
      return;
    }
    onCancel();
  }, [onCancel, loading]);
  const onConfirm = useCallback6(() => __async(this, null, function* () {
    if (!newDeliveryDeadline) {
      return;
    }
    const successMessage = "Incidente resuelto con \xE9xito";
    const errorMessage = "Error al resolver el incidente";
    setLoading(true);
    setHasBackendError(false);
    const newDeliverDeadlineDatetimeString = getDatetimeStringFromDateString(newDeliveryDeadline);
    try {
      const newAddress = withAddress ? {
        address_line: addressLine,
        city,
        zipcode
      } : void 0;
      const response = yield solveDeliveryFailedApi({
        incident,
        newDeliveryDeadline: newDeliverDeadlineDatetimeString,
        newAddress,
        config: config2
      });
      if (!response.ok)
        throw new Error(`Bad response solving delivery failed`);
      setLoading(false);
      toast4.success(successMessage);
      onSuccess();
      onCancel();
    } catch (error) {
      setHasBackendError(true);
      toast4.error(errorMessage);
      setLoading(false);
    }
  }), [
    newDeliveryDeadline,
    withAddress,
    addressLine,
    city,
    zipcode,
    incident,
    config2,
    onSuccess,
    onCancel
  ]);
  const hookResult = {
    loading,
    canSubmit,
    onGoback,
    onConfirm,
    headerText,
    newDeliveryDeadline,
    setNewDeliveryDeadline,
    hasDateError,
    addressLine,
    setAddressLine,
    city,
    setCity,
    zipcode,
    setZipcode,
    hasBackendError
  };
  return hookResult;
}

// src/pages/incidents-list/incident-solving/solve-delivery-failed/solve-delivery-failed-modal-component.tsx
function SolveDeliveryFailedModalComponent({
  incident,
  onSuccess,
  onCancel,
  config: config2,
  withAddress = false
}) {
  const {
    canSubmit,
    loading,
    onConfirm,
    onGoback,
    headerText,
    newDeliveryDeadline,
    setNewDeliveryDeadline,
    hasDateError,
    addressLine,
    setAddressLine,
    city,
    setCity,
    zipcode,
    setZipcode,
    hasBackendError
  } = useSolveDeliveryFailedModalHook({
    incident,
    onSuccess,
    onCancel,
    config: config2,
    withAddress
  });
  return /* @__PURE__ */ React38.createElement(
    ModalComponent4,
    {
      bodyComponent: /* @__PURE__ */ React38.createElement(FlexComponent15, { alignSelf: "stretch", flexDirection: "column", gap: "8px" }, /* @__PURE__ */ React38.createElement(FlexComponent15, { alignSelf: "stretch", flexDirection: "column", gap: "8px" }, /* @__PURE__ */ React38.createElement(ModalBodyRegularText, null, "Nueva fecha de reparto:"), /* @__PURE__ */ React38.createElement(
        Input9,
        {
          disableClear: true,
          handleChangeValue: (name, value) => {
            if (!value) {
              return;
            }
            const newDate = new Date(value);
            const newDateNormalized = new Date(newDate.setHours(0, 0, 0, 0));
            const newDateFrom = getDateStringFromJavascriptDate(newDateNormalized);
            setNewDeliveryDeadline(newDateFrom);
          },
          label: "Nueva fecha de reparto",
          name: "new-delivery-deadline",
          type: "date",
          value: newDeliveryDeadline
        }
      ), hasDateError ? /* @__PURE__ */ React38.createElement(ModalBodyErrorText, null, "La fecha de reparto no puede ser anterior al d\xEDa siguiente") : null), withAddress ? /* @__PURE__ */ React38.createElement(FlexComponent15, { flexDirection: "column", gap: "8px", width: "100%" }, /* @__PURE__ */ React38.createElement(ModalBodyRegularText, null, "Direcci\xF3n:"), /* @__PURE__ */ React38.createElement(FlexComponent15, { width: "100%" }, /* @__PURE__ */ React38.createElement(
        Input9,
        {
          handleChangeEvent: (e) => {
            const event = e;
            const newValue = event.target.value;
            setAddressLine(newValue);
          },
          label: "Direcci\xF3n",
          name: "address-line",
          type: "text",
          value: addressLine
        }
      )), /* @__PURE__ */ React38.createElement(FlexComponent15, { width: "100%" }, /* @__PURE__ */ React38.createElement(
        Input9,
        {
          handleChangeEvent: (e) => {
            const event = e;
            const newValue = event.target.value;
            setCity(newValue);
          },
          label: "Ciudad",
          name: "city",
          type: "text",
          value: city
        }
      )), /* @__PURE__ */ React38.createElement(FlexComponent15, { width: "100%" }, /* @__PURE__ */ React38.createElement(
        Input9,
        {
          handleChangeEvent: (e) => {
            const event = e;
            const newValue = event.target.value;
            setZipcode(newValue);
          },
          label: "C\xF3digo postal",
          name: "zipcode",
          type: "text",
          value: zipcode
        }
      )), hasBackendError ? /* @__PURE__ */ React38.createElement(ModalBodyErrorText, null, "La nueva direcci\xF3n no es v\xE1lida") : null) : null),
      cancelButtonLabel: "Cancelar",
      confirmButtonIsLoadingLabel: "Resolviendo...",
      confirmButtonLabel: "Resolver",
      description: headerText,
      isCancelDisabled: loading,
      isConfirmDisabled: !canSubmit,
      isConfirmLoading: loading,
      onCancel: onGoback,
      onClose: onGoback,
      onConfirm,
      title: "Resolver incidente"
    }
  );
}

// src/pages/incidents-list/incident-solving/solve-delivery-failed/solve-delivery-failed-hook.tsx
var useSolveDeliveryFailedHook = ({
  incident,
  onSuccess
}) => {
  const config2 = useConfigHook();
  const openSolveDeliveryFailedModal = (withAddress) => __async(void 0, null, function* () {
    const { show, destroy } = yield Modal4.new({
      content: /* @__PURE__ */ React39.createElement(
        SolveDeliveryFailedModalComponent,
        {
          config: config2,
          incident,
          onCancel: () => void destroy(),
          onSuccess,
          withAddress: withAddress != null ? withAddress : false
        }
      ),
      footer: null
    });
    void show();
  });
  return {
    openSolveDeliveryFailedModal
  };
};

// src/pages/incidents-list/incident-solving/solve-staged-in-platform/solve-staged-in-platform-hook.tsx
import React41 from "react";
import { Modal as Modal5 } from "react-async-popup";

// src/pages/incidents-list/incident-solving/solve-staged-in-platform/solve-staged-in-platform-modal-component.tsx
import React40 from "react";
import { FlexComponent as FlexComponent16, ModalComponent as ModalComponent5 } from "@ontruck/fe-ui";

// src/pages/incidents-list/incident-solving/solve-staged-in-platform/solve-staged-in-platform-modal-hook.tsx
import { useCallback as useCallback7, useState as useState8 } from "react";
import { toast as toast5 } from "sonner";

// src/pages/incidents-list/incident-solving/solve-staged-in-platform/solve-staged-in-platform-api.ts
function solveStagedInPlatformApi(_0) {
  return __async(this, arguments, function* ({
    incident,
    config: config2
  }) {
    const endpoint = `${config2.apiBase}/v1/fleet/incidents/${incident.id}/resolutions/`;
    return fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config2.token}`
      }
    });
  });
}

// src/pages/incidents-list/incident-solving/solve-staged-in-platform/solve-staged-in-platform-modal-hook.tsx
function useSolveStagedInPlatformModalHook({
  incident,
  onSuccess,
  onCancel,
  config: config2
}) {
  var _a;
  const [loading, setLoading] = useState8(false);
  const canSubmit = !loading;
  const headerText = `Env\xEDo ${((_a = incident.cargo.shipment) == null ? void 0 : _a.externalId) || ""} Paquete ${incident.cargo.externalId}`;
  const onGoback = useCallback7(() => {
    if (loading) {
      return;
    }
    onCancel();
  }, [onCancel, loading]);
  const onConfirm = useCallback7(() => __async(this, null, function* () {
    const successMessage = "Incidente resuelto con \xE9xito";
    const errorMessage = "Error al resolver el incidente";
    setLoading(true);
    try {
      const response = yield solveStagedInPlatformApi({
        incident,
        config: config2
      });
      if (!response.ok)
        throw new Error(`Bad response solving delivery failed`);
      setLoading(false);
      toast5.success(successMessage);
      onSuccess();
      onCancel();
    } catch (error) {
      toast5.error(errorMessage);
      setLoading(false);
    }
  }), [incident, config2, onSuccess, onCancel]);
  const hookResult = {
    loading,
    canSubmit,
    onGoback,
    onConfirm,
    headerText
  };
  return hookResult;
}

// src/pages/incidents-list/incident-solving/solve-staged-in-platform/solve-staged-in-platform-modal-component.tsx
function SolveStagedInPlatformModalComponent({
  incident,
  onSuccess,
  onCancel,
  config: config2
}) {
  const { canSubmit, loading, onConfirm, onGoback, headerText } = useSolveStagedInPlatformModalHook(
    {
      incident,
      onSuccess,
      onCancel,
      config: config2
    }
  );
  return /* @__PURE__ */ React40.createElement(
    ModalComponent5,
    {
      bodyComponent: /* @__PURE__ */ React40.createElement(FlexComponent16, { alignSelf: "stretch", flexDirection: "column", gap: "8px" }, /* @__PURE__ */ React40.createElement(ModalBodyRegularText, null, "Se marcar\xE1 el incidente como resuelto")),
      cancelButtonLabel: "Cancelar",
      confirmButtonIsLoadingLabel: "Resolviendo...",
      confirmButtonLabel: "Resolver",
      description: headerText,
      isCancelDisabled: loading,
      isConfirmDisabled: !canSubmit,
      isConfirmLoading: loading,
      onCancel: onGoback,
      onClose: onGoback,
      onConfirm,
      title: "Resolver incidente"
    }
  );
}

// src/pages/incidents-list/incident-solving/solve-staged-in-platform/solve-staged-in-platform-hook.tsx
var useSolveStagedInPlatformHook = ({
  incident,
  onSuccess
}) => {
  const config2 = useConfigHook();
  const openSolveStagedInPlatformModal = () => __async(void 0, null, function* () {
    const { show, destroy } = yield Modal5.new({
      content: /* @__PURE__ */ React41.createElement(
        SolveStagedInPlatformModalComponent,
        {
          config: config2,
          incident,
          onCancel: () => void destroy(),
          onSuccess
        }
      ),
      footer: null
    });
    void show();
  });
  return {
    openSolveStagedInPlatformModal
  };
};

// src/pages/incidents-list/incidents-table/individual-actions/incidents-table-individual-actions-component.tsx
var StyledIndividualActionsMenuButtonComponent2 = styled14.div`
  min-height: 60px;
  display: flex;
  align-items: center;
  button {
    min-height: 60px;
  }
`;
function IncidentsTableIndividualActionsComponent({
  incident
}) {
  const canSolveIncident = !incident.resolved;
  const { openSolveDeliveryFailedModal } = useSolveDeliveryFailedHook({
    incident,
    onSuccess: () => {
      void mutate4((key) => {
        return typeof key === "string" && key.startsWith("last-mile");
      });
    }
  });
  const { openSolveStagedInPlatformModal } = useSolveStagedInPlatformHook({
    incident,
    onSuccess: () => {
      void mutate4((key) => {
        return typeof key === "string" && key.startsWith("last-mile");
      });
    }
  });
  const openModal = useCallback8(() => {
    if (incident.acceptsSimpleResolution) {
      return void openSolveStagedInPlatformModal();
    }
    if (incident.incidentType === "delivery-failed") {
      return void openSolveDeliveryFailedModal();
    }
    if (incident.incidentType === "staged-in-platform") {
      return void openSolveStagedInPlatformModal();
    }
    if (incident.incidentType === "postponed-delivery") {
      return void openSolveDeliveryFailedModal();
    }
    if (incident.incidentType === "incorrect-address") {
      return void openSolveDeliveryFailedModal(true);
    }
  }, [
    incident.acceptsSimpleResolution,
    incident.incidentType,
    openSolveDeliveryFailedModal,
    openSolveStagedInPlatformModal
  ]);
  return /* @__PURE__ */ React42.createElement(
    Popover2,
    {
      className: "forced-right-popover",
      content: /* @__PURE__ */ React42.createElement(IndividualActionsBodyComponent2, null, /* @__PURE__ */ React42.createElement(
        IndividualActionItemComponent2,
        {
          enabled: canSolveIncident,
          onClick: () => {
            openModal();
          }
        },
        "Resolver incidente"
      )),
      placement: "left",
      renderOpener: ({ ref, onClick }) => /* @__PURE__ */ React42.createElement(StyledIndividualActionsMenuButtonComponent2, null, /* @__PURE__ */ React42.createElement(IndividualActionsMenuButtonComponent2, { onClick, ref }))
    }
  );
}

// src/pages/incidents-list/incidents-table/incidents-table-row-parent-component.tsx
function IncidentsTableRowParentComponent({
  incidentItem
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const { selectedIncidents, selectIncident, unSelectIncident } = useIncidentsListSelectionHook();
  const incidentStateColor = incidentItem.resolved ? "green" : "red";
  const incidentStateText = incidentItem.resolved ? "Resuelto" : "No resuelto";
  const isChecked = selectedIncidents.some((incident) => incident.id === incidentItem.id);
  const handleCheckboxChange = () => {
    if (isChecked) {
      unSelectIncident(incidentItem);
    } else {
      selectIncident(incidentItem);
    }
  };
  const driverText = incidentItem.driver ? incidentItem.driver.contactName || `Conductor ${incidentItem.driver.id}` : "";
  const latestCargoEvent = incidentItem.cargo.events.sort(
    (a, b) => b.createdAt.localeCompare(a.createdAt)
  )[0];
  const incidentTypeText = IncidentTypesService.getIncidentTypeText(
    incidentItem.incidentType || ""
  );
  return /* @__PURE__ */ React43.createElement(FlexComponent17, { alignItems: "center", borderTop: "1px solid var(--grey-300, #CCD7E0)" }, /* @__PURE__ */ React43.createElement(TableCellAcordionComponent, { width: INCIDENTS_TABLE_COLUMNS.accordionIndicator.width }), /* @__PURE__ */ React43.createElement(
    TableCellCheckboxComponent,
    {
      handleCheckboxChange,
      isChecked,
      width: INCIDENTS_TABLE_COLUMNS.checkbox.width
    }
  ), /* @__PURE__ */ React43.createElement(
    TableCellStateComponent,
    {
      stateColor: incidentStateColor,
      stateText: incidentStateText,
      width: INCIDENTS_TABLE_COLUMNS.state.width
    }
  ), /* @__PURE__ */ React43.createElement(
    TableCellTextComponent,
    {
      fontWeight: "bold",
      text: incidentItem.code,
      width: INCIDENTS_TABLE_COLUMNS.code.width
    }
  ), /* @__PURE__ */ React43.createElement(
    TableCellTextComponent,
    {
      text: incidentTypeText,
      width: INCIDENTS_TABLE_COLUMNS.incidentType.width
    }
  ), /* @__PURE__ */ React43.createElement(
    TableCellTextComponent,
    {
      text: ((_a = incidentItem.cargo.shipment) == null ? void 0 : _a.externalId) || "",
      width: INCIDENTS_TABLE_COLUMNS.externalId.width
    }
  ), /* @__PURE__ */ React43.createElement(
    TableCellTextComponent,
    {
      text: incidentItem.cargo.externalId || "",
      width: INCIDENTS_TABLE_COLUMNS.cargo.width
    }
  ), /* @__PURE__ */ React43.createElement(
    TableCellAddressComponent,
    {
      address: (_c = (_b = incidentItem.cargo.shipment) == null ? void 0 : _b.deliveryAddress) != null ? _c : void 0,
      width: INCIDENTS_TABLE_COLUMNS.deliveryAddress.width
    }
  ), /* @__PURE__ */ React43.createElement(
    TableCellAddressComponent,
    {
      address: (_f = (_e = (_d = incidentItem.cargo.shipment) == null ? void 0 : _d.billingDelegation) == null ? void 0 : _e.address) != null ? _f : void 0,
      width: INCIDENTS_TABLE_COLUMNS.billingDelegation.width
    }
  ), /* @__PURE__ */ React43.createElement(
    TableCellAddressComponent,
    {
      address: (_i = (_h = (_g = incidentItem.cargo.shipment) == null ? void 0 : _g.originDelegation) == null ? void 0 : _h.address) != null ? _i : void 0,
      width: INCIDENTS_TABLE_COLUMNS.originDelegation.width
    }
  ), /* @__PURE__ */ React43.createElement(
    TableCellAddressComponent,
    {
      address: (_l = (_k = (_j = incidentItem.cargo.shipment) == null ? void 0 : _j.destinationDelegation) == null ? void 0 : _k.address) != null ? _l : void 0,
      width: INCIDENTS_TABLE_COLUMNS.destinationDelegation.width
    }
  ), /* @__PURE__ */ React43.createElement(TableCellTextComponent, { text: driverText, width: INCIDENTS_TABLE_COLUMNS.driver.width }), /* @__PURE__ */ React43.createElement(
    TableCellCargoEventComponent,
    {
      cargoEvent: latestCargoEvent,
      width: `calc(${INCIDENTS_TABLE_COLUMNS.lastUpdate.width} - 24px)`
    }
  ), /* @__PURE__ */ React43.createElement(IncidentsTableIndividualActionsComponent, { incident: incidentItem }));
}

// src/pages/incidents-list/incidents-table/incidents-table-row-component.tsx
var RowWrapperComponent2 = styled15.div`
  header {
    display: flex;
    padding: unset;
    border-top: none;
    border-bottom: none;

    > div {
      flex: 1;
    }

    :hover {
      cursor: default;
    }
  }
  ${TableCellComponent12} {
    min-height: 60px;
  }
`;
var StyledAccordionComponent2 = styled15(AccordionComponent2)`
  height: auto;
  border-left: none;
  border-right: none;
`;
var StyledAccordionTriggerComponent2 = styled15(AccordionTriggerComponent2)`
  padding: unset;
  border-top: 3px solid var(--grey-200, #ccd7e0);
  border-bottom: none;
`;
function IncidentsTableRowComponent({
  incidentItem
}) {
  return /* @__PURE__ */ React44.createElement(RowWrapperComponent2, null, /* @__PURE__ */ React44.createElement(StyledAccordionComponent2, null, /* @__PURE__ */ React44.createElement(StyledAccordionTriggerComponent2, { open: false }, /* @__PURE__ */ React44.createElement(IncidentsTableRowParentComponent, { incidentItem }))));
}

// src/pages/incidents-list/incidents-table/incidents-table-component.tsx
function IncidentsTableComponent({
  incidents,
  error,
  totalIncidentsCount,
  isLoading
}) {
  const {
    incidentFilters,
    incidentFiltersOptions,
    handleChangePageSize,
    handleGoToPreviousPage,
    handleGoToPage,
    handleGoToNextPage
  } = useIncidentsListFiltersHook();
  const headerColumns = useMemo16(
    () => getIncidentsTableHeaderColumns({ incidents }),
    [incidents]
  );
  const getIncidentsRowsComponent = useCallback9(() => {
    return incidents.map((incidentItem) => {
      return /* @__PURE__ */ React45.createElement(IncidentsTableRowComponent, { incidentItem, key: incidentItem.id });
    });
  }, [incidents]);
  return /* @__PURE__ */ React45.createElement(
    TableComponent3,
    {
      columns: headerColumns,
      emptyStateMessage: "No se han encontrado incidentes",
      errorComponent: /* @__PURE__ */ React45.createElement(TableErrorComponent2, { errorLabel: "Error al cargar los incidentes" }),
      isError: error !== void 0,
      isLoading,
      isResponsive: true,
      numberOfItems: totalIncidentsCount,
      onChangePageSize: handleChangePageSize,
      onGoToNextPage: handleGoToNextPage,
      onGoToPage: handleGoToPage,
      onGoToPreviousPage: handleGoToPreviousPage,
      pageIndex: incidentFilters.page,
      pageSize: incidentFilters.pageSize,
      pageSizes: incidentFiltersOptions.paginationSizes,
      resultsPerPageLabel: "Incidentes por p\xE1gina",
      rowsComponents: getIncidentsRowsComponent(),
      scrollCacheKey: "incidents",
      summaryComponent: /* @__PURE__ */ React45.createElement(
        IncidentsTableSummaryComponent,
        {
          isError: error !== void 0,
          isLoading,
          totalIncidentsCount
        }
      )
    }
  );
}

// src/pages/incidents-list/incidents-list-page.tsx
function IncidentsListPage() {
  const { incidentFilters } = useIncidentsListFiltersHook();
  const { unSelectAllIncidents } = useIncidentsListSelectionHook();
  const { selectedDelegationId } = useMyDelegationHook();
  const { incidents, isLoading, error, totalIncidentsCount } = useIncidentsListDataHook({
    incidentFilters,
    myDelegationId: selectedDelegationId
  });
  useEffect5(() => {
    unSelectAllIncidents();
  }, [incidentFilters, unSelectAllIncidents]);
  const [topBarModuleMyDelegationNode, setTopBarModuleMyDelegationNode] = useState9(
    null
  );
  useEffect5(() => {
    if (topBarModuleMyDelegationNode) {
      return;
    }
    const node = document.getElementById(TOP_BAR_MODULE_MY_DELEGATION_ID);
    if (!node) {
      console.error(`Node with id ${TOP_BAR_MODULE_MY_DELEGATION_ID} not found`);
      return;
    }
    setTopBarModuleMyDelegationNode(node);
  }, [topBarModuleMyDelegationNode, setTopBarModuleMyDelegationNode]);
  return /* @__PURE__ */ React46.createElement(PageLayout2, null, topBarModuleMyDelegationNode ? createPortal2(/* @__PURE__ */ React46.createElement(MyDelegationComponent, null), topBarModuleMyDelegationNode) : null, /* @__PURE__ */ React46.createElement(IncidentsListToolbarComponent, null), /* @__PURE__ */ React46.createElement(PageContent2, null, /* @__PURE__ */ React46.createElement(
    IncidentsTableComponent,
    {
      error,
      incidents,
      isLoading,
      totalIncidentsCount
    }
  )), /* @__PURE__ */ React46.createElement(Toaster2, { richColors: true }));
}

// src/pages/shipment-detail/shipment-detail-page.tsx
import React54, { useState as useState10, useEffect as useEffect6 } from "react";
import {
  PageContent as PageContent3,
  PageLayout as PageLayout3,
  FlexComponent as FlexComponent18,
  Input as InputComponent,
  TextComponent as TextComponent14,
  MonitorComponent
} from "@ontruck/fe-ui";
import { DetailSomethingComponent } from "@ontruck/fe-core";

// src/business/shipments/get-shipment-hook.tsx
import useSWR7 from "swr";

// src/business/shipments/get-shipment-api.ts
function getShipmentApi(_0, _1) {
  return __async(this, arguments, function* ({ token, apiBase }, shipmentId) {
    const url = `${apiBase}/v1/fleet/shipments/${shipmentId}`;
    const response = yield fetch(url, {
      method: "GET",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!response.ok) {
      throw new Error("Failed to fetch shipments");
    }
    return yield response.json();
  });
}

// src/business/shipments/get-shipment-fetcher.ts
var getShipmentFetcher = (config2, shipmentId) => {
  return getShipmentApi(config2, shipmentId);
};

// src/business/shipments/get-shipment-hook.tsx
var RELOAD_SHIPMENTS_LIST_INTERVAL_IN_SECONDS2 = 1e7;
var useGetShipmentHook = ({ shipmentId }) => {
  const key = `last-mile/shipments/${shipmentId}`;
  const config2 = useConfigHook();
  const fetcher = () => __async(void 0, null, function* () {
    return getShipmentFetcher(config2, shipmentId);
  });
  const { data, error, isLoading } = useSWR7(key, fetcher, {
    refreshInterval: RELOAD_SHIPMENTS_LIST_INTERVAL_IN_SECONDS2 * 1e3,
    revalidateIfStale: true
  });
  const shipment = data ? shipmentMapper(data) : null;
  return {
    shipment,
    isLoading,
    error
  };
};

// src/components/events/get-shipment-events-service.tsx
import React53 from "react";
import { iconNames as iconNames2 } from "@ontruck/fe-icons";
import { getReadableDate as getReadableDate2 } from "@ontruck/fe-core";

// src/components/events/delivery-failed-event-component.tsx
import React47 from "react";

// src/components/events/list-event-component.tsx
import styled16 from "styled-components";
import { TextComponent as TextComponent11 } from "@ontruck/fe-ui";
var ListEventComponent = styled16.ul`
  padding: 0;
  padding-left: 24px;
  margin: 0;

  ${TextComponent11} {
    font-size: 12px;
  }
`;

// src/components/events/inline-text-event-component.tsx
import styled17 from "styled-components";
import { TextComponent as TextComponent12 } from "@ontruck/fe-ui";
var InlineTextEventComponent = styled17(TextComponent12)`
  display: inline;
`;

// src/components/events/link-event-component.tsx
import styled18 from "styled-components";
var LinkEventComponent = styled18.a`
  color: var(--otk-theme-color-primary-400, #57b1e5);
  text-decoration: underline;
`;

// src/components/events/delivery-failed-event-component.tsx
function DeliveryFailedEventComponent({
  event,
  externalId
}) {
  return /* @__PURE__ */ React47.createElement(ListEventComponent, null, /* @__PURE__ */ React47.createElement("li", null, /* @__PURE__ */ React47.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "ID:"), " ", /* @__PURE__ */ React47.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight)" }, externalId)), event.observations ? /* @__PURE__ */ React47.createElement("li", null, /* @__PURE__ */ React47.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "Observaciones:"), " ", /* @__PURE__ */ React47.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight)" }, event.observations)) : null, event.latitude && event.longitude ? /* @__PURE__ */ React47.createElement("li", null, /* @__PURE__ */ React47.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "Posici\xF3n gps:"), " ", /* @__PURE__ */ React47.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight)" }, event.latitude, " - ", event.longitude)) : null, event.image ? /* @__PURE__ */ React47.createElement("li", null, /* @__PURE__ */ React47.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "Imagen:"), " ", /* @__PURE__ */ React47.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight)" }, /* @__PURE__ */ React47.createElement(LinkEventComponent, { href: event.image, target: "_blank" }, "Enlace a la imagen"))) : null);
}

// src/components/events/incident-reported-event-component.tsx
import React48 from "react";
function IncidentReportedEventComponent({
  event,
  externalId
}) {
  return /* @__PURE__ */ React48.createElement(ListEventComponent, null, /* @__PURE__ */ React48.createElement("li", null, /* @__PURE__ */ React48.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "ID:"), " ", /* @__PURE__ */ React48.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight)" }, externalId)), event.observations ? /* @__PURE__ */ React48.createElement("li", null, /* @__PURE__ */ React48.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "Observaciones:"), " ", /* @__PURE__ */ React48.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight)" }, event.observations)) : null, event.image ? /* @__PURE__ */ React48.createElement("li", null, /* @__PURE__ */ React48.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "Imagen:"), " ", /* @__PURE__ */ React48.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight)" }, /* @__PURE__ */ React48.createElement(LinkEventComponent, { href: event.image, target: "_blank" }, "Enlace a la imagen"))) : null, event.latitude && event.longitude ? /* @__PURE__ */ React48.createElement("li", null, /* @__PURE__ */ React48.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "Posici\xF3n gps:"), " ", /* @__PURE__ */ React48.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight)" }, event.latitude, " - ", event.longitude)) : null);
}

// src/components/events/delivery-completed-event-component.tsx
import React49 from "react";
function DeliveryCompletedEventComponent({
  event,
  externalId
}) {
  return /* @__PURE__ */ React49.createElement(ListEventComponent, null, /* @__PURE__ */ React49.createElement("li", null, /* @__PURE__ */ React49.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "ID:"), " ", /* @__PURE__ */ React49.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight)" }, externalId)), event.observations ? /* @__PURE__ */ React49.createElement("li", null, /* @__PURE__ */ React49.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "Observaciones:"), " ", /* @__PURE__ */ React49.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight)" }, event.observations)) : null, event.idNumber ? /* @__PURE__ */ React49.createElement("li", null, /* @__PURE__ */ React49.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "DNI / NIE / Pasaporte:"), " ", /* @__PURE__ */ React49.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight)" }, event.idNumber)) : null, event.latitude && event.longitude ? /* @__PURE__ */ React49.createElement("li", null, /* @__PURE__ */ React49.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "Posici\xF3n gps:"), " ", /* @__PURE__ */ React49.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight)" }, event.latitude, " - ", event.longitude)) : null, event.image ? /* @__PURE__ */ React49.createElement("li", null, /* @__PURE__ */ React49.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "POD:"), " ", /* @__PURE__ */ React49.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight)" }, /* @__PURE__ */ React49.createElement(LinkEventComponent, { href: event.image, target: "_blank" }, "Enlace a la imagen"))) : null);
}

// src/components/events/shipment-state-changed-event-component.tsx
import React50 from "react";
import { BallComponent, TextComponent as TextComponent13 } from "@ontruck/fe-ui";
function ShipmentStateChangedEventComponent({ event }) {
  var _a, _b;
  const { diff } = event;
  const oldState = (_a = diff == null ? void 0 : diff.old) != null ? _a : "Sin estado";
  const newState = (_b = diff == null ? void 0 : diff.new) != null ? _b : "Sin estado";
  const oldStateColor = ShipmentsStateService.getShipmentStateColor(oldState);
  const oldStateText = ShipmentsStateService.getShipmentStateText(oldState);
  const newStateColor = ShipmentsStateService.getShipmentStateColor(newState);
  const newStateText = ShipmentsStateService.getShipmentStateText(newState);
  return /* @__PURE__ */ React50.createElement(ListEventComponent, null, diff ? /* @__PURE__ */ React50.createElement("div", { style: { display: "flex", flexDirection: "column", gap: "4px" } }, /* @__PURE__ */ React50.createElement("li", null, /* @__PURE__ */ React50.createElement(InlineTextEventComponent, { gap: "8px" }, "Estado anterior"), /* @__PURE__ */ React50.createElement(TextComponent13, { fontWeight: "bold", gap: "4px" }, /* @__PURE__ */ React50.createElement(BallComponent, { backgroundColor: oldStateColor }), " ", oldStateText)), /* @__PURE__ */ React50.createElement("li", null, /* @__PURE__ */ React50.createElement(InlineTextEventComponent, { gap: "8px" }, "Nuevo estado"), /* @__PURE__ */ React50.createElement(TextComponent13, { fontWeight: "bold", gap: "4px" }, /* @__PURE__ */ React50.createElement(BallComponent, { backgroundColor: newStateColor }), " ", newStateText))) : null);
}

// src/components/events/received-event-component.tsx
import React51 from "react";
function ReceivedEventComponent({ externalId }) {
  return /* @__PURE__ */ React51.createElement(ListEventComponent, null, /* @__PURE__ */ React51.createElement("li", null, /* @__PURE__ */ React51.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "ID:"), " ", /* @__PURE__ */ React51.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight)" }, externalId)));
}

// src/components/events/collected-event-component.tsx
import React52 from "react";
function CollectedEventComponent({ externalId }) {
  return /* @__PURE__ */ React52.createElement(ListEventComponent, null, /* @__PURE__ */ React52.createElement("li", null, /* @__PURE__ */ React52.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "ID:"), " ", /* @__PURE__ */ React52.createElement(InlineTextEventComponent, { fontWeight: "var(--otk-theme-font-weight)" }, externalId)));
}

// src/components/events/get-shipment-events-service.tsx
var bodyByEventType = {
  [CARGO_EVENT_TYPES.created]: () => null,
  [CARGO_EVENT_TYPES.assigned]: () => null,
  [CARGO_EVENT_TYPES.collectedForDelivery]: (_, externalId) => /* @__PURE__ */ React53.createElement(CollectedEventComponent, { externalId }),
  [CARGO_EVENT_TYPES.collectedForTransfer]: (_, externalId) => /* @__PURE__ */ React53.createElement(CollectedEventComponent, { externalId }),
  [CARGO_EVENT_TYPES.consolidated]: () => null,
  [CARGO_EVENT_TYPES.customsCleared]: () => null,
  [CARGO_EVENT_TYPES.deconsolidated]: () => null,
  [CARGO_EVENT_TYPES.received]: (_, externalId) => /* @__PURE__ */ React53.createElement(ReceivedEventComponent, { externalId }),
  [CARGO_EVENT_TYPES.incidentResolved]: () => null,
  [CARGO_EVENT_TYPES.returningToDelegation]: () => null,
  [CARGO_EVENT_TYPES.deliveryFailed]: (event, externalId) => /* @__PURE__ */ React53.createElement(DeliveryFailedEventComponent, { event, externalId }),
  [CARGO_EVENT_TYPES.incidentReported]: (event, externalId) => /* @__PURE__ */ React53.createElement(IncidentReportedEventComponent, { event, externalId }),
  [CARGO_EVENT_TYPES.deliveryAddressUpdated]: () => null,
  [CARGO_EVENT_TYPES.deliveryInternalUpdated]: () => null,
  [CARGO_EVENT_TYPES.delivered]: (event, externalId) => /* @__PURE__ */ React53.createElement(DeliveryCompletedEventComponent, { event, externalId }),
  [CARGO_EVENT_TYPES.shipmentStateChanged]: (event) => /* @__PURE__ */ React53.createElement(ShipmentStateChangedEventComponent, { event })
};
function getBodyComponentByEventTypeService(event, externalId) {
  if (!event.eventType) {
    return null;
  }
  try {
    return bodyByEventType[event.eventType](event, externalId);
  } catch (error) {
    return null;
  }
}
var whoTypes = {
  internal: "internal",
  system: "system",
  carrier: "carrier"
};
var whoByType = {
  [whoTypes.internal]: "Operador",
  [whoTypes.system]: "Sistema",
  [whoTypes.carrier]: "Conductor"
};
function getWhoLabelByEventType(type) {
  if (type in whoTypes) {
    return whoByType[type];
  }
  return whoByType.system;
}
function getWhoColorByType(type) {
  if (type === whoTypes.internal) {
    return {
      backgroundColor: "var(--otk-theme-color-grey-300, #ccd6e0)",
      color: "var(--otk-theme-color-primary-400, #57B1E5)"
    };
  }
  if (type === whoTypes.system) {
    return {
      backgroundColor: "var(--otk-theme-color-grey-200, #E2E8EE)",
      color: "var(--otk-theme-color-grey-900)"
    };
  }
  return {
    backgroundColor: "var(--otk-theme-color-primary-500, #2396DC)",
    color: "var(--otk-theme-color-background-color-white,#fff)"
  };
}
var getCreatedByDisplayText = (event) => {
  let text = event.createdBy.username;
  if (event.createdBy.firstName && event.createdBy.lastName) {
    text = `${event.createdBy.firstName} ${event.createdBy.lastName}`;
  }
  return text;
};
var getWhoHandlerByEventType = {
  [CARGO_EVENT_TYPES.created]: (event, shipper) => {
    const type = "system";
    return __spreadValues({
      type,
      label: getWhoLabelByEventType(type),
      details: shipper
    }, getWhoColorByType(type));
  },
  [CARGO_EVENT_TYPES.assigned]: (event) => {
    return __spreadValues({
      type: event.createdBy.type,
      label: getWhoLabelByEventType(event.createdBy.type),
      details: getCreatedByDisplayText(event)
    }, getWhoColorByType(event.createdBy.type));
  },
  [CARGO_EVENT_TYPES.collectedForDelivery]: (event) => {
    return __spreadValues({
      type: event.createdBy.type,
      label: getWhoLabelByEventType(event.createdBy.type),
      details: getCreatedByDisplayText(event)
    }, getWhoColorByType(event.createdBy.type));
  },
  [CARGO_EVENT_TYPES.collectedForTransfer]: (event) => {
    return __spreadValues({
      type: event.createdBy.type,
      label: getWhoLabelByEventType(event.createdBy.type),
      details: getCreatedByDisplayText(event)
    }, getWhoColorByType(event.createdBy.type));
  },
  [CARGO_EVENT_TYPES.consolidated]: (event) => {
    return __spreadValues({
      type: event.createdBy.type,
      label: getWhoLabelByEventType(event.createdBy.type),
      details: event.createdBy.username
    }, getWhoColorByType(event.createdBy.type));
  },
  [CARGO_EVENT_TYPES.customsCleared]: (event, shipper) => {
    return __spreadValues({
      type: event.createdBy.type,
      label: getWhoLabelByEventType(event.createdBy.type),
      details: shipper
    }, getWhoColorByType(event.createdBy.type));
  },
  [CARGO_EVENT_TYPES.deliveryAddressUpdated]: (event) => {
    return __spreadValues({
      type: event.createdBy.type,
      label: getWhoLabelByEventType(event.createdBy.type),
      details: null
    }, getWhoColorByType(event.createdBy.type));
  },
  [CARGO_EVENT_TYPES.deliveryInternalUpdated]: (event) => {
    return __spreadValues({
      type: event.createdBy.type,
      label: getWhoLabelByEventType(event.createdBy.type),
      details: null
    }, getWhoColorByType(event.createdBy.type));
  },
  [CARGO_EVENT_TYPES.deconsolidated]: (event) => {
    return __spreadValues({
      type: event.createdBy.type,
      label: getWhoLabelByEventType(event.createdBy.type),
      details: null
    }, getWhoColorByType(event.createdBy.type));
  },
  [CARGO_EVENT_TYPES.deliveryFailed]: (event) => {
    return __spreadValues({
      type: event.createdBy.type,
      label: getWhoLabelByEventType(event.createdBy.type),
      details: getCreatedByDisplayText(event)
    }, getWhoColorByType(event.createdBy.type));
  },
  [CARGO_EVENT_TYPES.delivered]: (event) => {
    return __spreadValues({
      type: event.createdBy.type,
      label: getWhoLabelByEventType(event.createdBy.type),
      details: getCreatedByDisplayText(event)
    }, getWhoColorByType(event.createdBy.type));
  },
  [CARGO_EVENT_TYPES.incidentReported]: (event) => {
    return __spreadValues({
      type: event.createdBy.type,
      label: getWhoLabelByEventType(event.createdBy.type),
      details: getCreatedByDisplayText(event)
    }, getWhoColorByType(event.createdBy.type));
  },
  [CARGO_EVENT_TYPES.received]: (event) => {
    return __spreadValues({
      type: event.createdBy.type,
      label: getWhoLabelByEventType(event.createdBy.type),
      details: getCreatedByDisplayText(event)
    }, getWhoColorByType(event.createdBy.type));
  },
  [CARGO_EVENT_TYPES.incidentResolved]: (event) => {
    return __spreadValues({
      type: event.createdBy.type,
      label: getWhoLabelByEventType(event.createdBy.type),
      details: getCreatedByDisplayText(event)
    }, getWhoColorByType(event.createdBy.type));
  },
  [CARGO_EVENT_TYPES.returningToDelegation]: (event) => {
    return __spreadValues({
      type: event.createdBy.type,
      label: getWhoLabelByEventType(event.createdBy.type),
      details: null
    }, getWhoColorByType(event.createdBy.type));
  },
  [CARGO_EVENT_TYPES.shipmentStateChanged]: (event) => {
    return __spreadValues({
      type: event.createdBy.type,
      label: getWhoLabelByEventType(event.createdBy.type),
      details: getCreatedByDisplayText(event)
    }, getWhoColorByType(event.createdBy.type));
  }
};
function getWhoByEventTypeService(event, shipper) {
  try {
    if (!event.eventType) {
      return __spreadValues({
        type: whoTypes.system,
        label: getWhoLabelByEventType(whoTypes.system),
        details: null
      }, getWhoColorByType(whoTypes.system));
    }
    const handler = getWhoHandlerByEventType[event.eventType];
    return handler(event, shipper);
  } catch (error) {
    return __spreadValues({
      type: whoTypes.system,
      label: event.eventType || "",
      details: null
    }, getWhoColorByType(whoTypes.system));
  }
}
function getFormattedId(id) {
  return `ID.${id.toString().padStart(8, "0")}`;
}
var getActorHandlerByEventType = {
  [CARGO_EVENT_TYPES.created]: () => null,
  [CARGO_EVENT_TYPES.assigned]: (event) => {
    var _a, _b;
    return (_b = (_a = event.driver) == null ? void 0 : _a.contactName) != null ? _b : null;
  },
  [CARGO_EVENT_TYPES.collectedForDelivery]: (event) => {
    var _a, _b;
    return (_b = (_a = event.driver) == null ? void 0 : _a.contactName) != null ? _b : null;
  },
  [CARGO_EVENT_TYPES.collectedForTransfer]: (event) => {
    var _a, _b;
    return (_b = (_a = event.driver) == null ? void 0 : _a.contactName) != null ? _b : null;
  },
  [CARGO_EVENT_TYPES.consolidated]: (_, externalId) => getFormattedId(externalId),
  [CARGO_EVENT_TYPES.customsCleared]: () => null,
  [CARGO_EVENT_TYPES.deliveryAddressUpdated]: () => "Direcci\xF3n - Datos de contacto",
  [CARGO_EVENT_TYPES.deliveryInternalUpdated]: () => "Direcci\xF3n - Datos de contacto",
  [CARGO_EVENT_TYPES.deconsolidated]: (_, externalId) => getFormattedId(externalId),
  [CARGO_EVENT_TYPES.incidentReported]: (event) => event.incidentType ? IncidentTypesService.getIncidentTypeText(event.incidentType) : null,
  [CARGO_EVENT_TYPES.received]: (event) => event.address.companyName,
  [CARGO_EVENT_TYPES.incidentResolved]: () => null,
  [CARGO_EVENT_TYPES.returningToDelegation]: () => null,
  [CARGO_EVENT_TYPES.deliveryFailed]: (event) => {
    var _a, _b;
    return (_b = (_a = event.driver) == null ? void 0 : _a.contactName) != null ? _b : null;
  },
  [CARGO_EVENT_TYPES.delivered]: (event) => {
    var _a, _b;
    return (_b = (_a = event.driver) == null ? void 0 : _a.contactName) != null ? _b : null;
  },
  [CARGO_EVENT_TYPES.shipmentStateChanged]: () => null
};
var getActorByEventTypeService = (event, externalId) => {
  if (!event.eventType) {
    return null;
  }
  try {
    const handler = getActorHandlerByEventType[event.eventType];
    return handler(event, externalId);
  } catch (error) {
    return null;
  }
};
var iconDescriptionByEventType = {
  [CARGO_EVENT_TYPES.created]: {
    name: iconNames2.clipboard,
    color: "var(--otk-theme-color-grey-300, #ccd6e0)"
  },
  [CARGO_EVENT_TYPES.assigned]: {
    name: iconNames2.circleUser,
    color: "var(--otk-theme-color-primary-400, #57B1E5)"
  },
  [CARGO_EVENT_TYPES.collectedForDelivery]: {
    name: iconNames2.circleArrowRight,
    color: "var(--otk-theme-color-primary-400, #57B1E5)"
  },
  [CARGO_EVENT_TYPES.collectedForTransfer]: {
    name: iconNames2.circleArrowRight,
    color: "var(--otk-theme-color-primary-400, #57B1E5)"
  },
  [CARGO_EVENT_TYPES.consolidated]: {
    name: iconNames2.circleInformation,
    color: "var(--otk-theme-color-grey-300, #ccd6e0)"
  },
  [CARGO_EVENT_TYPES.customsCleared]: {
    name: iconNames2.circleLineCheck,
    color: "var(--otk-theme-color-primary-400, #57B1E5)"
  },
  [CARGO_EVENT_TYPES.deliveryAddressUpdated]: {
    name: iconNames2.circleInformation,
    color: "var(--otk-theme-color-primary-400, #57B1E5)"
  },
  [CARGO_EVENT_TYPES.deliveryInternalUpdated]: {
    name: iconNames2.circleInformation,
    color: "var(--otk-theme-color-grey-300, #57B1E5)"
  },
  [CARGO_EVENT_TYPES.deconsolidated]: {
    name: iconNames2.circleInformation,
    color: "var(--otk-theme-color-grey-300, #ccd6e0)"
  },
  [CARGO_EVENT_TYPES.deliveryFailed]: {
    name: iconNames2.circleExclamation,
    color: "var(--otk-theme-color-red-500, #ff4d4f)"
  },
  [CARGO_EVENT_TYPES.delivered]: {
    name: iconNames2.circleCheck,
    color: "var(--otk-theme-color-success-800, #00b573)"
  },
  [CARGO_EVENT_TYPES.incidentReported]: {
    name: iconNames2.circleExclamation,
    color: "var(--otk-theme-color-red-500, #ff4d4f)"
  },
  [CARGO_EVENT_TYPES.received]: {
    name: iconNames2.location,
    color: "var(--otk-theme-color-success-800, ##00b573)"
  },
  [CARGO_EVENT_TYPES.incidentResolved]: {
    name: iconNames2.circleCheck,
    color: "var(--otk-theme-color-success-800, #00b573)"
  },
  [CARGO_EVENT_TYPES.returningToDelegation]: {
    name: iconNames2.circleArrowRight,
    color: "var(--otk-theme-color-primary-400, #57B1E5)"
  },
  [CARGO_EVENT_TYPES.shipmentStateChanged]: {
    name: iconNames2.circleInformation,
    color: "var(--otk-theme-color-primary-400, #57B1E5)"
  }
};
function getIconByEventTypeService(eventType) {
  return iconDescriptionByEventType[eventType];
}
function getActionByEventTypeService(cargoEvent) {
  return CargoEventTypesService.getCargoEventTypeText(cargoEvent);
}
function getTagsService(event, shipmentCargos) {
  const eventId = event == null ? void 0 : event.id;
  if (!eventId || !shipmentCargos || shipmentCargos.length === 0) {
    return [];
  }
  const tagsForEvent = [];
  for (let index = 0; index < shipmentCargos.length; index++) {
    const cargo = shipmentCargos[index];
    const cargoEvents = cargo.events;
    for (const cargoEvent of cargoEvents) {
      if (cargoEvent.id === eventId) {
        if (cargoEvent.eventType === CARGO_EVENT_TYPES.shipmentStateChanged) {
          tagsForEvent.push("shipmentStateChanged");
        } else if (cargoEvent.eventType === CARGO_EVENT_TYPES.incidentReported || cargoEvent.eventType === CARGO_EVENT_TYPES.incidentResolved) {
          tagsForEvent.push("incident");
          tagsForEvent.push(`00${index + 1}`);
        } else if (cargoEvent.eventType === CARGO_EVENT_TYPES.received) {
          tagsForEvent.push("received");
          tagsForEvent.push(`00${index + 1}`);
        } else {
          tagsForEvent.push(`00${index + 1}`);
        }
      }
    }
  }
  return tagsForEvent;
}
function getShipmentEventsService(shipmentCargos) {
  if (!shipmentCargos) {
    return [];
  }
  const shipmentEvents = shipmentCargos.flatMap(
    (cargo) => cargo.events.map((e) => {
      if (!e.eventType || !e.id) {
        return void 0;
      }
      const action = getActionByEventTypeService(e);
      const icon = getIconByEventTypeService(e.eventType);
      const actor = getActorByEventTypeService(e, cargo.externalId);
      const who = getWhoByEventTypeService(e, cargo.externalId);
      const when = getReadableDate2(e.createdAt);
      const bodyComponent = getBodyComponentByEventTypeService(e, cargo.externalId);
      const tags = getTagsService(e, shipmentCargos);
      return {
        id: Number(e.id),
        actor,
        action,
        bodyComponent,
        icon,
        who,
        when,
        tags,
        createdAt: e.createdAt
      };
    }).filter((event) => event !== void 0)
  );
  const sortedEvents = shipmentEvents.sort((a, b) => {
    if (!a || !b) {
      return 0;
    }
    return b.createdAt.localeCompare(a.createdAt);
  });
  return sortedEvents;
}

// src/pages/shipment-detail/shipment-detail-page.tsx
function SeparatorComponent({ label }) {
  return /* @__PURE__ */ React54.createElement(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "var(--otk-theme-spacing-s, 8px)",
        width: "100%",
        padding: "var(--otk-theme-spacing-s, 8px)"
      }
    },
    /* @__PURE__ */ React54.createElement(
      "div",
      {
        style: { width: "100%", height: "1px", backgroundColor: "var(--otk-theme-color-grey-300)" }
      }
    ),
    label ? /* @__PURE__ */ React54.createElement(
      TextComponent14,
      {
        color: "var(--otk-theme-color-grey-500)",
        fontWeight: "medium",
        size: "s",
        style: { flexShrink: 0 }
      },
      label
    ) : null,
    /* @__PURE__ */ React54.createElement(
      "div",
      {
        style: { width: "100%", height: "1px", backgroundColor: "var(--otk-theme-color-grey-300)" }
      }
    )
  );
}
function ShipmentDetailPage({
  shipmentId,
  onCloseDetail
}) {
  var _a, _b, _c, _d, _e, _f;
  const { shipment, isLoading, error } = useGetShipmentHook({ shipmentId });
  const [shipmentEvents, setShipmentEvents] = useState10([]);
  const [documentedDateValue, setDocumentedDateValue] = useState10("");
  const [transitDateValue, setTransitDateValue] = useState10("");
  const [networkObjectiveDateValue, setNetworkObjectiveDateValue] = useState10("");
  const [objectiveCenterDateValue, setObjectiveCenterDateValue] = useState10("");
  const [cargoAgency, setCargoAgency] = useState10("");
  const [clientName, setClientName] = useState10("");
  const [typeOfService, setTypeOfService] = useState10("");
  const [originSender, setOriginSender] = useState10("");
  const [originCIFNIF, setOriginCIFNIF] = useState10("");
  const [originPhone, setOriginPhone] = useState10("");
  const [originReference, setOriginReference] = useState10("");
  const [originAddress, setOriginAddress] = useState10("");
  const [originPostalCode, setOriginPostalCode] = useState10("");
  const [originCity, setOriginCity] = useState10("");
  const [originAgency, setOriginAgency] = useState10("");
  const [destinationAddressee, setDestinationAddressee] = useState10("");
  const [destinationContactPoint, setDestinationContactPoint] = useState10("");
  const [destinationCIFNIF, setDestinationCIFNIF] = useState10("");
  const [destinationPhone, setDestinationPhone] = useState10("");
  const [destinationShipmentNumber, setDestinationShipmentNumber] = useState10("");
  const [destinationAddress, setDestinationAddress] = useState10("");
  const [destinationPostalCode, setDestinationPostalCode] = useState10("");
  const [destinationCity, setDestinationCity] = useState10("");
  const [destinationAgency, setDestinationAgency] = useState10("");
  useEffect6(() => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
    if (!shipment || shipmentEvents.length > 0) {
      return;
    }
    const events = getShipmentEventsService(shipment.cargos);
    setShipmentEvents(events);
    setDocumentedDateValue(getFormattedDateFromStringDatetime(shipment.createdAt));
    setTransitDateValue(getFormattedDateFromStringDatetime(shipment.receptionDatetime));
    setNetworkObjectiveDateValue(
      getFormattedDateFromStringDatetime(shipment.networkObjectiveDatetime)
    );
    setObjectiveCenterDateValue(
      getFormattedDateFromStringDatetime(shipment.centreObjectiveDatetime)
    );
    setCargoAgency(
      `${shipment.billingDelegation.address.zipcode} - ${shipment.billingDelegation.address.companyName}`
    );
    setClientName((_b2 = (_a2 = shipment.shipper) == null ? void 0 : _a2.companyName) != null ? _b2 : "");
    const serviceType = ShipmentsServicesService.getShipmentServiceText(shipment.service);
    setTypeOfService(serviceType);
    setOriginSender((_d2 = (_c2 = shipment.senderAddress) == null ? void 0 : _c2.companyName) != null ? _d2 : "");
    setOriginPhone((_f2 = (_e2 = shipment.senderAddress) == null ? void 0 : _e2.contactPhone) != null ? _f2 : "");
    setOriginReference((_g = shipment.externalReference) != null ? _g : "");
    setOriginAddress((_i = (_h = shipment.senderAddress) == null ? void 0 : _h.addressLine) != null ? _i : "");
    setOriginPostalCode((_k = (_j = shipment.senderAddress) == null ? void 0 : _j.zipcode) != null ? _k : "");
    setOriginCity((_m = (_l = shipment.senderAddress) == null ? void 0 : _l.city) != null ? _m : "");
    setOriginAgency(
      `${shipment.originDelegation.address.zipcode} - ${shipment.originDelegation.address.companyName}`
    );
    setDestinationAddressee((_o = (_n = shipment.deliveryAddress) == null ? void 0 : _n.contactName) != null ? _o : "");
    setDestinationContactPoint((_q = (_p = shipment.deliveryAddress) == null ? void 0 : _p.contactEmail) != null ? _q : "");
    setDestinationPhone((_s = (_r = shipment.deliveryAddress) == null ? void 0 : _r.contactPhone) != null ? _s : "");
    setDestinationShipmentNumber((_t = shipment.externalReference) != null ? _t : "");
    setDestinationAddress((_v = (_u = shipment.deliveryAddress) == null ? void 0 : _u.addressLine) != null ? _v : "");
    setDestinationPostalCode((_x = (_w = shipment.deliveryAddress) == null ? void 0 : _w.zipcode) != null ? _x : "");
    setDestinationCity((_z = (_y = shipment.deliveryAddress) == null ? void 0 : _y.city) != null ? _z : "");
    setDestinationAgency(
      `${shipment.destinationDelegation.address.zipcode} - ${shipment.destinationDelegation.address.companyName}`
    );
  }, [shipment, shipmentEvents]);
  const isEditMode = false;
  if (isLoading) {
    return null;
  }
  if (error) {
    return null;
  }
  const handleChangeDocumentedDateValue = (name, value) => {
    if (!value) {
      setDocumentedDateValue("");
      return;
    }
    const newDate = new Date(value);
    const newDateNormalized = new Date(newDate.setHours(0, 0, 0, 0));
    const newDateFrom = getDateStringFromJavascriptDate(newDateNormalized);
    setDocumentedDateValue(newDateFrom);
  };
  const handleChangeTransitDateValue = (name, value) => {
    if (!value) {
      setTransitDateValue("");
      return;
    }
    const newDate = new Date(value);
    const newDateNormalized = new Date(newDate.setHours(0, 0, 0, 0));
    const newDateFrom = getDateStringFromJavascriptDate(newDateNormalized);
    setTransitDateValue(newDateFrom);
  };
  const handleChangeRedObjectDateValue = (name, value) => {
    if (!value) {
      setNetworkObjectiveDateValue("");
      return;
    }
    const newDate = new Date(value);
    const newDateNormalized = new Date(newDate.setHours(0, 0, 0, 0));
    const newDateFrom = getDateStringFromJavascriptDate(newDateNormalized);
    setNetworkObjectiveDateValue(newDateFrom);
  };
  const handleChangeObjCenterDateValue = (name, value) => {
    if (!value) {
      setObjectiveCenterDateValue("");
      return;
    }
    const newDate = new Date(value);
    const newDateNormalized = new Date(newDate.setHours(0, 0, 0, 0));
    const newDateFrom = getDateStringFromJavascriptDate(newDateNormalized);
    setObjectiveCenterDateValue(newDateFrom);
  };
  const handleChangeCargoAgency = (name, value) => {
    if (!value) {
      setCargoAgency("");
      return;
    }
    setCargoAgency(value);
  };
  const handleChangeClientName = (name, value) => {
    if (!value) {
      setClientName("");
      return;
    }
    setClientName(value);
  };
  const handleChangeTypeOfService = (name, value) => {
    if (!value) {
      setTypeOfService("");
      return;
    }
    setTypeOfService(value);
  };
  const handleChangeOriginSender = (name, value) => {
    if (!value) {
      setOriginSender("");
      return;
    }
    setOriginSender(value);
  };
  const handleChangeOriginCIFNIF = (name, value) => {
    if (!value) {
      setOriginCIFNIF("");
      return;
    }
    setOriginCIFNIF(value);
  };
  const handleChangeOriginPhone = (name, value) => {
    if (!value) {
      setOriginPhone("");
      return;
    }
    setOriginPhone(value);
  };
  const handleChangeOriginReference = (name, value) => {
    if (!value) {
      setOriginReference("");
      return;
    }
    setOriginReference(value);
  };
  const handleChangeOriginAddress = (name, value) => {
    if (!value) {
      setOriginAddress("");
      return;
    }
    setOriginAddress(value);
  };
  const handleChangeOriginPostalCode = (name, value) => {
    if (!value) {
      setOriginPostalCode("");
      return;
    }
    setOriginPostalCode(value);
  };
  const handleChangeOriginCity = (name, value) => {
    if (!value) {
      setOriginCity("");
      return;
    }
    setOriginCity(value);
  };
  const handleChangeOriginAgency = (name, value) => {
    if (!value) {
      setOriginAgency("");
      return;
    }
    setOriginAgency(value);
  };
  const handleChangeDestinationAddressee = (name, value) => {
    if (!value) {
      setDestinationAddressee("");
      return;
    }
    setDestinationAddressee(value);
  };
  const handleChangeDestinationContactPoint = (name, value) => {
    if (!value) {
      setDestinationContactPoint("");
      return;
    }
    setDestinationContactPoint(value);
  };
  const handleChangeDestinationCIFNIF = (name, value) => {
    if (!value) {
      setDestinationCIFNIF("");
      return;
    }
    setDestinationCIFNIF(value);
  };
  const handleChangeDestinationPhone = (name, value) => {
    if (!value) {
      setDestinationPhone("");
      return;
    }
    setDestinationPhone(value);
  };
  const handleChangeDestinationShipmentNumber = (name, value) => {
    if (!value) {
      setDestinationShipmentNumber("");
      return;
    }
    setDestinationShipmentNumber(value);
  };
  const handleChangeDestinationAddress = (name, value) => {
    if (!value) {
      setDestinationAddress("");
      return;
    }
    setDestinationAddress(value);
  };
  const handleChangeDestinationPostalCode = (name, value) => {
    if (!value) {
      setDestinationPostalCode("");
      return;
    }
    setDestinationPostalCode(value);
  };
  const handleChangeDestinationCity = (name, value) => {
    if (!value) {
      setDestinationCity("");
      return;
    }
    setDestinationCity(value);
  };
  const handleChangeDestinationAgency = (name, value) => {
    if (!value) {
      setDestinationAgency("");
      return;
    }
    setDestinationAgency(value);
  };
  return /* @__PURE__ */ React54.createElement(PageLayout3, null, /* @__PURE__ */ React54.createElement(PageContent3, null, /* @__PURE__ */ React54.createElement(
    FlexComponent18,
    {
      alignItems: "stretch",
      flex: "1",
      flexDirection: "row",
      gap: "0",
      overflow: "hidden",
      overflowY: "hidden"
    },
    /* @__PURE__ */ React54.createElement(DetailSomethingComponent, null, /* @__PURE__ */ React54.createElement(DetailSomethingComponent.Header, { onClose: onCloseDetail }, /* @__PURE__ */ React54.createElement(DetailSomethingComponent.Header.Label, null, "Env\xEDo:"), /* @__PURE__ */ React54.createElement(DetailSomethingComponent.Header.Title, null, shipment == null ? void 0 : shipment.externalId)), /* @__PURE__ */ React54.createElement(DetailSomethingComponent.Content, null, /* @__PURE__ */ React54.createElement(DetailSomethingComponent.Sections, null, /* @__PURE__ */ React54.createElement(DetailSomethingComponent.Section, null, /* @__PURE__ */ React54.createElement(
      FlexComponent18,
      {
        flexDirection: "column",
        gap: "var(--otk-theme-spacing-s, 8px)",
        width: "100%"
      },
      /* @__PURE__ */ React54.createElement(FlexComponent18, { gap: "var(--otk-theme-spacing-s, 8px)", width: "100%" }, /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeDocumentedDateValue,
          isDisabled: !isEditMode,
          label: "F. documentado",
          name: "shipment-detail-f-documentado",
          type: "date",
          value: documentedDateValue
        }
      ), /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeTransitDateValue,
          isDisabled: !isEditMode,
          label: "F. transito",
          name: "shipment-detail-f-transito",
          type: "date",
          value: transitDateValue
        }
      ), /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeRedObjectDateValue,
          isDisabled: !isEditMode,
          label: "F. obj. Red",
          name: "shipment-detail-f-obj-rede",
          type: "date",
          value: networkObjectiveDateValue
        }
      ), /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeObjCenterDateValue,
          isDisabled: !isEditMode,
          label: "F. obj. Centro",
          name: "shipment-detail-f-obj-centro",
          type: "date",
          value: objectiveCenterDateValue
        }
      )),
      /* @__PURE__ */ React54.createElement(FlexComponent18, { gap: "var(--otk-theme-spacing-2, 8px)", width: "100%" }, /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeClientName,
          isDisabled: !isEditMode,
          label: "Cliente",
          name: "shipment-detail-client",
          type: "text",
          value: clientName
        }
      ), /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeTypeOfService,
          isDisabled: !isEditMode,
          label: "Tipo de servicio",
          name: "shipment-detail-service-type",
          type: "text",
          value: typeOfService
        }
      ), /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeCargoAgency,
          isDisabled: !isEditMode,
          label: "Agencia de Cargo",
          name: "shipment-detail-agencia-cargo",
          type: "text",
          value: cargoAgency
        }
      ))
    )), /* @__PURE__ */ React54.createElement(DetailSomethingComponent.Section, null, /* @__PURE__ */ React54.createElement(DetailSomethingComponent.Section.Title, null, "Origen"), /* @__PURE__ */ React54.createElement(
      FlexComponent18,
      {
        flexDirection: "column",
        gap: "var(--otk-theme-spacing-s, 8px)",
        width: "100%"
      },
      /* @__PURE__ */ React54.createElement(FlexComponent18, { gap: "var(--otk-theme-spacing-s, 8px)", width: "100%" }, /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeOriginSender,
          isDisabled: !isEditMode,
          label: "Remitente",
          name: "shipment-detail-origen-remitente",
          type: "text",
          value: originSender
        }
      )),
      /* @__PURE__ */ React54.createElement(FlexComponent18, { gap: "var(--otk-theme-spacing-s, 8px)", width: "100%" }, /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeOriginCIFNIF,
          isDisabled: !isEditMode,
          label: "CIF/NIF",
          name: "shipment-detail-origen-cif-nif",
          type: "text",
          value: originCIFNIF
        }
      ), /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeOriginPhone,
          isDisabled: !isEditMode,
          label: "Telefono",
          name: "shipment-detail-origen-telefono",
          type: "text",
          value: originPhone
        }
      ), /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeOriginReference,
          isDisabled: !isEditMode,
          label: "Referencia",
          name: "shipment-detail-origen-referencia",
          type: "text",
          value: originReference
        }
      )),
      /* @__PURE__ */ React54.createElement(FlexComponent18, { gap: "var(--otk-theme-spacing-s, 8px)", width: "100%" }, /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeOriginAddress,
          isDisabled: !isEditMode,
          label: "Direccion",
          name: "shipment-detail-origen-direccion",
          type: "text",
          value: originAddress
        }
      )),
      /* @__PURE__ */ React54.createElement(FlexComponent18, { gap: "var(--otk-theme-spacing-s, 8px)", width: "100%" }, /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeOriginPostalCode,
          isDisabled: !isEditMode,
          label: "C. Postal",
          name: "shipment-detail-origen-codigo-postal",
          type: "text",
          value: originPostalCode
        }
      ), /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeOriginCity,
          isDisabled: !isEditMode,
          label: "Poblacion",
          name: "shipment-detail-origen-poblacion",
          type: "text",
          value: originCity
        }
      ), /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeOriginAgency,
          isDisabled: !isEditMode,
          label: "Agencia de Origen",
          name: "shipment-detail-origen-agencia-origen",
          type: "text",
          value: originAgency
        }
      ))
    )), /* @__PURE__ */ React54.createElement(DetailSomethingComponent.Section, null, /* @__PURE__ */ React54.createElement(DetailSomethingComponent.Section.Title, null, "Destino"), /* @__PURE__ */ React54.createElement(
      FlexComponent18,
      {
        flexDirection: "column",
        gap: "var(--otk-theme-spacing-s, 8px)",
        width: "100%"
      },
      /* @__PURE__ */ React54.createElement(FlexComponent18, { gap: "var(--otk-theme-spacing-s, 8px)", width: "100%" }, /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeDestinationAddressee,
          isDisabled: !isEditMode,
          label: "Destinatario",
          name: "shipment-detail-destino-addressee",
          type: "text",
          value: destinationAddressee
        }
      )),
      /* @__PURE__ */ React54.createElement(FlexComponent18, { gap: "var(--otk-theme-spacing-s, 8px)", width: "100%" }, /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeDestinationContactPoint,
          isDisabled: !isEditMode,
          label: "P. Contacto",
          name: "shipment-detail-destino-p-contacto",
          type: "text",
          value: destinationContactPoint
        }
      )),
      /* @__PURE__ */ React54.createElement(FlexComponent18, { gap: "var(--otk-theme-spacing-s, 8px)", width: "100%" }, /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeDestinationCIFNIF,
          isDisabled: !isEditMode,
          label: "CIF/NIF",
          name: "shipment-detail-destino-cif-nif",
          type: "text",
          value: destinationCIFNIF
        }
      ), /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeDestinationPhone,
          isDisabled: !isEditMode,
          label: "Telefono",
          name: "shipment-detail-destino-telefono",
          type: "text",
          value: destinationPhone
        }
      ), /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeDestinationShipmentNumber,
          isDisabled: !isEditMode,
          label: "Referencia",
          name: "shipment-detail-destino-referencia",
          type: "text",
          value: destinationShipmentNumber
        }
      )),
      /* @__PURE__ */ React54.createElement(FlexComponent18, { gap: "var(--otk-theme-spacing-s, 8px)", width: "100%" }, /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeDestinationAddress,
          isDisabled: !isEditMode,
          label: "Direccion",
          name: "shipment-detail-destino-direccion",
          type: "text",
          value: destinationAddress
        }
      )),
      /* @__PURE__ */ React54.createElement(FlexComponent18, { gap: "var(--otk-theme-spacing-s, 8px)", width: "100%" }, /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeDestinationPostalCode,
          isDisabled: !isEditMode,
          label: "C. Postal",
          name: "shipment-detail-destino-codigo-postal",
          type: "text",
          value: destinationPostalCode
        }
      ), /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeDestinationCity,
          isDisabled: !isEditMode,
          label: "Poblacion",
          name: "shipment-detail-destino-poblacion",
          type: "text",
          value: destinationCity
        }
      ), /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          handleChangeValue: handleChangeDestinationAgency,
          isDisabled: !isEditMode,
          label: "Agencia de destino",
          name: "shipment-detail-destino-agencia-destino",
          type: "text",
          value: destinationAgency
        }
      ))
    )), /* @__PURE__ */ React54.createElement(DetailSomethingComponent.Section, null, /* @__PURE__ */ React54.createElement(DetailSomethingComponent.Section.Title, null, "Bultos"), /* @__PURE__ */ React54.createElement(
      FlexComponent18,
      {
        flexDirection: "column",
        gap: "var(--otk-theme-spacing-s, 8px)",
        width: "100%"
      },
      /* @__PURE__ */ React54.createElement(SeparatorComponent, { label: "Total registrado en origen" }),
      /* @__PURE__ */ React54.createElement(FlexComponent18, { gap: "var(--otk-theme-spacing-s, 8px)", width: "100%" }, /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          isDisabled: !isEditMode,
          label: "Bultos",
          name: "shipment-detail-bultos",
          type: "text",
          value: (_a = shipment == null ? void 0 : shipment.cargos.length.toString()) != null ? _a : "",
          width: "50px"
        }
      ), /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          isDisabled: !isEditMode,
          label: "Peso",
          name: "shipment-detail-peso",
          type: "text",
          value: (_b = shipment == null ? void 0 : shipment.weight.toString()) != null ? _b : ""
        }
      ), /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          isDisabled: !isEditMode,
          label: "Alto",
          name: "shipment-detail-alto",
          type: "text",
          value: (_c = shipment == null ? void 0 : shipment.maxHeight.toString()) != null ? _c : ""
        }
      ), /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          isDisabled: !isEditMode,
          label: "Ancho",
          name: "shipment-detail-ancho",
          type: "text",
          value: (_d = shipment == null ? void 0 : shipment.maxWidth.toString()) != null ? _d : ""
        }
      ), /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          isDisabled: !isEditMode,
          label: "Largo",
          name: "shipment-detail-largo",
          type: "text",
          value: (_e = shipment == null ? void 0 : shipment.maxLength.toString()) != null ? _e : ""
        }
      ), /* @__PURE__ */ React54.createElement(
        InputComponent,
        {
          isDisabled: !isEditMode,
          label: "Volumen",
          name: "shipment-detail-volumen",
          type: "text",
          value: (_f = shipment == null ? void 0 : shipment.totalVolume.toString()) != null ? _f : ""
        }
      )),
      /* @__PURE__ */ React54.createElement(SeparatorComponent, { label: "Desglose por bulto" }),
      shipment == null ? void 0 : shipment.cargos.map((cargo, index) => /* @__PURE__ */ React54.createElement(
        FlexComponent18,
        {
          gap: "var(--otk-theme-spacing-s, 8px)",
          key: cargo.id,
          width: "100%"
        },
        /* @__PURE__ */ React54.createElement(
          InputComponent,
          {
            isDisabled: !isEditMode,
            label: "",
            name: `shipment-detail-bultos-${cargo.id}`,
            type: "text",
            value: `00${index + 1}`,
            width: "50px"
          }
        ),
        /* @__PURE__ */ React54.createElement(
          InputComponent,
          {
            isDisabled: !isEditMode,
            label: "Peso",
            name: `shipment-detail-peso-${cargo.id}`,
            type: "text",
            value: cargo.weight.toString()
          }
        ),
        /* @__PURE__ */ React54.createElement(
          InputComponent,
          {
            isDisabled: !isEditMode,
            label: "Alto",
            name: `shipment-detail-alto-${cargo.id}`,
            type: "text",
            value: cargo.maxHeight.toString()
          }
        ),
        /* @__PURE__ */ React54.createElement(
          InputComponent,
          {
            isDisabled: !isEditMode,
            label: "Ancho",
            name: `shipment-detail-ancho-${cargo.id}`,
            type: "text",
            value: cargo.maxWidth.toString()
          }
        ),
        /* @__PURE__ */ React54.createElement(
          InputComponent,
          {
            isDisabled: !isEditMode,
            label: "Largo",
            name: `shipment-detail-largo-${cargo.id}`,
            type: "text",
            value: cargo.maxLength.toString()
          }
        ),
        /* @__PURE__ */ React54.createElement(
          InputComponent,
          {
            isDisabled: !isEditMode,
            label: "Volumen",
            name: `shipment-detail-volumen-${cargo.id}`,
            type: "text",
            value: cargo.totalVolume.toString()
          }
        )
      ))
    ))), /* @__PURE__ */ React54.createElement(DetailSomethingComponent.RightSidebar, null, /* @__PURE__ */ React54.createElement(
      MonitorComponent,
      {
        events: shipmentEvents,
        hiddenTags: [
          { tagName: "shipmentStateChanged", tagDisplayName: "Estados" },
          { tagName: "incident", tagDisplayName: "Incidentes" },
          { tagName: "received", tagDisplayName: "Lecturas" }
        ],
        title: "logs"
      }
    ))))
  )));
}

// src/pages/smart-views-list/smart-views-list-page.tsx
import React58 from "react";
import { FlexComponent as FlexComponent20, PageContent as PageContent4, PageLayout as PageLayout4 } from "@ontruck/fe-ui";
import { Toaster as Toaster3 } from "sonner";
import { DetailSomethingComponent as DetailSomethingComponent2 } from "@ontruck/fe-core";

// src/pages/smart-views-list/smart-views-table/smart-views-table-component.tsx
import React57, { useCallback as useCallback10 } from "react";
import { TableComponent as TableComponent4, TableErrorComponent as TableErrorComponent3 } from "@ontruck/fe-ui";

// src/pages/smart-views-list/smart-views-table/smart-views-table-row-component.tsx
import React56 from "react";
import { AccordionComponent as AccordionComponent3, AccordionTriggerComponent as AccordionTriggerComponent3 } from "@ontruck/fe-ui";
import styled19 from "styled-components";

// src/pages/smart-views-list/smart-views-table/smart-views-table-row-parent-component.tsx
import React55, { useState as useState11 } from "react";
import { ButtonComponent, FlexComponent as FlexComponent19, TableCellComponent as TableCellComponent13, TextComponent as TextComponent15 } from "@ontruck/fe-ui";
import { TrashLineIcon } from "@ontruck/fe-icons";
import { toast as toast6 } from "sonner";
import { mutate as mutate5 } from "swr";

// src/business/smart-views/delete-smart-view-api.ts
function deleteSmartViewApi(_0, _1) {
  return __async(this, arguments, function* ({ token, apiBase }, smartViewId) {
    const baseURL = `${apiBase}/v1/price-negotiation/filter-views/`;
    const url = `${baseURL}${smartViewId}/`;
    const response = yield fetch(url, {
      method: "DELETE",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!response.ok) {
      throw new Error("Failed to delete smart views");
    }
  });
}

// src/pages/smart-views-list/smart-views-table/smart-views-table-columns.ts
var SMART_VIEWS_TABLE_COLUMNS = {
  name: {
    id: "1",
    width: "256px",
    label: "VISTA"
  },
  hiddenColumns: {
    id: "2",
    width: "320px",
    label: "COLUMNAS OCULTAS"
  },
  hiddenFilters: {
    id: "3",
    width: "320px",
    label: "FILTROS OCULTOS"
  },
  filterValues: {
    id: "4",
    width: "320px",
    label: "FILTROS SELECCIONADOS"
  },
  actions: {
    id: "5",
    width: "64px",
    label: ""
  }
};

// src/pages/smart-views-list/smart-views-table/smart-views-table-row-parent-component.tsx
var cellPadding = "8px 0px 8px 0px";
var cellAlignItems = "start";
function SmartViewsTableRowParentComponent({
  smartViewItem
}) {
  const {
    shipmentFilters,
    shipmentsSmartViews,
    setShipmentsSmartViews,
    handleChangeShipmentSmartView
  } = useShipmentsListFiltersHook();
  const hiddenColumnsText = smartViewItem.hiddenColumns.map(
    (column) => SmartViewsService.getColumnText(column)
  );
  const hiddenFiltersText = smartViewItem.hiddenFilters.map(
    (filter) => SmartViewsService.getFilterText(filter)
  );
  const filterValueTexts = smartViewItem.filterValues.map(
    (filterValue) => SmartViewsService.getSmartViewFilterValueText(filterValue)
  );
  const isDefaultFilter = Number(smartViewItem.id) <= 0;
  const color = isDefaultFilter ? "var(--grey500)" : "var(--grey900)";
  const config2 = useConfigHook();
  const [isDeleting, setIsDeleting] = useState11(false);
  const handleDeleteSmartView = () => __async(this, null, function* () {
    try {
      setIsDeleting(true);
      yield deleteSmartViewApi(config2, smartViewItem.id);
      void mutate5((key) => {
        return typeof key === "string" && key.startsWith("last-mile/smart-views");
      });
      if (shipmentFilters.shipmentSmartView.id === smartViewItem.id) {
        handleChangeShipmentSmartView(DEFAULT_SHIPMENT_SMART_VIEW);
      }
      setShipmentsSmartViews(
        shipmentsSmartViews.filter((smartView) => smartView.id !== smartViewItem.id)
      );
      toast6.success("Vista eliminada correctamente");
    } catch (error) {
      toast6.error("Error al eliminar la vista");
    } finally {
      setIsDeleting(false);
    }
  });
  return /* @__PURE__ */ React55.createElement(FlexComponent19, { alignItems: "center", borderTop: "1px solid var(--grey-300, #CCD7E0)" }, /* @__PURE__ */ React55.createElement(TableCellComponent13, { alignItems: cellAlignItems, width: SMART_VIEWS_TABLE_COLUMNS.name.width }, /* @__PURE__ */ React55.createElement(FlexComponent19, { flexDirection: "column", gap: "4px", padding: cellPadding }, /* @__PURE__ */ React55.createElement(TextComponent15, { color, fontWeight: "bold", key: smartViewItem.name, size: "s" }, smartViewItem.name))), /* @__PURE__ */ React55.createElement(
    TableCellComponent13,
    {
      alignItems: cellAlignItems,
      width: SMART_VIEWS_TABLE_COLUMNS.hiddenColumns.width
    },
    /* @__PURE__ */ React55.createElement(
      FlexComponent19,
      {
        alignItems: cellAlignItems,
        flexDirection: "column",
        gap: "8px",
        padding: cellPadding
      },
      hiddenColumnsText.map((columnText) => /* @__PURE__ */ React55.createElement(TextComponent15, { key: columnText, size: "s" }, columnText))
    )
  ), /* @__PURE__ */ React55.createElement(
    TableCellComponent13,
    {
      alignItems: cellAlignItems,
      width: SMART_VIEWS_TABLE_COLUMNS.hiddenFilters.width
    },
    /* @__PURE__ */ React55.createElement(
      FlexComponent19,
      {
        alignItems: cellAlignItems,
        flexDirection: "column",
        gap: "8px",
        padding: cellPadding
      },
      hiddenFiltersText.map((filterText) => /* @__PURE__ */ React55.createElement(TextComponent15, { key: filterText, size: "s" }, filterText))
    )
  ), /* @__PURE__ */ React55.createElement(
    TableCellComponent13,
    {
      alignItems: cellAlignItems,
      width: SMART_VIEWS_TABLE_COLUMNS.filterValues.width
    },
    /* @__PURE__ */ React55.createElement(
      FlexComponent19,
      {
        alignItems: cellAlignItems,
        flexDirection: "column",
        gap: "8px",
        padding: cellPadding
      },
      filterValueTexts.map((filterValueText) => /* @__PURE__ */ React55.createElement(
        FlexComponent19,
        {
          alignItems: "center",
          flexWrap: "wrap",
          gap: "8px",
          justifyContent: "start",
          key: filterValueText.filterText
        },
        " ",
        /* @__PURE__ */ React55.createElement(TextComponent15, { fontWeight: "bold", size: "s" }, filterValueText.filterText, ":"),
        /* @__PURE__ */ React55.createElement(TextComponent15, { size: "s" }, filterValueText.valueToDisplay)
      ))
    )
  ), /* @__PURE__ */ React55.createElement(
    TableCellComponent13,
    {
      alignItems: cellAlignItems,
      borderRight: "none",
      padding: cellPadding,
      width: SMART_VIEWS_TABLE_COLUMNS.actions.width
    },
    /* @__PURE__ */ React55.createElement(
      ButtonComponent,
      {
        disabled: isDefaultFilter || isDeleting,
        onClick: () => {
          void handleDeleteSmartView();
        },
        variant: "ghost"
      },
      /* @__PURE__ */ React55.createElement(TrashLineIcon, { color, sizeInPixels: 24 })
    )
  ));
}

// src/pages/smart-views-list/smart-views-table/smart-views-table-row-component.tsx
var RowWrapperComponent3 = styled19.div`
  header {
    display: flex;
    padding: unset;
    border-top: none;
    border-bottom: none;

    > div {
      flex: 1;
    }

    :hover {
      cursor: default;
    }
  }
`;
var StyledAccordionComponent3 = styled19(AccordionComponent3)`
  height: auto;
  border-left: none;
  border-right: none;
`;
var StyledAccordionTriggerComponent3 = styled19(AccordionTriggerComponent3)`
  padding: unset;
  border-top: 3px solid var(--grey-200, #ccd7e0);
  border-bottom: none;
`;
function SmartViewsTableRowComponent({
  smartViewItem
}) {
  return /* @__PURE__ */ React56.createElement(RowWrapperComponent3, null, /* @__PURE__ */ React56.createElement(StyledAccordionComponent3, null, /* @__PURE__ */ React56.createElement(StyledAccordionTriggerComponent3, { open: false }, /* @__PURE__ */ React56.createElement(SmartViewsTableRowParentComponent, { smartViewItem }))));
}

// src/pages/smart-views-list/smart-views-table/smart-views-table-component.tsx
function SmartViewsTableComponent({
  smartViews,
  error,
  isLoading
}) {
  const headerColumns = SMART_VIEWS_TABLE_COLUMNS;
  const getSmartViewsRowsComponent = useCallback10(() => {
    return smartViews.map((smartViewItem) => {
      return /* @__PURE__ */ React57.createElement(SmartViewsTableRowComponent, { key: smartViewItem.id, smartViewItem });
    });
  }, [smartViews]);
  return /* @__PURE__ */ React57.createElement(
    TableComponent4,
    {
      columns: headerColumns,
      emptyStateMessage: "No se han encontrado vistas",
      errorComponent: /* @__PURE__ */ React57.createElement(TableErrorComponent3, { errorLabel: "Error al cargar las vistas" }),
      isError: error !== void 0,
      isLoading,
      isResponsive: true,
      numberOfItems: smartViews.length,
      rowsComponents: getSmartViewsRowsComponent(),
      scrollCacheKey: "smart-views"
    }
  );
}

// src/pages/smart-views-list/smart-views-list-page.tsx
function SmartViewsListPage({
  onGoToShipmentsList,
  onGoToSmartViewsNew
}) {
  const availableShipmentsSmartViews = useSmartViewsDataHook("shipments");
  return /* @__PURE__ */ React58.createElement(PageLayout4, null, /* @__PURE__ */ React58.createElement(PageContent4, null, /* @__PURE__ */ React58.createElement(FlexComponent20, { alignItems: "stretch", flex: "1", flexDirection: "row", gap: "0", overflowY: "hidden" }, /* @__PURE__ */ React58.createElement(DetailSomethingComponent2, null, /* @__PURE__ */ React58.createElement(DetailSomethingComponent2.Header, { onClose: onGoToShipmentsList }, /* @__PURE__ */ React58.createElement(DetailSomethingComponent2.Header.Label, null, "Env\xEDos"), /* @__PURE__ */ React58.createElement(DetailSomethingComponent2.Header.Title, null, "Vistas")), /* @__PURE__ */ React58.createElement(DetailSomethingComponent2.Content, null, /* @__PURE__ */ React58.createElement(
    SmartViewsTableComponent,
    {
      error: void 0,
      isLoading: false,
      smartViews: availableShipmentsSmartViews
    }
  )), /* @__PURE__ */ React58.createElement(
    DetailSomethingComponent2.Footer,
    {
      isNewMode: true,
      newButtonText: "Crear nueva vista",
      onNew: onGoToSmartViewsNew
    }
  )))), /* @__PURE__ */ React58.createElement(Toaster3, { richColors: true }));
}

// src/pages/smart-views-new/smart-views-new-page.tsx
import React59, { useMemo as useMemo17, useState as useState12 } from "react";
import {
  PageContent as PageContent5,
  PageLayout as PageLayout5,
  FlexComponent as FlexComponent21,
  Input as Input10,
  SectionBody,
  SectionLine,
  MultiSelectInputComponent as MultiSelectInputComponent2,
  TextComponent as TextComponent16
} from "@ontruck/fe-ui";
import { DetailSomethingComponent as DetailSomethingComponent3 } from "@ontruck/fe-core";
import styled20 from "styled-components";
import { toast as toast7, Toaster as Toaster4 } from "sonner";
import { mutate as mutate6 } from "swr";

// src/business/smart-views/new-smart-view-api.ts
function newSmartViewApi(_0, _1) {
  return __async(this, arguments, function* ({ token, apiBase }, smartViewDto) {
    const baseURL = `${apiBase}/v1/price-negotiation/filter-views/`;
    const url = baseURL;
    const response = yield fetch(url, {
      method: "POST",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(smartViewDto)
    });
    if (!response.ok) {
      throw new Error("Failed to create smart views");
    }
  });
}

// src/pages/smart-views-new/smart-views-new-page.tsx
var CheckboxListBodyComponent = styled20(SectionBody)`
  display: flex;
  flex-direction: column;
  gap: 0px;
  align-items: start;
`;
var CheckboxListItemComponent = styled20(SectionLine)`
  display: flex;
  align-items: center;
  width: 100%;
  label {
    border-top: 1px solid var(--grey200);
    border-bottom: 1px solid var(--grey200);
    color: var(--grey700);
    cursor: pointer;
    width: 100%;
    padding-bottom: 16px;
    padding-top: 16px;
    padding-left: 24px;
    padding-right: 24px;
  }
  input {
    margin-left: auto;
    flex-shrink: 0;
    border-radius: 4px;
    background: var(--grey100);
    border: 1px solid var(--grey500);
  }
  input {
    outline: none;
    border: none;
    border-image: none;
    appearance: none;
    background: var(--grey100);
    border: 1px solid var(--grey500);
  }
  input:checked {
    background-color: var(--accent-color-blue);
    border: 1px solid var(--accent-color-blue);
  }
  input:checked::after {
    border: 0;
  }
  input:disabled:checked {
    border: 1px solid var(--grey100);
    background-color: var(--grey500);
  }
  input:disabled::after {
    border: 0;
  }
`;
var SingleLineCheckboxItem = styled20(CheckboxListItemComponent)`
  width: 100%;
`;
var NonBinaryCheckboxContainer = styled20.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 64px;
`;
var NonBinaryCheckbox = styled20.div`
  width: 20px;
  height: 20px;
  background: var(--grey500);
  border-radius: 4px;
`;
function SmartViewsNewPage({
  onCloseDetail
}) {
  const config2 = useConfigHook();
  const [name, setName] = useState12("");
  const hasNameError = name.trim() === "";
  const [showError, setShowError] = useState12(false);
  const [isSaving, setIsSaving] = useState12(false);
  const [selectedFilters, setSelectedFilters] = useState12(
    Object.values(AVAILABLE_FILTERS_TO_HIDE)
  );
  const onFilterClick = (filter) => {
    setSelectedFilters((prev) => {
      if (prev.includes(filter)) {
        return prev.filter((f) => f !== filter);
      }
      return [...prev, filter];
    });
  };
  const filtersToHide = Object.values(AVAILABLE_FILTERS_TO_HIDE).filter(
    (filter) => !selectedFilters.includes(filter)
  );
  const [selectedColumns, setSelectedColumns] = useState12(
    Object.values(AVAILABLE_COLUMNS_TO_HIDE)
  );
  const onColumnClick = (column) => {
    setSelectedColumns((prev) => {
      if (prev.includes(column)) {
        return prev.filter((c) => c !== column);
      }
      return [...prev, column];
    });
  };
  const columnsToHide = Object.values(AVAILABLE_COLUMNS_TO_HIDE).filter(
    (column) => !selectedColumns.includes(column)
  );
  const isDisabled = useMemo17(() => {
    return Boolean(showError && hasNameError || isSaving);
  }, [hasNameError, showError, isSaving]);
  const { shipmentFiltersOptions } = useShipmentsListFiltersHook();
  const stateOptions = getShipmentStateOptions(shipmentFiltersOptions);
  const [state, setState] = useState12([]);
  const serviceOptions = getShipmentServiceOptions(shipmentFiltersOptions);
  const [service, setService] = useState12("");
  const [destinationZipCode, setDestinationZipCode] = useState12("");
  const [shipperId, setShipperId] = useState12("");
  const [driverId, setDriverId] = useState12("");
  const [search, setSearch] = useState12("");
  const [lastReceptionInDelegation, setLastReceptionInDelegation] = useState12(false);
  const { shippers } = useGetShippersHook({ config: config2 });
  const { drivers } = useGetDriversHook({ config: config2 });
  const onSave = () => __async(this, null, function* () {
    var _a, _b;
    try {
      setShowError(true);
      if (hasNameError || isDisabled) {
        return;
      }
      setIsSaving(true);
      const filterValues = [];
      if (state.length > 0) {
        state.forEach((stateValue) => {
          filterValues.push({
            filter: "state",
            value: stateValue
          });
        });
      }
      if (service.trim() !== "") {
        filterValues.push({
          filter: "service",
          value: service
        });
      }
      if (destinationZipCode.trim() !== "") {
        filterValues.push({
          filter: "destinationZipCode",
          value: destinationZipCode
        });
      }
      if (search.trim() !== "") {
        filterValues.push({
          filter: "search",
          value: search
        });
      }
      if (shipperId.trim() !== "") {
        const shipperName = (_a = shippers.find(
          (shipper) => shipper.id.toString() === shipperId
        )) == null ? void 0 : _a.companyName;
        filterValues.push({
          filter: "shipper",
          value: shipperId,
          displayValue: shipperName
        });
      }
      if (driverId.trim() !== "") {
        const driverName = (_b = drivers.find((driver) => driver.id.toString() === driverId)) == null ? void 0 : _b.contactName;
        filterValues.push({
          filter: "driver",
          value: driverId,
          displayValue: driverName
        });
      }
      if (lastReceptionInDelegation) {
        filterValues.push({
          filter: "lastReceptionInDelegation",
          value: "true"
        });
      }
      const data = {
        hiddenFilters: filtersToHide,
        hiddenColumns: columnsToHide,
        filterValues,
        type: "shipments"
      };
      const dto = {
        name,
        filters: JSON.stringify(data)
      };
      yield newSmartViewApi(config2, dto);
      toast7.success("Vista creada correctamente");
      void mutate6((key) => {
        return typeof key === "string" && key.startsWith("last-mile/smart-views");
      });
      setIsSaving(false);
      onCloseDetail == null ? void 0 : onCloseDetail();
    } catch (error) {
      toast7.error("Error al crear la vista");
      setIsSaving(false);
    }
  });
  return /* @__PURE__ */ React59.createElement(PageLayout5, null, /* @__PURE__ */ React59.createElement(PageContent5, null, /* @__PURE__ */ React59.createElement(
    FlexComponent21,
    {
      alignItems: "stretch",
      flex: "1",
      flexDirection: "row",
      gap: "0",
      overflow: "hidden",
      overflowY: "hidden"
    },
    /* @__PURE__ */ React59.createElement(DetailSomethingComponent3, null, /* @__PURE__ */ React59.createElement(DetailSomethingComponent3.Header, { onClose: onCloseDetail }, /* @__PURE__ */ React59.createElement(DetailSomethingComponent3.Header.Label, null, "Env\xEDos"), /* @__PURE__ */ React59.createElement(DetailSomethingComponent3.Header.Title, null, "Crear nueva vista")), /* @__PURE__ */ React59.createElement(DetailSomethingComponent3.Content, null, /* @__PURE__ */ React59.createElement(DetailSomethingComponent3.Sections, null, /* @__PURE__ */ React59.createElement(DetailSomethingComponent3.Section, null, /* @__PURE__ */ React59.createElement(
      FlexComponent21,
      {
        flexDirection: "column",
        gap: "var(--otk-theme-spacing-s, 8px)",
        width: "100%"
      },
      /* @__PURE__ */ React59.createElement(FlexComponent21, { gap: "var(--otk-theme-spacing-s, 8px)", width: "100%" }, /* @__PURE__ */ React59.createElement(
        Input10,
        {
          handleChangeEvent: (e) => {
            setName(e.target.value);
          },
          hasError: Boolean(hasNameError && showError),
          isRequired: true,
          label: "Nombre de la vista",
          name: "smart-view-name",
          type: "text",
          value: name
        }
      ))
    )), /* @__PURE__ */ React59.createElement(DetailSomethingComponent3.Section, null, /* @__PURE__ */ React59.createElement(DetailSomethingComponent3.Section.Title, null, "Filtros aplicados"), /* @__PURE__ */ React59.createElement(
      FlexComponent21,
      {
        flexDirection: "column",
        gap: "var(--otk-theme-spacing-s, 8px)",
        width: "100%"
      },
      /* @__PURE__ */ React59.createElement(FlexComponent21, { gap: "var(--otk-theme-spacing-s, 8px)", width: "100%" }, /* @__PURE__ */ React59.createElement(
        MultiSelectInputComponent2,
        {
          label: "Estado",
          onChange: (values) => {
            setState(values);
          },
          options: stateOptions,
          values: state
        }
      ), /* @__PURE__ */ React59.createElement(
        Input10,
        {
          handleChangeValue: (_, value) => {
            if (value !== void 0)
              setService(value);
          },
          label: "Servicio",
          name: "service",
          options: serviceOptions,
          type: "select",
          value: service
        }
      )),
      /* @__PURE__ */ React59.createElement(FlexComponent21, { gap: "var(--otk-theme-spacing-s, 8px)", width: "100%" }, /* @__PURE__ */ React59.createElement(FlexComponent21, { width: "50%" }, /* @__PURE__ */ React59.createElement(
        Input10,
        {
          handleChangeEvent: (e) => {
            const event = e;
            const newValue = event.target.value;
            setDestinationZipCode(newValue);
          },
          label: "CP de entrega",
          name: "destination-zip-code",
          type: "text",
          value: destinationZipCode
        }
      )), /* @__PURE__ */ React59.createElement(FlexComponent21, { width: "50%" }, /* @__PURE__ */ React59.createElement(
        CheckboxInputContainer,
        {
          onClick: (e) => {
            e.preventDefault();
            setLastReceptionInDelegation(!lastReceptionInDelegation);
          },
          style: { width: "100%" }
        },
        /* @__PURE__ */ React59.createElement("label", { htmlFor: "last-reception-in-delegation" }, /* @__PURE__ */ React59.createElement(TextComponent16, null, "\xDAltima lectura en mi delegaci\xF3n")),
        /* @__PURE__ */ React59.createElement(
          "input",
          {
            checked: lastReceptionInDelegation,
            id: "last-reception-in-delegation",
            name: "last-reception-in-delegation",
            onChange: (e) => {
              setLastReceptionInDelegation(e.target.checked);
            },
            type: "checkbox"
          }
        )
      ))),
      /* @__PURE__ */ React59.createElement(FlexComponent21, { gap: "var(--otk-theme-spacing-s, 8px)", width: "100%" }, /* @__PURE__ */ React59.createElement(FlexComponent21, { width: "50%" }, /* @__PURE__ */ React59.createElement(
        ShipperInputComponent,
        {
          config: config2,
          handleChangeValue: (_, value) => {
            if (value === void 0) {
              setShipperId("");
            } else {
              setShipperId(value.toString());
            }
          },
          value: shipperId === "" ? void 0 : shipperId
        }
      )), /* @__PURE__ */ React59.createElement(FlexComponent21, { width: "50%" }, /* @__PURE__ */ React59.createElement(
        DriverInputComponent,
        {
          config: config2,
          handleChangeValue: (_, value) => {
            if (value === void 0) {
              setDriverId("");
            } else {
              setDriverId(value.toString());
            }
          },
          value: driverId === "" ? void 0 : driverId
        }
      ))),
      /* @__PURE__ */ React59.createElement(FlexComponent21, { gap: "var(--otk-theme-spacing-s, 8px)", width: "100%" }, /* @__PURE__ */ React59.createElement(FlexComponent21, { width: "50%" }, /* @__PURE__ */ React59.createElement(
        Input10,
        {
          handleChangeEvent: (e) => {
            const event = e;
            const newValue = event.target.value;
            setSearch(newValue);
          },
          label: "B\xFAsqueda",
          name: "search",
          type: "text",
          value: search
        }
      )))
    )), /* @__PURE__ */ React59.createElement(DetailSomethingComponent3.Section, null, /* @__PURE__ */ React59.createElement(DetailSomethingComponent3.Section.Title, null, "Filtros disponibles en la tabla"), /* @__PURE__ */ React59.createElement(
      FlexComponent21,
      {
        flexDirection: "column",
        gap: "var(--otk-theme-spacing-s, 8px)",
        width: "100%"
      },
      /* @__PURE__ */ React59.createElement(CheckboxListBodyComponent, null, Object.values(ALWAYS_VISIBLE_FILTERS).map((filter) => /* @__PURE__ */ React59.createElement(SingleLineCheckboxItem, { key: filter }, /* @__PURE__ */ React59.createElement(
        Input10,
        {
          isDisabled: true,
          label: SmartViewsService.getFilterText(filter),
          name: `filter-${filter}`,
          type: "checkbox",
          value: "true"
        }
      ))), Object.values(AVAILABLE_FILTERS_TO_HIDE).map((filter) => /* @__PURE__ */ React59.createElement(SingleLineCheckboxItem, { key: filter }, /* @__PURE__ */ React59.createElement(
        Input10,
        {
          handleChangeValue: (_name, _value) => {
            onFilterClick(filter);
          },
          isDisabled: isSaving,
          label: SmartViewsService.getFilterText(filter),
          name: `filter-${filter}`,
          type: "checkbox",
          value: selectedFilters.includes(filter).toString()
        }
      ))))
    )), /* @__PURE__ */ React59.createElement(DetailSomethingComponent3.Section, null, /* @__PURE__ */ React59.createElement(DetailSomethingComponent3.Section.Title, null, "Columnas visibles en la tabla"), /* @__PURE__ */ React59.createElement(
      FlexComponent21,
      {
        flexDirection: "column",
        gap: "var(--otk-theme-spacing-s, 8px)",
        width: "100%"
      },
      /* @__PURE__ */ React59.createElement(CheckboxListBodyComponent, null, Object.values(COLUMNS_ALWAYS_VISIBLE).map((column) => /* @__PURE__ */ React59.createElement(SingleLineCheckboxItem, { key: column }, /* @__PURE__ */ React59.createElement(
        Input10,
        {
          isDisabled: true,
          label: SmartViewsService.getColumnText(column),
          name: `column-${column}`,
          type: "checkbox",
          value: "true"
        }
      ))), Object.values(AVAILABLE_COLUMNS_TO_HIDE).map((column) => /* @__PURE__ */ React59.createElement(SingleLineCheckboxItem, { key: column }, /* @__PURE__ */ React59.createElement(
        Input10,
        {
          handleChangeValue: (_name, _value) => {
            onColumnClick(column);
          },
          isDisabled: isSaving,
          label: SmartViewsService.getColumnText(column),
          name: `column-${column}`,
          type: "checkbox",
          value: selectedColumns.includes(column).toString()
        }
      ))))
    )))), /* @__PURE__ */ React59.createElement(
      DetailSomethingComponent3.Footer,
      {
        isDisabled,
        isNewMode: true,
        isSaving,
        newButtonText: "Guardar vista",
        onNew: () => {
          void onSave();
        }
      }
    ))
  )), /* @__PURE__ */ React59.createElement(Toaster4, { richColors: true }));
}

// src/pages/dashboard/dashboard-page.tsx
import React61, { useEffect as useEffect7, useState as useState13 } from "react";
import { Input as Input11, PageContent as PageContent6, PageLayout as PageLayout6 } from "@ontruck/fe-ui";
import { createPortal as createPortal3 } from "react-dom";

// src/pages/dashboard/dashboard-component.tsx
import { FlexComponent as FlexComponent22, TextComponent as TextComponent17 } from "@ontruck/fe-ui";
import React60 from "react";
import styled21 from "styled-components";

// src/pages/dashboard/dashboard-data-hook.tsx
import useSWR8 from "swr";
var RELOAD_DASHBOARD_DATA_INTERVAL_IN_SECONDS = 30;
var calculateMetrics = (shipments, incidents) => {
  const shipmentIdsInIncidentState = shipments.filter((shipment) => shipment.state === "incident").map((shipment) => shipment.id);
  const relevantIncidents = incidents.filter(
    (incident) => incident.cargo.shipment && shipmentIdsInIncidentState.includes(incident.cargo.shipment.id.toString())
  );
  const shipmentsByState = shipments.reduce((acc, shipment) => {
    const state = shipment.state;
    acc[state] = (acc[state] || 0) + 1;
    return acc;
  }, {});
  const shipmentsData = Object.entries(shipmentsByState).map(([state, count]) => ({
    state,
    count,
    color: ShipmentsStateService.getShipmentStateColor(state)
  }));
  const finalShipmentsData = shipmentsData.sort((a, b) => b.count - a.count);
  const openIncidents = relevantIncidents.filter((incident) => !incident.resolved);
  const resolvedIncidents = relevantIncidents.filter((incident) => incident.resolved);
  let incidentsData = [];
  if (relevantIncidents.length === 0 && shipmentIdsInIncidentState.length > 0) {
    incidentsData = [
      {
        state: "Abiertas",
        count: shipmentIdsInIncidentState.length,
        color: "#D31B4C"
      }
    ];
  } else {
    incidentsData = [
      {
        state: "Abiertas",
        count: openIncidents.length,
        color: "#D31B4C"
      },
      {
        state: "Cerradas",
        count: resolvedIncidents.length,
        color: "#28A745"
      }
    ];
  }
  const totalShipments = shipments.length;
  const deliveryPercentage = totalShipments > 0 ? Math.round((shipmentsByState.delivered || 0) / totalShipments * 100) : 0;
  const objectivesData = [
    {
      state: "Cumplido",
      count: deliveryPercentage,
      color: "#28A745"
    },
    {
      state: "Pendiente",
      count: 100 - deliveryPercentage,
      color: "#FFC107"
    }
  ];
  const deliveryLevel24h = Math.round(Math.random() * 30) + 70;
  const deliveryLevel48h = Math.round(Math.random() * 20) + 80;
  return {
    shipments: finalShipmentsData,
    incidents: incidentsData,
    objectives: objectivesData,
    deliveryLevel24h,
    deliveryLevel48h,
    totalShipments,
    dateRange: `${(/* @__PURE__ */ new Date()).toISOString().split("T")[0]} - ${(/* @__PURE__ */ new Date()).toISOString().split("T")[0]}`
  };
};
var useDashboardDataHook = ({
  dateFrom,
  dateTo
}) => {
  const config2 = useConfigHook();
  const { selectedDelegationId } = useMyDelegationHook();
  const dashboardFilters = {
    shipmentSmartView: {
      id: "",
      name: "General",
      type: "shipment",
      hiddenColumns: [],
      hiddenFilters: [],
      filterValues: []
    },
    destinationZipCode: "",
    driverId: "",
    shipperId: "",
    page: 1,
    pageSize: 1e3,
    // Get all shipments for the date range
    search: "",
    service: "",
    state: [],
    focDateFrom: "",
    focDateTo: "",
    forDateFrom: "",
    forDateTo: "",
    createdAtDateFrom: dateFrom,
    createdAtDateTo: dateTo,
    receptionDateFrom: "",
    receptionDateTo: "",
    lastReceptionInDelegation: false,
    csCargos: [],
    csOrigins: [],
    csDestinations: []
  };
  const incidentFilters = {
    destinationZipCode: "",
    page: 1,
    pageSize: 1e3,
    // Get all incidents
    search: "",
    resolved: ""
  };
  const shipmentsKey = `dashboard/shipments/${dateFrom}-${dateTo}/${selectedDelegationId}`;
  const incidentsKey = `dashboard/incidents/${selectedDelegationId}`;
  const shipmentsFetcher = () => __async(void 0, null, function* () {
    return getShipmentsFetcher(config2, dashboardFilters, selectedDelegationId);
  });
  const incidentsFetcher = () => __async(void 0, null, function* () {
    return getIncidentsFetcher(config2, incidentFilters, selectedDelegationId);
  });
  const {
    data: shipmentsData,
    error: shipmentsError,
    isLoading: shipmentsLoading
  } = useSWR8(shipmentsKey, shipmentsFetcher, {
    refreshInterval: RELOAD_DASHBOARD_DATA_INTERVAL_IN_SECONDS * 1e3,
    revalidateIfStale: true
  });
  const {
    data: incidentsData,
    error: incidentsError,
    isLoading: incidentsLoading
  } = useSWR8(incidentsKey, incidentsFetcher, {
    refreshInterval: RELOAD_DASHBOARD_DATA_INTERVAL_IN_SECONDS * 1e3,
    revalidateIfStale: true
  });
  const shipmentsMapped = shipmentsData ? getShipmentsMapper(shipmentsData.results) : [];
  const incidentsMapped = incidentsData ? getIncidentsMapper(incidentsData.results) : [];
  const metrics = calculateMetrics(shipmentsMapped, incidentsMapped);
  metrics.dateRange = `${dateFrom} - ${dateTo}`;
  return {
    metrics,
    isLoading: shipmentsLoading || incidentsLoading,
    error: shipmentsError || incidentsError
  };
};

// src/pages/dashboard/dashboard-component.tsx
var DashboardWrapper = styled21.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  background: var(--grey-200, #e2e8ee);
  padding: 32px;
`;
var DashboardContainer = styled21.div`
  width: calc(1376px + 96px);
  height: calc(656px + 32px);
  display: grid;
  grid-template-columns: 320px 192px 432px 432px;
  grid-template-rows: 437px 219px;
  /* background: blue; */
  gap: 32px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0;
  margin-bottom: 0;
`;
var TallCard = styled21.div`
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03); */
  grid-row: 1 / 3;
  grid-column: 1 / 2;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
var TopCard = styled21.div`
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03); */
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
var BottomSection = styled21.div`
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03); */
  grid-row: 2 / 3;
  grid-column: 2 / 5;
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;
  overflow: hidden;
`;
var SmallCardsRow = styled21.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  align-items: stretch;
  height: 100%;
`;
var SmallCard = styled21.div`
  /* box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03); */
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  overflow: hidden;
`;
var PremiumCard = styled21.div`
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
var PremiumCardWithTitle = styled21(PremiumCard)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;
var PremiumCardTitle = styled21.div`
  font-size: 16px;
  color: var(--grey700);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;
var PremiumGraph = styled21.div`
  /* background: red; */
  /* height: 45%; */
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
var PremiumList = styled21.div`
  /* background: blue; */
  /* height: 45%; */
  width: 100%;
  padding: 16px;
`;
var PremiumKpiContainer = styled21(PremiumCard)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  /* background: green; */
`;
var PremiumKPIBase = styled21.div`
  width: 200px;
  margin-left: auto;
  margin-right: auto;
  /* border: 1px solid red; */
  display: flex;
  align-items: center;
  justify-content: center;
`;
var PremiumKPITitle = styled21(PremiumKPIBase)`
  font-size: 36px;
  color: var(--grey900);
  display: flex;
  align-items: center;
  justify-content: center;
`;
var PremiumKPIText = styled21(PremiumKPIBase)`
  font-size: 16px;
  color: var(--grey700);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
`;
var PremiumKPIBar = styled21(PremiumKPIBase)`
  background-color: var(--grey300);
  height: 16px;
  margin-top: 8px;
  padding: 0px;
  width: 150px;
  /* width: 100%; */
  border-radius: 4px;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: ${(props) => props.percentage}%;
    background-color: green;
    border-radius: 4px;
  }
`;
var TopCardsContainer = styled21.div`
  grid-column: 2 / 5;
  grid-row: 1 / 2;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  height: 100%;
`;
var PremiumListItem = styled21.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid var(--grey300);
  padding: 8px;
`;
var PremiumListItemText = styled21.div`
  display: flex;
  gap: 8px;
`;
var PremiumListItemBox = styled21.div`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background-color: var(--grey300);
`;
var LoadingContainer = styled21.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  font-size: 16px;
  color: var(--grey700);
`;
var ErrorContainer = styled21.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  font-size: 16px;
  color: var(--01, #d31b4c);
`;
var NoDataContainer = styled21.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  font-size: 16px;
  color: var(--grey700);
  text-align: center;
  gap: 8px;
  /* border: 1px solid red; */
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
`;
var DateRangeInfo = styled21.div`
  font-size: 12px;
  color: var(--grey500);
  text-align: center;
  padding: 8px;
  background: var(--grey100);
  border-radius: 4px;
  margin-bottom: 8px;
`;
function DonutChart({
  data,
  centerText
}) {
  const size = 250;
  const strokeWidth = 24;
  const radius = (size - strokeWidth) / 2;
  const center = size / 2;
  const total = data.reduce((sum, d) => sum + d.count, 0);
  let startAngleAcc = 0;
  function describeArc(cx, cy, r, startAngle, endAngle) {
    const start = polarToCartesian(cx, cy, r, endAngle);
    const end = polarToCartesian(cx, cy, r, startAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    return ["M", start.x, start.y, "A", r, r, 0, largeArcFlag, 0, end.x, end.y].join(" ");
  }
  function polarToCartesian(cx, cy, r, angle) {
    const rad = (angle - 90) * Math.PI / 180;
    return {
      x: cx + r * Math.cos(rad),
      y: cy + r * Math.sin(rad)
    };
  }
  const segments = [];
  data.forEach((d) => {
    const value = d.count;
    const angle = value / total * 360;
    const endAngle = startAngleAcc + angle;
    const path = describeArc(center, center, radius, startAngleAcc, endAngle);
    segments.push(
      /* @__PURE__ */ React60.createElement(
        "path",
        {
          d: path,
          fill: "none",
          key: d.state,
          stroke: d.color || ShipmentsStateService.getShipmentStateColor(d.state),
          strokeLinecap: "butt",
          strokeWidth
        }
      )
    );
    startAngleAcc = endAngle;
  });
  return /* @__PURE__ */ React60.createElement("svg", { height: size, style: { display: "block", margin: "0 auto" }, width: size }, segments, /* @__PURE__ */ React60.createElement(
    "text",
    {
      dominantBaseline: "middle",
      fill: "#2d3a4a",
      fontSize: "32",
      fontWeight: "bold",
      textAnchor: "middle",
      x: center,
      y: center - 4
    },
    total
  ), /* @__PURE__ */ React60.createElement(
    "text",
    {
      dominantBaseline: "middle",
      fill: "#7b8a99",
      fontSize: "16",
      textAnchor: "middle",
      x: center,
      y: center + 24
    },
    centerText || "bultos"
  ));
}
function HalfCircleChart({
  data
}) {
  const size = 250;
  const strokeWidth = 24;
  const radius = (size - strokeWidth) / 2;
  const center = size / 2;
  const total = 100;
  let startAngleAcc = 270;
  function describeArc(cx, cy, r, startAngle, endAngle) {
    const start = polarToCartesian(cx, cy, r, endAngle);
    const end = polarToCartesian(cx, cy, r, startAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";
    return ["M", start.x, start.y, "A", r, r, 0, largeArcFlag, 0, end.x, end.y].join(" ");
  }
  function polarToCartesian(cx, cy, r, angle) {
    const rad = (angle - 90) * Math.PI / 180;
    return {
      x: cx + r * Math.cos(rad),
      y: cy + r * Math.sin(rad)
    };
  }
  const segments = [];
  data.forEach((d) => {
    const value = d.count;
    const angle = value / total * 180;
    const endAngle = startAngleAcc + angle;
    const path = describeArc(center, center, radius, startAngleAcc, endAngle);
    segments.push(
      /* @__PURE__ */ React60.createElement(
        "path",
        {
          d: path,
          fill: "none",
          key: d.state,
          stroke: d.color || "#7b8a99",
          strokeLinecap: "butt",
          strokeWidth
        }
      )
    );
    startAngleAcc = endAngle;
  });
  const totalPercentage = data.slice(0, 2).reduce((sum, d) => sum + d.count, 0);
  return /* @__PURE__ */ React60.createElement(
    "svg",
    {
      height: size,
      style: { display: "block", margin: "0 auto", paddingTop: "48px" },
      width: size
    },
    segments,
    /* @__PURE__ */ React60.createElement(
      "text",
      {
        dominantBaseline: "middle",
        fill: "#2d3a4a",
        fontSize: "32",
        fontWeight: "bold",
        textAnchor: "middle",
        x: center,
        y: center + 20
      },
      totalPercentage,
      "%"
    ),
    /* @__PURE__ */ React60.createElement(
      "text",
      {
        dominantBaseline: "middle",
        fill: "#7b8a99",
        fontSize: "16",
        textAnchor: "middle",
        x: center,
        y: center + 48
      },
      "del objetivo"
    )
  );
}
function DashboardComponent({
  dateFrom,
  dateTo
}) {
  const { metrics, isLoading, error } = useDashboardDataHook({ dateFrom, dateTo });
  if (isLoading) {
    return /* @__PURE__ */ React60.createElement(DashboardWrapper, null, /* @__PURE__ */ React60.createElement(DashboardContainer, null, /* @__PURE__ */ React60.createElement(LoadingContainer, null, "Cargando datos del dashboard...")));
  }
  if (error) {
    return /* @__PURE__ */ React60.createElement(DashboardWrapper, null, /* @__PURE__ */ React60.createElement(DashboardContainer, null, /* @__PURE__ */ React60.createElement(ErrorContainer, null, "Error al cargar los datos del dashboard")));
  }
  if (metrics.totalShipments === 0) {
    return /* @__PURE__ */ React60.createElement(DashboardWrapper, null, /* @__PURE__ */ React60.createElement(DashboardContainer, null, /* @__PURE__ */ React60.createElement(NoDataContainer, null, /* @__PURE__ */ React60.createElement(TextComponent17, { style: { fontSize: "18px", fontWeight: "bold" } }, "No hay datos disponibles"), /* @__PURE__ */ React60.createElement(TextComponent17, null, "No se encontraron env\xEDos para el per\xEDodo seleccionado."), /* @__PURE__ */ React60.createElement(TextComponent17, { style: { fontSize: "14px", color: "var(--grey500)" } }, "Per\xEDodo: ", metrics.dateRange), /* @__PURE__ */ React60.createElement(TextComponent17, { style: { fontSize: "14px", color: "var(--grey500)" } }, "Intenta seleccionar una fecha diferente o contacta al administrador."))));
  }
  return /* @__PURE__ */ React60.createElement(DashboardWrapper, null, /* @__PURE__ */ React60.createElement(DateRangeInfo, null, "Mostrando datos del per\xEDodo: ", metrics.dateRange, " (", metrics.totalShipments, " env\xEDos totales)"), /* @__PURE__ */ React60.createElement(DashboardContainer, null, /* @__PURE__ */ React60.createElement(TallCard, null, /* @__PURE__ */ React60.createElement(PremiumCardWithTitle, null, /* @__PURE__ */ React60.createElement(PremiumCardTitle, null, "Env\xEDos"), /* @__PURE__ */ React60.createElement(PremiumGraph, null, /* @__PURE__ */ React60.createElement(DonutChart, { data: metrics.shipments })), /* @__PURE__ */ React60.createElement(PremiumList, null, metrics.shipments.map((shipment) => /* @__PURE__ */ React60.createElement(PremiumListItem, { key: shipment.state }, /* @__PURE__ */ React60.createElement(PremiumListItemText, null, /* @__PURE__ */ React60.createElement(
    PremiumListItemBox,
    {
      style: {
        backgroundColor: shipment.color || ShipmentsStateService.getShipmentStateColor(shipment.state)
      }
    }
  ), /* @__PURE__ */ React60.createElement(TextComponent17, null, ShipmentsStateService.getShipmentStateText(shipment.state))), /* @__PURE__ */ React60.createElement(TextComponent17, null, shipment.count)))))), /* @__PURE__ */ React60.createElement(TopCardsContainer, null, /* @__PURE__ */ React60.createElement(TopCard, null, /* @__PURE__ */ React60.createElement(PremiumCardWithTitle, null, /* @__PURE__ */ React60.createElement(PremiumCardTitle, null, "Incidencias"), /* @__PURE__ */ React60.createElement(PremiumGraph, null, /* @__PURE__ */ React60.createElement(DonutChart, { centerText: "incidencias", data: metrics.incidents })), /* @__PURE__ */ React60.createElement(PremiumList, null, metrics.incidents.map((incident) => /* @__PURE__ */ React60.createElement(PremiumListItem, { key: incident.state }, /* @__PURE__ */ React60.createElement(PremiumListItemText, null, /* @__PURE__ */ React60.createElement(
    PremiumListItemBox,
    {
      style: {
        backgroundColor: incident.color
      }
    }
  ), /* @__PURE__ */ React60.createElement(TextComponent17, null, incident.state)), /* @__PURE__ */ React60.createElement(TextComponent17, null, incident.count)))))), /* @__PURE__ */ React60.createElement(TopCard, null, /* @__PURE__ */ React60.createElement(PremiumCardWithTitle, null, /* @__PURE__ */ React60.createElement(PremiumCardTitle, null, "Objetivos del d\xEDa"), /* @__PURE__ */ React60.createElement(PremiumGraph, null, /* @__PURE__ */ React60.createElement(HalfCircleChart, { data: metrics.objectives })), /* @__PURE__ */ React60.createElement(PremiumList, null, metrics.objectives.slice(0, 2).map((objective) => /* @__PURE__ */ React60.createElement(PremiumListItem, { key: objective.state }, /* @__PURE__ */ React60.createElement(PremiumListItemText, null, /* @__PURE__ */ React60.createElement(
    PremiumListItemBox,
    {
      style: {
        backgroundColor: objective.color
      }
    }
  ), /* @__PURE__ */ React60.createElement(TextComponent17, null, objective.state)), /* @__PURE__ */ React60.createElement(TextComponent17, null, objective.count, "%"))))))), /* @__PURE__ */ React60.createElement(BottomSection, null, /* @__PURE__ */ React60.createElement(FlexComponent22, { height: "40px" }, /* @__PURE__ */ React60.createElement(
    TextComponent17,
    {
      style: {
        width: "100%",
        textAlign: "center",
        marginLeft: "auto",
        marginRight: "auto",
        justifyContent: "center"
      }
    },
    "Nivel de entrega por tipo de servicio"
  )), /* @__PURE__ */ React60.createElement(SmallCardsRow, null, /* @__PURE__ */ React60.createElement(SmallCard, null, /* @__PURE__ */ React60.createElement(PremiumKpiContainer, null, /* @__PURE__ */ React60.createElement(PremiumKPITitle, null, metrics.deliveryLevel24h, "%"), /* @__PURE__ */ React60.createElement(PremiumKPIText, null, "24 horas"), /* @__PURE__ */ React60.createElement(PremiumKPIBar, { percentage: metrics.deliveryLevel24h }))), /* @__PURE__ */ React60.createElement(SmallCard, null, /* @__PURE__ */ React60.createElement(PremiumKpiContainer, null, /* @__PURE__ */ React60.createElement(PremiumKPITitle, null, metrics.deliveryLevel48h, "%"), /* @__PURE__ */ React60.createElement(PremiumKPIText, null, "48 horas"), /* @__PURE__ */ React60.createElement(PremiumKPIBar, { percentage: metrics.deliveryLevel48h })))))));
}

// src/pages/dashboard/dashboard-page.tsx
function DashboardPage() {
  const getDefaultDateRange = () => {
    const today = /* @__PURE__ */ new Date();
    const thirtyDaysAgo = /* @__PURE__ */ new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);
    return {
      from: thirtyDaysAgo.toISOString().split("T")[0],
      to: today.toISOString().split("T")[0]
    };
  };
  const defaultRange = getDefaultDateRange();
  const [dateFrom, setDateFrom] = useState13(defaultRange.from);
  const [dateTo, setDateTo] = useState13(defaultRange.to);
  const [topBarModuleMyDelegationNode, setTopBarModuleMyDelegationNode] = useState13(
    null
  );
  useEffect7(() => {
    if (topBarModuleMyDelegationNode) {
      return;
    }
    const node = document.getElementById(TOP_BAR_MODULE_MY_DELEGATION_ID);
    if (!node) {
      console.error(`Node with id ${TOP_BAR_MODULE_MY_DELEGATION_ID} not found`);
      return;
    }
    setTopBarModuleMyDelegationNode(node);
  }, [topBarModuleMyDelegationNode, setTopBarModuleMyDelegationNode]);
  return /* @__PURE__ */ React61.createElement(PageLayout6, null, topBarModuleMyDelegationNode ? createPortal3(/* @__PURE__ */ React61.createElement(MyDelegationComponent, null), topBarModuleMyDelegationNode) : null, /* @__PURE__ */ React61.createElement(CustomToolbarComponent, null, /* @__PURE__ */ React61.createElement(CustomToolbarContentComponent, null, /* @__PURE__ */ React61.createElement(ResponsiveInputsContainerComponent, null, /* @__PURE__ */ React61.createElement(FiltersContainerComponent, null, /* @__PURE__ */ React61.createElement(
    Input11,
    {
      handleChangeValue: (name, value) => {
        if (!value) {
          setDateFrom("");
          return;
        }
        const newDate = new Date(value);
        const newDateNormalized = new Date(newDate.setHours(0, 0, 0, 0));
        const newDateFrom = getDateStringFromJavascriptDate(newDateNormalized);
        setDateFrom(newDateFrom);
      },
      label: "Fecha desde",
      name: "date-created-at-from",
      type: "date",
      value: dateFrom,
      width: FILTERS_CONFIG.CREATED_AT_DATE_FROM.width
    }
  ), /* @__PURE__ */ React61.createElement(
    Input11,
    {
      handleChangeValue: (name, value) => {
        if (!value) {
          setDateTo("");
          return;
        }
        const newDate = new Date(value);
        const newDateNormalized = new Date(newDate.setHours(0, 0, 0, 0));
        const newDateTo = getDateStringFromJavascriptDate(newDateNormalized);
        setDateTo(newDateTo);
      },
      label: "Fecha hasta",
      name: "date-created-at-to",
      type: "date",
      value: dateTo,
      width: FILTERS_CONFIG.CREATED_AT_DATE_FROM.width
    }
  ))))), /* @__PURE__ */ React61.createElement(PageContent6, null, /* @__PURE__ */ React61.createElement(DashboardComponent, { dateFrom, dateTo })));
}

// src/config/config-provider.tsx
import React62 from "react";
function ConfigProvider({
  token,
  apiBase,
  userDelegations,
  children
}) {
  return /* @__PURE__ */ React62.createElement(
    ConfigContext.Provider,
    {
      value: {
        apiBase,
        token,
        userDelegations
      }
    },
    children
  );
}

// src/components/spinner/spinner-component.tsx
import React63, { useEffect as useEffect8, useState as useState14 } from "react";
import styled22, { keyframes } from "styled-components";
import { FlexComponent as FlexComponent23 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent4 } from "@ontruck/fe-icons";
var SPINNER_COLOR_IN_HEXADECIMAL = "#1d2938";
var SpinnerWrapperComponent = styled22(FlexComponent23)`
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: var(--otk-theme-color-midnight-express-800, #1d2838);
  transition: opacity 1.5s ease;

  opacity: ${({ isVisible }) => {
  if (!isVisible) {
    return `0`;
  }
  return "1";
}};

  @starting-style {
    opacity: 1;
  }

  svg {
    width: 50px;
    height: 50px;
  }
`;
var rotate = keyframes`
  from {
      transform: rotate(0);
    }
    to{
      transform: rotate(359deg);
    }
`;
var SpinnerContainerComponent = styled22(FlexComponent23)`
  position: relative;
`;
var SpinnerCircleBorderComponent = styled22.div`
  width: 160px;
  height: 160px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: ${SPINNER_COLOR_IN_HEXADECIMAL};
  background: linear-gradient(
    90deg,
    rgba(29, 41, 56, 1) 0%,
    rgba(9, 9, 121, 1) 24%,
    rgba(11, 37, 161, 1) 53%,
    #0037b6 100%
  );
  animation: ${rotate} 1s linear 0s infinite;
`;
var SpinnerCircleCoreComponent = styled22.div`
  width: 100%;
  height: 100%;
  background-color: var(--otk-theme-color-midnight-express-800, #1d2838);
  border-radius: 50%;
`;
var SpinnerLogoComponent = styled22(FlexComponent23)`
  position: absolute;
  top: 60px;
  left: 60px;
`;
function SpinnerComponent({
  timeInMilliseconds,
  isLoading
}) {
  const [isVisible, setIsVisible] = useState14(isLoading || true);
  useEffect8(() => {
    if (!timeInMilliseconds) {
      return;
    }
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, timeInMilliseconds);
    return () => {
      clearTimeout(timer);
    };
  }, [isLoading, timeInMilliseconds, isVisible]);
  return /* @__PURE__ */ React63.createElement(SpinnerWrapperComponent, { isVisible }, /* @__PURE__ */ React63.createElement(SpinnerContainerComponent, null, /* @__PURE__ */ React63.createElement(SpinnerCircleBorderComponent, null, /* @__PURE__ */ React63.createElement(SpinnerCircleCoreComponent, null)), /* @__PURE__ */ React63.createElement(SpinnerLogoComponent, null, /* @__PURE__ */ React63.createElement(IconComponent4, { color: "white", name: "van", sizeInPixels: 5 }))));
}
export {
  ConfigProvider,
  DashboardPage,
  IncidentsListPage,
  MyDelegationComponent,
  SpinnerComponent as OntimeSpinnerComponent,
  ShipmentDetailPage,
  ShipmentsListPage,
  SmartViewsListPage,
  SmartViewsNewPage,
  TOP_BAR_MODULE_MY_DELEGATION_ID
};
